
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire43c3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire43c3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hi5z5", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c9686f2ae6fd93b8$export$ffb0004e005737fa; }, function (v) { return $c9686f2ae6fd93b8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b; }, function (v) { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $c9686f2ae6fd93b8$export$25062201e9e25d76; }, function (v) { return $c9686f2ae6fd93b8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9686f2ae6fd93b8$export$ffb0004e005737fa;
var $c9686f2ae6fd93b8$export$34b9dba7ce09269b;
var $c9686f2ae6fd93b8$export$25062201e9e25d76;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
var $c9686f2ae6fd93b8$var$k = Symbol.for("react.element"), $c9686f2ae6fd93b8$var$l = Symbol.for("react.fragment"), $c9686f2ae6fd93b8$var$m = Object.prototype.hasOwnProperty, $c9686f2ae6fd93b8$var$n = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c9686f2ae6fd93b8$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c9686f2ae6fd93b8$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c9686f2ae6fd93b8$var$m.call(a, b) && !$c9686f2ae6fd93b8$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c9686f2ae6fd93b8$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c9686f2ae6fd93b8$var$n.current
    };
}
$c9686f2ae6fd93b8$export$ffb0004e005737fa = $c9686f2ae6fd93b8$var$l;
$c9686f2ae6fd93b8$export$34b9dba7ce09269b = $c9686f2ae6fd93b8$var$q;
$c9686f2ae6fd93b8$export$25062201e9e25d76 = $c9686f2ae6fd93b8$var$q;

});
parcelRegister("4Iuzv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ip19S"));

});
parcelRegister("ip19S", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954; }, function (v) { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8; }, function (v) { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d65b75cac4e2d5f6$export$ffb0004e005737fa; }, function (v) { return $d65b75cac4e2d5f6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d65b75cac4e2d5f6$export$e2c29f18771995cb; }, function (v) { return $d65b75cac4e2d5f6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd; }, function (v) { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d65b75cac4e2d5f6$export$5f8d39834fd61797; }, function (v) { return $d65b75cac4e2d5f6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5; }, function (v) { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d65b75cac4e2d5f6$export$ae55be85d98224ed; }, function (v) { return $d65b75cac4e2d5f6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d65b75cac4e2d5f6$export$e530037191fcd5d7; }, function (v) { return $d65b75cac4e2d5f6$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109; }, function (v) { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d; }, function (v) { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9; }, function (v) { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43; }, function (v) { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d65b75cac4e2d5f6$export$257a8862b851cb5b; }, function (v) { return $d65b75cac4e2d5f6$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d65b75cac4e2d5f6$export$a8257692ac88316c; }, function (v) { return $d65b75cac4e2d5f6$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d65b75cac4e2d5f6$export$488013bae63b21da; }, function (v) { return $d65b75cac4e2d5f6$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d65b75cac4e2d5f6$export$7c73462e0d25e514; }, function (v) { return $d65b75cac4e2d5f6$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d65b75cac4e2d5f6$export$7568632d0d33d16d; }, function (v) { return $d65b75cac4e2d5f6$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $d65b75cac4e2d5f6$export$88948ce120ea2619; }, function (v) { return $d65b75cac4e2d5f6$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d65b75cac4e2d5f6$export$35808ee640e87ca7; }, function (v) { return $d65b75cac4e2d5f6$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d65b75cac4e2d5f6$export$fae74005e78b1a27; }, function (v) { return $d65b75cac4e2d5f6$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e; }, function (v) { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf; }, function (v) { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591; }, function (v) { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $d65b75cac4e2d5f6$export$f680877a34711e37; }, function (v) { return $d65b75cac4e2d5f6$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2; }, function (v) { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969; }, function (v) { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c; }, function (v) { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d65b75cac4e2d5f6$export$1538c33de8887b59; }, function (v) { return $d65b75cac4e2d5f6$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $d65b75cac4e2d5f6$export$13e3392192263954; }, function (v) { return $d65b75cac4e2d5f6$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca; }, function (v) { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d65b75cac4e2d5f6$export$60241385465d0a34; }, function (v) { return $d65b75cac4e2d5f6$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16; }, function (v) { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf; }, function (v) { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d65b75cac4e2d5f6$export$83d89fbfd8236492; }, function (v) { return $d65b75cac4e2d5f6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d65b75cac4e2d5f6$export$dca3b0875bd9a954;
var $d65b75cac4e2d5f6$export$16fa2f45be04daa8;
var $d65b75cac4e2d5f6$export$ffb0004e005737fa;
var $d65b75cac4e2d5f6$export$e2c29f18771995cb;
var $d65b75cac4e2d5f6$export$221d75b3f55bb0bd;
var $d65b75cac4e2d5f6$export$5f8d39834fd61797;
var $d65b75cac4e2d5f6$export$74bf444e3cd11ea5;
var $d65b75cac4e2d5f6$export$ae55be85d98224ed;
var $d65b75cac4e2d5f6$export$e530037191fcd5d7;
var $d65b75cac4e2d5f6$export$fd42f52fd3ae1109;
var $d65b75cac4e2d5f6$export$c8a8987d4410bf2d;
var $d65b75cac4e2d5f6$export$d38cd72104c1f0e9;
var $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43;
var $d65b75cac4e2d5f6$export$257a8862b851cb5b;
var $d65b75cac4e2d5f6$export$a8257692ac88316c;
var $d65b75cac4e2d5f6$export$488013bae63b21da;
var $d65b75cac4e2d5f6$export$7c73462e0d25e514;
var $d65b75cac4e2d5f6$export$7568632d0d33d16d;
var $d65b75cac4e2d5f6$export$88948ce120ea2619;
var $d65b75cac4e2d5f6$export$35808ee640e87ca7;
var $d65b75cac4e2d5f6$export$fae74005e78b1a27;
var $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e;
var $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf;
var $d65b75cac4e2d5f6$export$6d9c69b0de29b591;
var $d65b75cac4e2d5f6$export$f680877a34711e37;
var $d65b75cac4e2d5f6$export$d5a552a76deda3c2;
var $d65b75cac4e2d5f6$export$aaabe4eda9ed9969;
var $d65b75cac4e2d5f6$export$e5c5a5f917a5871c;
var $d65b75cac4e2d5f6$export$1538c33de8887b59;
var $d65b75cac4e2d5f6$export$13e3392192263954;
var $d65b75cac4e2d5f6$export$b8f5890fc79d6aca;
var $d65b75cac4e2d5f6$export$60241385465d0a34;
var $d65b75cac4e2d5f6$export$306c0aa65ff9ec16;
var $d65b75cac4e2d5f6$export$7b286972b8d8ccbf;
var $d65b75cac4e2d5f6$export$83d89fbfd8236492;
"use strict";
var $d65b75cac4e2d5f6$var$l = Symbol.for("react.element"), $d65b75cac4e2d5f6$var$n = Symbol.for("react.portal"), $d65b75cac4e2d5f6$var$p = Symbol.for("react.fragment"), $d65b75cac4e2d5f6$var$q = Symbol.for("react.strict_mode"), $d65b75cac4e2d5f6$var$r = Symbol.for("react.profiler"), $d65b75cac4e2d5f6$var$t = Symbol.for("react.provider"), $d65b75cac4e2d5f6$var$u = Symbol.for("react.context"), $d65b75cac4e2d5f6$var$v = Symbol.for("react.forward_ref"), $d65b75cac4e2d5f6$var$w = Symbol.for("react.suspense"), $d65b75cac4e2d5f6$var$x = Symbol.for("react.memo"), $d65b75cac4e2d5f6$var$y = Symbol.for("react.lazy"), $d65b75cac4e2d5f6$var$z = Symbol.iterator;
function $d65b75cac4e2d5f6$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d65b75cac4e2d5f6$var$z && a[$d65b75cac4e2d5f6$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d65b75cac4e2d5f6$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d65b75cac4e2d5f6$var$C = Object.assign, $d65b75cac4e2d5f6$var$D = {};
function $d65b75cac4e2d5f6$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
$d65b75cac4e2d5f6$var$E.prototype.isReactComponent = {};
$d65b75cac4e2d5f6$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$d65b75cac4e2d5f6$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $d65b75cac4e2d5f6$var$F() {}
$d65b75cac4e2d5f6$var$F.prototype = $d65b75cac4e2d5f6$var$E.prototype;
function $d65b75cac4e2d5f6$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
var $d65b75cac4e2d5f6$var$H = $d65b75cac4e2d5f6$var$G.prototype = new $d65b75cac4e2d5f6$var$F;
$d65b75cac4e2d5f6$var$H.constructor = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$var$C($d65b75cac4e2d5f6$var$H, $d65b75cac4e2d5f6$var$E.prototype);
$d65b75cac4e2d5f6$var$H.isPureReactComponent = !0;
var $d65b75cac4e2d5f6$var$I = Array.isArray, $d65b75cac4e2d5f6$var$J = Object.prototype.hasOwnProperty, $d65b75cac4e2d5f6$var$K = {
    current: null
}, $d65b75cac4e2d5f6$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d65b75cac4e2d5f6$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$d65b75cac4e2d5f6$var$J.call(b, d) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $d65b75cac4e2d5f6$var$K.current
    };
}
function $d65b75cac4e2d5f6$var$N(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $d65b75cac4e2d5f6$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d65b75cac4e2d5f6$var$l;
}
function $d65b75cac4e2d5f6$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $d65b75cac4e2d5f6$var$P = /\/+/g;
function $d65b75cac4e2d5f6$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $d65b75cac4e2d5f6$var$escape("" + a.key) : b.toString(36);
}
function $d65b75cac4e2d5f6$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $d65b75cac4e2d5f6$var$l:
                case $d65b75cac4e2d5f6$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $d65b75cac4e2d5f6$var$Q(h, 0) : d, $d65b75cac4e2d5f6$var$I(c) ? (e = "", null != a && (e = a.replace($d65b75cac4e2d5f6$var$P, "$&/") + "/"), $d65b75cac4e2d5f6$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($d65b75cac4e2d5f6$var$O(c) && (c = $d65b75cac4e2d5f6$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($d65b75cac4e2d5f6$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($d65b75cac4e2d5f6$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $d65b75cac4e2d5f6$var$Q(k, g);
        h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    }
    else if (f = $d65b75cac4e2d5f6$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $d65b75cac4e2d5f6$var$Q(k, g++), h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $d65b75cac4e2d5f6$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $d65b75cac4e2d5f6$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $d65b75cac4e2d5f6$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $d65b75cac4e2d5f6$var$U = {
    current: null
}, $d65b75cac4e2d5f6$var$V = {
    transition: null
}, $d65b75cac4e2d5f6$var$W = {
    ReactCurrentDispatcher: $d65b75cac4e2d5f6$var$U,
    ReactCurrentBatchConfig: $d65b75cac4e2d5f6$var$V,
    ReactCurrentOwner: $d65b75cac4e2d5f6$var$K
};
$d65b75cac4e2d5f6$export$dca3b0875bd9a954 = {
    map: $d65b75cac4e2d5f6$var$S,
    forEach: function(a, b, e) {
        $d65b75cac4e2d5f6$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $d65b75cac4e2d5f6$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $d65b75cac4e2d5f6$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$d65b75cac4e2d5f6$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$d65b75cac4e2d5f6$export$16fa2f45be04daa8 = $d65b75cac4e2d5f6$var$E;
$d65b75cac4e2d5f6$export$ffb0004e005737fa = $d65b75cac4e2d5f6$var$p;
$d65b75cac4e2d5f6$export$e2c29f18771995cb = $d65b75cac4e2d5f6$var$r;
$d65b75cac4e2d5f6$export$221d75b3f55bb0bd = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$export$5f8d39834fd61797 = $d65b75cac4e2d5f6$var$q;
$d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = $d65b75cac4e2d5f6$var$w;
$d65b75cac4e2d5f6$export$ae55be85d98224ed = $d65b75cac4e2d5f6$var$W;
$d65b75cac4e2d5f6$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $d65b75cac4e2d5f6$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $d65b75cac4e2d5f6$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$d65b75cac4e2d5f6$var$J.call(b, f) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $d65b75cac4e2d5f6$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $d65b75cac4e2d5f6$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$d65b75cac4e2d5f6$export$c8a8987d4410bf2d = $d65b75cac4e2d5f6$var$M;
$d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = function(a) {
    var b = $d65b75cac4e2d5f6$var$M.bind(null, a);
    b.type = a;
    return b;
};
$d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d65b75cac4e2d5f6$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$v,
        render: a
    };
};
$d65b75cac4e2d5f6$export$a8257692ac88316c = $d65b75cac4e2d5f6$var$O;
$d65b75cac4e2d5f6$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $d65b75cac4e2d5f6$var$T
    };
};
$d65b75cac4e2d5f6$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$d65b75cac4e2d5f6$export$7568632d0d33d16d = function(a) {
    var b = $d65b75cac4e2d5f6$var$V.transition;
    $d65b75cac4e2d5f6$var$V.transition = {};
    try {
        a();
    } finally{
        $d65b75cac4e2d5f6$var$V.transition = b;
    }
};
$d65b75cac4e2d5f6$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$d65b75cac4e2d5f6$export$35808ee640e87ca7 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useCallback(a, b);
};
$d65b75cac4e2d5f6$export$fae74005e78b1a27 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useContext(a);
};
$d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = function() {};
$d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useDeferredValue(a);
};
$d65b75cac4e2d5f6$export$6d9c69b0de29b591 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useEffect(a, b);
};
$d65b75cac4e2d5f6$export$f680877a34711e37 = function() {
    return $d65b75cac4e2d5f6$var$U.current.useId();
};
$d65b75cac4e2d5f6$export$d5a552a76deda3c2 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useImperativeHandle(a, b, e);
};
$d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useInsertionEffect(a, b);
};
$d65b75cac4e2d5f6$export$e5c5a5f917a5871c = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useLayoutEffect(a, b);
};
$d65b75cac4e2d5f6$export$1538c33de8887b59 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useMemo(a, b);
};
$d65b75cac4e2d5f6$export$13e3392192263954 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useReducer(a, b, e);
};
$d65b75cac4e2d5f6$export$b8f5890fc79d6aca = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useRef(a);
};
$d65b75cac4e2d5f6$export$60241385465d0a34 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useState(a);
};
$d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useSyncExternalStore(a, b, e);
};
$d65b75cac4e2d5f6$export$7b286972b8d8ccbf = function() {
    return $d65b75cac4e2d5f6$var$U.current.useTransition();
};
$d65b75cac4e2d5f6$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("68oCn", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $477696120c5741dc$export$ae55be85d98224ed; }, function (v) { return $477696120c5741dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $477696120c5741dc$export$d39a5bbd09211389; }, function (v) { return $477696120c5741dc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $477696120c5741dc$export$882461b6382ed46c; }, function (v) { return $477696120c5741dc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $477696120c5741dc$export$466bfc07425424d5; }, function (v) { return $477696120c5741dc$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $477696120c5741dc$export$cd75ccfd720a3cd4; }, function (v) { return $477696120c5741dc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $477696120c5741dc$export$fa8d919ba61d84db; }, function (v) { return $477696120c5741dc$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $477696120c5741dc$export$757ceba2d55c277e; }, function (v) { return $477696120c5741dc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $477696120c5741dc$export$b3890eb0ae9dca99; }, function (v) { return $477696120c5741dc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $477696120c5741dc$export$502457920280e6be; }, function (v) { return $477696120c5741dc$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $477696120c5741dc$export$c78a37762a8d58e1; }, function (v) { return $477696120c5741dc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $477696120c5741dc$export$dc54d992c10e8a18; }, function (v) { return $477696120c5741dc$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $477696120c5741dc$export$83d89fbfd8236492; }, function (v) { return $477696120c5741dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $477696120c5741dc$export$ae55be85d98224ed;
var $477696120c5741dc$export$d39a5bbd09211389;
var $477696120c5741dc$export$882461b6382ed46c;
var $477696120c5741dc$export$466bfc07425424d5;
var $477696120c5741dc$export$cd75ccfd720a3cd4;
var $477696120c5741dc$export$fa8d919ba61d84db;
var $477696120c5741dc$export$757ceba2d55c277e;
var $477696120c5741dc$export$b3890eb0ae9dca99;
var $477696120c5741dc$export$502457920280e6be;
var $477696120c5741dc$export$c78a37762a8d58e1;
var $477696120c5741dc$export$dc54d992c10e8a18;
var $477696120c5741dc$export$83d89fbfd8236492;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");

var $1c3ne = parcelRequire("1c3ne");
function $477696120c5741dc$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $477696120c5741dc$var$da = new Set, $477696120c5741dc$var$ea = {};
function $477696120c5741dc$var$fa(a, b) {
    $477696120c5741dc$var$ha(a, b);
    $477696120c5741dc$var$ha(a + "Capture", b);
}
function $477696120c5741dc$var$ha(a, b) {
    $477696120c5741dc$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$477696120c5741dc$var$da.add(b[a]);
}
var $477696120c5741dc$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $477696120c5741dc$var$ja = Object.prototype.hasOwnProperty, $477696120c5741dc$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $477696120c5741dc$var$la = {}, $477696120c5741dc$var$ma = {};
function $477696120c5741dc$var$oa(a) {
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$ma, a)) return !0;
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$la, a)) return !1;
    if ($477696120c5741dc$var$ka.test(a)) return $477696120c5741dc$var$ma[a] = !0;
    $477696120c5741dc$var$la[a] = !0;
    return !1;
}
function $477696120c5741dc$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $477696120c5741dc$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $477696120c5741dc$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $477696120c5741dc$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $477696120c5741dc$var$ra = /[\-:]([a-z])/g;
function $477696120c5741dc$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$477696120c5741dc$var$z.xlinkHref = new $477696120c5741dc$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $477696120c5741dc$var$ta(a, b, c, d) {
    var e = $477696120c5741dc$var$z.hasOwnProperty(b) ? $477696120c5741dc$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $477696120c5741dc$var$qa(b, c, e, d) && (c = null), d || null === e ? $477696120c5741dc$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $477696120c5741dc$var$ua = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $477696120c5741dc$var$va = Symbol.for("react.element"), $477696120c5741dc$var$wa = Symbol.for("react.portal"), $477696120c5741dc$var$ya = Symbol.for("react.fragment"), $477696120c5741dc$var$za = Symbol.for("react.strict_mode"), $477696120c5741dc$var$Aa = Symbol.for("react.profiler"), $477696120c5741dc$var$Ba = Symbol.for("react.provider"), $477696120c5741dc$var$Ca = Symbol.for("react.context"), $477696120c5741dc$var$Da = Symbol.for("react.forward_ref"), $477696120c5741dc$var$Ea = Symbol.for("react.suspense"), $477696120c5741dc$var$Fa = Symbol.for("react.suspense_list"), $477696120c5741dc$var$Ga = Symbol.for("react.memo"), $477696120c5741dc$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $477696120c5741dc$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $477696120c5741dc$var$Ja = Symbol.iterator;
function $477696120c5741dc$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $477696120c5741dc$var$Ja && a[$477696120c5741dc$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $477696120c5741dc$var$A = Object.assign, $477696120c5741dc$var$La;
function $477696120c5741dc$var$Ma(a) {
    if (void 0 === $477696120c5741dc$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $477696120c5741dc$var$La = b && b[1] || "";
    }
    return "\n" + $477696120c5741dc$var$La + a;
}
var $477696120c5741dc$var$Na = !1;
function $477696120c5741dc$var$Oa(a, b) {
    if (!a || $477696120c5741dc$var$Na) return "";
    $477696120c5741dc$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $477696120c5741dc$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $477696120c5741dc$var$Ma(a) : "";
}
function $477696120c5741dc$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $477696120c5741dc$var$Ma(a.type);
        case 16:
            return $477696120c5741dc$var$Ma("Lazy");
        case 13:
            return $477696120c5741dc$var$Ma("Suspense");
        case 19:
            return $477696120c5741dc$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $477696120c5741dc$var$Oa(a.type, !1), a;
        case 11:
            return a = $477696120c5741dc$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $477696120c5741dc$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $477696120c5741dc$var$ya:
            return "Fragment";
        case $477696120c5741dc$var$wa:
            return "Portal";
        case $477696120c5741dc$var$Aa:
            return "Profiler";
        case $477696120c5741dc$var$za:
            return "StrictMode";
        case $477696120c5741dc$var$Ea:
            return "Suspense";
        case $477696120c5741dc$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $477696120c5741dc$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $477696120c5741dc$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $477696120c5741dc$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $477696120c5741dc$var$Ga:
            return b = a.displayName || null, null !== b ? b : $477696120c5741dc$var$Qa(a.type) || "Memo";
        case $477696120c5741dc$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $477696120c5741dc$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $477696120c5741dc$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $477696120c5741dc$var$Qa(b);
        case 8:
            return b === $477696120c5741dc$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $477696120c5741dc$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $477696120c5741dc$var$Ua(a) {
    var b = $477696120c5741dc$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $477696120c5741dc$var$Va(a) {
    a._valueTracker || (a._valueTracker = $477696120c5741dc$var$Ua(a));
}
function $477696120c5741dc$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $477696120c5741dc$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $477696120c5741dc$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $477696120c5741dc$var$Ya(a, b) {
    var c = b.checked;
    return $477696120c5741dc$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $477696120c5741dc$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $477696120c5741dc$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $477696120c5741dc$var$ab(a, b) {
    b = b.checked;
    null != b && $477696120c5741dc$var$ta(a, "checked", b, !1);
}
function $477696120c5741dc$var$bb(a, b) {
    $477696120c5741dc$var$ab(a, b);
    var c = $477696120c5741dc$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $477696120c5741dc$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $477696120c5741dc$var$cb(a, b.type, $477696120c5741dc$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $477696120c5741dc$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $477696120c5741dc$var$cb(a, b, c) {
    if ("number" !== b || $477696120c5741dc$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $477696120c5741dc$var$eb = Array.isArray;
function $477696120c5741dc$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $477696120c5741dc$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $477696120c5741dc$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($477696120c5741dc$var$p(91));
    return $477696120c5741dc$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $477696120c5741dc$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($477696120c5741dc$var$p(92));
            if ($477696120c5741dc$var$eb(c)) {
                if (1 < c.length) throw Error($477696120c5741dc$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $477696120c5741dc$var$Sa(c)
    };
}
function $477696120c5741dc$var$ib(a, b) {
    var c = $477696120c5741dc$var$Sa(b.value), d = $477696120c5741dc$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $477696120c5741dc$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $477696120c5741dc$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $477696120c5741dc$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $477696120c5741dc$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $477696120c5741dc$var$mb, $477696120c5741dc$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $477696120c5741dc$var$mb = $477696120c5741dc$var$mb || document.createElement("div");
        $477696120c5741dc$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $477696120c5741dc$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $477696120c5741dc$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $477696120c5741dc$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $477696120c5741dc$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($477696120c5741dc$var$pb).forEach(function(a) {
    $477696120c5741dc$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $477696120c5741dc$var$pb[b] = $477696120c5741dc$var$pb[a];
    });
});
function $477696120c5741dc$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $477696120c5741dc$var$pb.hasOwnProperty(a) && $477696120c5741dc$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $477696120c5741dc$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $477696120c5741dc$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $477696120c5741dc$var$tb = $477696120c5741dc$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $477696120c5741dc$var$ub(a, b) {
    if (b) {
        if ($477696120c5741dc$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($477696120c5741dc$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($477696120c5741dc$var$p(62));
    }
}
function $477696120c5741dc$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $477696120c5741dc$var$wb = null;
function $477696120c5741dc$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $477696120c5741dc$var$yb = null, $477696120c5741dc$var$zb = null, $477696120c5741dc$var$Ab = null;
function $477696120c5741dc$var$Bb(a) {
    if (a = $477696120c5741dc$var$Cb(a)) {
        if ("function" !== typeof $477696120c5741dc$var$yb) throw Error($477696120c5741dc$var$p(280));
        var b = a.stateNode;
        b && (b = $477696120c5741dc$var$Db(b), $477696120c5741dc$var$yb(a.stateNode, a.type, b));
    }
}
function $477696120c5741dc$var$Eb(a) {
    $477696120c5741dc$var$zb ? $477696120c5741dc$var$Ab ? $477696120c5741dc$var$Ab.push(a) : $477696120c5741dc$var$Ab = [
        a
    ] : $477696120c5741dc$var$zb = a;
}
function $477696120c5741dc$var$Fb() {
    if ($477696120c5741dc$var$zb) {
        var a = $477696120c5741dc$var$zb, b = $477696120c5741dc$var$Ab;
        $477696120c5741dc$var$Ab = $477696120c5741dc$var$zb = null;
        $477696120c5741dc$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$477696120c5741dc$var$Bb(b[a]);
    }
}
function $477696120c5741dc$var$Gb(a, b) {
    return a(b);
}
function $477696120c5741dc$var$Hb() {}
var $477696120c5741dc$var$Ib = !1;
function $477696120c5741dc$var$Jb(a, b, c) {
    if ($477696120c5741dc$var$Ib) return a(b, c);
    $477696120c5741dc$var$Ib = !0;
    try {
        return $477696120c5741dc$var$Gb(a, b, c);
    } finally{
        if ($477696120c5741dc$var$Ib = !1, null !== $477696120c5741dc$var$zb || null !== $477696120c5741dc$var$Ab) $477696120c5741dc$var$Hb(), $477696120c5741dc$var$Fb();
    }
}
function $477696120c5741dc$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $477696120c5741dc$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($477696120c5741dc$var$p(231, b, typeof c));
    return c;
}
var $477696120c5741dc$var$Lb = !1;
if ($477696120c5741dc$var$ia) try {
    var $477696120c5741dc$var$Mb = {};
    Object.defineProperty($477696120c5741dc$var$Mb, "passive", {
        get: function() {
            $477696120c5741dc$var$Lb = !0;
        }
    });
    window.addEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
    window.removeEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
} catch (a) {
    $477696120c5741dc$var$Lb = !1;
}
function $477696120c5741dc$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $477696120c5741dc$var$Ob = !1, $477696120c5741dc$var$Pb = null, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, $477696120c5741dc$var$Sb = {
    onError: function(a) {
        $477696120c5741dc$var$Ob = !0;
        $477696120c5741dc$var$Pb = a;
    }
};
function $477696120c5741dc$var$Tb(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Ob = !1;
    $477696120c5741dc$var$Pb = null;
    $477696120c5741dc$var$Nb.apply($477696120c5741dc$var$Sb, arguments);
}
function $477696120c5741dc$var$Ub(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Tb.apply(this, arguments);
    if ($477696120c5741dc$var$Ob) {
        if ($477696120c5741dc$var$Ob) {
            var l = $477696120c5741dc$var$Pb;
            $477696120c5741dc$var$Ob = !1;
            $477696120c5741dc$var$Pb = null;
        } else throw Error($477696120c5741dc$var$p(198));
        $477696120c5741dc$var$Qb || ($477696120c5741dc$var$Qb = !0, $477696120c5741dc$var$Rb = l);
    }
}
function $477696120c5741dc$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $477696120c5741dc$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $477696120c5741dc$var$Xb(a) {
    if ($477696120c5741dc$var$Vb(a) !== a) throw Error($477696120c5741dc$var$p(188));
}
function $477696120c5741dc$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $477696120c5741dc$var$Vb(a);
        if (null === b) throw Error($477696120c5741dc$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $477696120c5741dc$var$Xb(e), a;
                if (f === d) return $477696120c5741dc$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($477696120c5741dc$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($477696120c5741dc$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($477696120c5741dc$var$p(190));
    }
    if (3 !== c.tag) throw Error($477696120c5741dc$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $477696120c5741dc$var$Zb(a) {
    a = $477696120c5741dc$var$Yb(a);
    return null !== a ? $477696120c5741dc$var$$b(a) : null;
}
function $477696120c5741dc$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $477696120c5741dc$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $477696120c5741dc$var$ac = $1c3ne.unstable_scheduleCallback, $477696120c5741dc$var$bc = $1c3ne.unstable_cancelCallback, $477696120c5741dc$var$cc = $1c3ne.unstable_shouldYield, $477696120c5741dc$var$dc = $1c3ne.unstable_requestPaint, $477696120c5741dc$var$B = $1c3ne.unstable_now, $477696120c5741dc$var$ec = $1c3ne.unstable_getCurrentPriorityLevel, $477696120c5741dc$var$fc = $1c3ne.unstable_ImmediatePriority, $477696120c5741dc$var$gc = $1c3ne.unstable_UserBlockingPriority, $477696120c5741dc$var$hc = $1c3ne.unstable_NormalPriority, $477696120c5741dc$var$ic = $1c3ne.unstable_LowPriority, $477696120c5741dc$var$jc = $1c3ne.unstable_IdlePriority, $477696120c5741dc$var$kc = null, $477696120c5741dc$var$lc = null;
function $477696120c5741dc$var$mc(a) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberRoot) try {
        $477696120c5741dc$var$lc.onCommitFiberRoot($477696120c5741dc$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $477696120c5741dc$var$oc = Math.clz32 ? Math.clz32 : $477696120c5741dc$var$nc, $477696120c5741dc$var$pc = Math.log, $477696120c5741dc$var$qc = Math.LN2;
function $477696120c5741dc$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($477696120c5741dc$var$pc(a) / $477696120c5741dc$var$qc | 0) | 0;
}
var $477696120c5741dc$var$rc = 64, $477696120c5741dc$var$sc = 4194304;
function $477696120c5741dc$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $477696120c5741dc$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $477696120c5741dc$var$tc(h) : (f &= g, 0 !== f && (d = $477696120c5741dc$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $477696120c5741dc$var$tc(g) : 0 !== f && (d = $477696120c5741dc$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $477696120c5741dc$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $477696120c5741dc$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $477696120c5741dc$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $477696120c5741dc$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $477696120c5741dc$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $477696120c5741dc$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $477696120c5741dc$var$yc() {
    var a = $477696120c5741dc$var$rc;
    $477696120c5741dc$var$rc <<= 1;
    0 === ($477696120c5741dc$var$rc & 4194240) && ($477696120c5741dc$var$rc = 64);
    return a;
}
function $477696120c5741dc$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $477696120c5741dc$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $477696120c5741dc$var$oc(b);
    a[b] = c;
}
function $477696120c5741dc$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $477696120c5741dc$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $477696120c5741dc$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $477696120c5741dc$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $477696120c5741dc$var$C = 0;
function $477696120c5741dc$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $477696120c5741dc$var$Ec, $477696120c5741dc$var$Fc, $477696120c5741dc$var$Gc, $477696120c5741dc$var$Hc, $477696120c5741dc$var$Ic, $477696120c5741dc$var$Jc = !1, $477696120c5741dc$var$Kc = [], $477696120c5741dc$var$Lc = null, $477696120c5741dc$var$Mc = null, $477696120c5741dc$var$Nc = null, $477696120c5741dc$var$Oc = new Map, $477696120c5741dc$var$Pc = new Map, $477696120c5741dc$var$Qc = [], $477696120c5741dc$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $477696120c5741dc$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $477696120c5741dc$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $477696120c5741dc$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $477696120c5741dc$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $477696120c5741dc$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $477696120c5741dc$var$Pc.delete(b.pointerId);
    }
}
function $477696120c5741dc$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $477696120c5741dc$var$Cb(b), null !== b && $477696120c5741dc$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $477696120c5741dc$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $477696120c5741dc$var$Lc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $477696120c5741dc$var$Mc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $477696120c5741dc$var$Nc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $477696120c5741dc$var$Oc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $477696120c5741dc$var$Pc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $477696120c5741dc$var$Vc(a) {
    var b = $477696120c5741dc$var$Wc(a.target);
    if (null !== b) {
        var c = $477696120c5741dc$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $477696120c5741dc$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $477696120c5741dc$var$Ic(a.priority, function() {
                        $477696120c5741dc$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $477696120c5741dc$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $477696120c5741dc$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $477696120c5741dc$var$wb = d;
            c.target.dispatchEvent(d);
            $477696120c5741dc$var$wb = null;
        } else return b = $477696120c5741dc$var$Cb(c), null !== b && $477696120c5741dc$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $477696120c5741dc$var$Zc(a, b, c) {
    $477696120c5741dc$var$Xc(a) && c.delete(b);
}
function $477696120c5741dc$var$$c() {
    $477696120c5741dc$var$Jc = !1;
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Lc) && ($477696120c5741dc$var$Lc = null);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Mc) && ($477696120c5741dc$var$Mc = null);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Nc) && ($477696120c5741dc$var$Nc = null);
    $477696120c5741dc$var$Oc.forEach($477696120c5741dc$var$Zc);
    $477696120c5741dc$var$Pc.forEach($477696120c5741dc$var$Zc);
}
function $477696120c5741dc$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $477696120c5741dc$var$Jc || ($477696120c5741dc$var$Jc = !0, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, $477696120c5741dc$var$$c)));
}
function $477696120c5741dc$var$bd(a) {
    function b(b) {
        return $477696120c5741dc$var$ad(b, a);
    }
    if (0 < $477696120c5741dc$var$Kc.length) {
        $477696120c5741dc$var$ad($477696120c5741dc$var$Kc[0], a);
        for(var c = 1; c < $477696120c5741dc$var$Kc.length; c++){
            var d = $477696120c5741dc$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$ad($477696120c5741dc$var$Lc, a);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$ad($477696120c5741dc$var$Mc, a);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$ad($477696120c5741dc$var$Nc, a);
    $477696120c5741dc$var$Oc.forEach(b);
    $477696120c5741dc$var$Pc.forEach(b);
    for(c = 0; c < $477696120c5741dc$var$Qc.length; c++)d = $477696120c5741dc$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $477696120c5741dc$var$Qc.length && (c = $477696120c5741dc$var$Qc[0], null === c.blockedOn);)$477696120c5741dc$var$Vc(c), null === c.blockedOn && $477696120c5741dc$var$Qc.shift();
}
var $477696120c5741dc$var$cd = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$dd = !0;
function $477696120c5741dc$var$ed(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 1, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$gd(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 4, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$fd(a, b, c, d) {
    if ($477696120c5741dc$var$dd) {
        var e = $477696120c5741dc$var$Yc(a, b, c, d);
        if (null === e) $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c), $477696120c5741dc$var$Sc(a, d);
        else if ($477696120c5741dc$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($477696120c5741dc$var$Sc(a, d), b & 4 && -1 < $477696120c5741dc$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $477696120c5741dc$var$Cb(e);
                null !== f && $477696120c5741dc$var$Ec(f);
                f = $477696120c5741dc$var$Yc(a, b, c, d);
                null === f && $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $477696120c5741dc$var$hd(a, b, d, null, c);
    }
}
var $477696120c5741dc$var$id = null;
function $477696120c5741dc$var$Yc(a, b, c, d) {
    $477696120c5741dc$var$id = null;
    a = $477696120c5741dc$var$xb(d);
    a = $477696120c5741dc$var$Wc(a);
    if (null !== a) {
        if (b = $477696120c5741dc$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $477696120c5741dc$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $477696120c5741dc$var$id = a;
    return null;
}
function $477696120c5741dc$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($477696120c5741dc$var$ec()){
                case $477696120c5741dc$var$fc:
                    return 1;
                case $477696120c5741dc$var$gc:
                    return 4;
                case $477696120c5741dc$var$hc:
                case $477696120c5741dc$var$ic:
                    return 16;
                case $477696120c5741dc$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ld = null, $477696120c5741dc$var$md = null;
function $477696120c5741dc$var$nd() {
    if ($477696120c5741dc$var$md) return $477696120c5741dc$var$md;
    var a, b = $477696120c5741dc$var$ld, c = b.length, d, e = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $477696120c5741dc$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $477696120c5741dc$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $477696120c5741dc$var$pd() {
    return !0;
}
function $477696120c5741dc$var$qd() {
    return !1;
}
function $477696120c5741dc$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $477696120c5741dc$var$pd : $477696120c5741dc$var$qd;
        this.isPropagationStopped = $477696120c5741dc$var$qd;
        return this;
    }
    $477696120c5741dc$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $477696120c5741dc$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $477696120c5741dc$var$pd);
        },
        persist: function() {},
        isPersistent: $477696120c5741dc$var$pd
    });
    return b;
}
var $477696120c5741dc$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $477696120c5741dc$var$td = $477696120c5741dc$var$rd($477696120c5741dc$var$sd), $477696120c5741dc$var$ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    view: 0,
    detail: 0
}), $477696120c5741dc$var$vd = $477696120c5741dc$var$rd($477696120c5741dc$var$ud), $477696120c5741dc$var$wd, $477696120c5741dc$var$xd, $477696120c5741dc$var$yd, $477696120c5741dc$var$Ad = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $477696120c5741dc$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $477696120c5741dc$var$yd && ($477696120c5741dc$var$yd && "mousemove" === a.type ? ($477696120c5741dc$var$wd = a.screenX - $477696120c5741dc$var$yd.screenX, $477696120c5741dc$var$xd = a.screenY - $477696120c5741dc$var$yd.screenY) : $477696120c5741dc$var$xd = $477696120c5741dc$var$wd = 0, $477696120c5741dc$var$yd = a);
        return $477696120c5741dc$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $477696120c5741dc$var$xd;
    }
}), $477696120c5741dc$var$Bd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ad), $477696120c5741dc$var$Cd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    dataTransfer: 0
}), $477696120c5741dc$var$Dd = $477696120c5741dc$var$rd($477696120c5741dc$var$Cd), $477696120c5741dc$var$Ed = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    relatedTarget: 0
}), $477696120c5741dc$var$Fd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ed), $477696120c5741dc$var$Gd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Hd = $477696120c5741dc$var$rd($477696120c5741dc$var$Gd), $477696120c5741dc$var$Id = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $477696120c5741dc$var$Jd = $477696120c5741dc$var$rd($477696120c5741dc$var$Id), $477696120c5741dc$var$Kd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    data: 0
}), $477696120c5741dc$var$Ld = $477696120c5741dc$var$rd($477696120c5741dc$var$Kd), $477696120c5741dc$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $477696120c5741dc$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $477696120c5741dc$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $477696120c5741dc$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $477696120c5741dc$var$Od[a]) ? !!b[a] : !1;
}
function $477696120c5741dc$var$zd() {
    return $477696120c5741dc$var$Pd;
}
var $477696120c5741dc$var$Qd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $477696120c5741dc$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $477696120c5741dc$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $477696120c5741dc$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $477696120c5741dc$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $477696120c5741dc$var$Rd = $477696120c5741dc$var$rd($477696120c5741dc$var$Qd), $477696120c5741dc$var$Sd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $477696120c5741dc$var$Td = $477696120c5741dc$var$rd($477696120c5741dc$var$Sd), $477696120c5741dc$var$Ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $477696120c5741dc$var$zd
}), $477696120c5741dc$var$Vd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ud), $477696120c5741dc$var$Wd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Xd = $477696120c5741dc$var$rd($477696120c5741dc$var$Wd), $477696120c5741dc$var$Yd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $477696120c5741dc$var$Zd = $477696120c5741dc$var$rd($477696120c5741dc$var$Yd), $477696120c5741dc$var$$d = [
    9,
    13,
    27,
    32
], $477696120c5741dc$var$ae = $477696120c5741dc$var$ia && "CompositionEvent" in window, $477696120c5741dc$var$be = null;
$477696120c5741dc$var$ia && "documentMode" in document && ($477696120c5741dc$var$be = document.documentMode);
var $477696120c5741dc$var$ce = $477696120c5741dc$var$ia && "TextEvent" in window && !$477696120c5741dc$var$be, $477696120c5741dc$var$de = $477696120c5741dc$var$ia && (!$477696120c5741dc$var$ae || $477696120c5741dc$var$be && 8 < $477696120c5741dc$var$be && 11 >= $477696120c5741dc$var$be), $477696120c5741dc$var$ee = String.fromCharCode(32), $477696120c5741dc$var$fe = !1;
function $477696120c5741dc$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $477696120c5741dc$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $477696120c5741dc$var$ie = !1;
function $477696120c5741dc$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $477696120c5741dc$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $477696120c5741dc$var$fe = !0;
            return $477696120c5741dc$var$ee;
        case "textInput":
            return a = b.data, a === $477696120c5741dc$var$ee && $477696120c5741dc$var$fe ? null : a;
        default:
            return null;
    }
}
function $477696120c5741dc$var$ke(a, b) {
    if ($477696120c5741dc$var$ie) return "compositionend" === a || !$477696120c5741dc$var$ae && $477696120c5741dc$var$ge(a, b) ? (a = $477696120c5741dc$var$nd(), $477696120c5741dc$var$md = $477696120c5741dc$var$ld = $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $477696120c5741dc$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $477696120c5741dc$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $477696120c5741dc$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$477696120c5741dc$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $477696120c5741dc$var$ne(a, b, c, d) {
    $477696120c5741dc$var$Eb(d);
    b = $477696120c5741dc$var$oe(b, "onChange");
    0 < b.length && (c = new $477696120c5741dc$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $477696120c5741dc$var$pe = null, $477696120c5741dc$var$qe = null;
function $477696120c5741dc$var$re(a) {
    $477696120c5741dc$var$se(a, 0);
}
function $477696120c5741dc$var$te(a) {
    var b = $477696120c5741dc$var$ue(a);
    if ($477696120c5741dc$var$Wa(b)) return a;
}
function $477696120c5741dc$var$ve(a, b) {
    if ("change" === a) return b;
}
var $477696120c5741dc$var$we = !1;
if ($477696120c5741dc$var$ia) {
    var $477696120c5741dc$var$xe;
    if ($477696120c5741dc$var$ia) {
        var $477696120c5741dc$var$ye = "oninput" in document;
        if (!$477696120c5741dc$var$ye) {
            var $477696120c5741dc$var$ze = document.createElement("div");
            $477696120c5741dc$var$ze.setAttribute("oninput", "return;");
            $477696120c5741dc$var$ye = "function" === typeof $477696120c5741dc$var$ze.oninput;
        }
        $477696120c5741dc$var$xe = $477696120c5741dc$var$ye;
    } else $477696120c5741dc$var$xe = !1;
    $477696120c5741dc$var$we = $477696120c5741dc$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $477696120c5741dc$var$Ae() {
    $477696120c5741dc$var$pe && ($477696120c5741dc$var$pe.detachEvent("onpropertychange", $477696120c5741dc$var$Be), $477696120c5741dc$var$qe = $477696120c5741dc$var$pe = null);
}
function $477696120c5741dc$var$Be(a) {
    if ("value" === a.propertyName && $477696120c5741dc$var$te($477696120c5741dc$var$qe)) {
        var b = [];
        $477696120c5741dc$var$ne(b, $477696120c5741dc$var$qe, a, $477696120c5741dc$var$xb(a));
        $477696120c5741dc$var$Jb($477696120c5741dc$var$re, b);
    }
}
function $477696120c5741dc$var$Ce(a, b, c) {
    "focusin" === a ? ($477696120c5741dc$var$Ae(), $477696120c5741dc$var$pe = b, $477696120c5741dc$var$qe = c, $477696120c5741dc$var$pe.attachEvent("onpropertychange", $477696120c5741dc$var$Be)) : "focusout" === a && $477696120c5741dc$var$Ae();
}
function $477696120c5741dc$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $477696120c5741dc$var$te($477696120c5741dc$var$qe);
}
function $477696120c5741dc$var$Ee(a, b) {
    if ("click" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $477696120c5741dc$var$He = "function" === typeof Object.is ? Object.is : $477696120c5741dc$var$Ge;
function $477696120c5741dc$var$Ie(a, b) {
    if ($477696120c5741dc$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$477696120c5741dc$var$ja.call(b, e) || !$477696120c5741dc$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $477696120c5741dc$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $477696120c5741dc$var$Ke(a, b) {
    var c = $477696120c5741dc$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $477696120c5741dc$var$Je(c);
    }
}
function $477696120c5741dc$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $477696120c5741dc$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $477696120c5741dc$var$Me() {
    for(var a = window, b = $477696120c5741dc$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $477696120c5741dc$var$Xa(a.document);
    }
    return b;
}
function $477696120c5741dc$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $477696120c5741dc$var$Oe(a) {
    var b = $477696120c5741dc$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $477696120c5741dc$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $477696120c5741dc$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $477696120c5741dc$var$Ke(c, f);
                var g = $477696120c5741dc$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $477696120c5741dc$var$Pe = $477696120c5741dc$var$ia && "documentMode" in document && 11 >= document.documentMode, $477696120c5741dc$var$Qe = null, $477696120c5741dc$var$Re = null, $477696120c5741dc$var$Se = null, $477696120c5741dc$var$Te = !1;
function $477696120c5741dc$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $477696120c5741dc$var$Te || null == $477696120c5741dc$var$Qe || $477696120c5741dc$var$Qe !== $477696120c5741dc$var$Xa(d) || (d = $477696120c5741dc$var$Qe, "selectionStart" in d && $477696120c5741dc$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $477696120c5741dc$var$Se && $477696120c5741dc$var$Ie($477696120c5741dc$var$Se, d) || ($477696120c5741dc$var$Se = d, d = $477696120c5741dc$var$oe($477696120c5741dc$var$Re, "onSelect"), 0 < d.length && (b = new $477696120c5741dc$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $477696120c5741dc$var$Qe)));
}
function $477696120c5741dc$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $477696120c5741dc$var$We = {
    animationend: $477696120c5741dc$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $477696120c5741dc$var$Ve("Animation", "AnimationIteration"),
    animationstart: $477696120c5741dc$var$Ve("Animation", "AnimationStart"),
    transitionend: $477696120c5741dc$var$Ve("Transition", "TransitionEnd")
}, $477696120c5741dc$var$Xe = {}, $477696120c5741dc$var$Ye = {};
$477696120c5741dc$var$ia && ($477696120c5741dc$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $477696120c5741dc$var$We.animationend.animation, delete $477696120c5741dc$var$We.animationiteration.animation, delete $477696120c5741dc$var$We.animationstart.animation), "TransitionEvent" in window || delete $477696120c5741dc$var$We.transitionend.transition);
function $477696120c5741dc$var$Ze(a) {
    if ($477696120c5741dc$var$Xe[a]) return $477696120c5741dc$var$Xe[a];
    if (!$477696120c5741dc$var$We[a]) return a;
    var b = $477696120c5741dc$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $477696120c5741dc$var$Ye) return $477696120c5741dc$var$Xe[a] = b[c];
    return a;
}
var $477696120c5741dc$var$$e = $477696120c5741dc$var$Ze("animationend"), $477696120c5741dc$var$af = $477696120c5741dc$var$Ze("animationiteration"), $477696120c5741dc$var$bf = $477696120c5741dc$var$Ze("animationstart"), $477696120c5741dc$var$cf = $477696120c5741dc$var$Ze("transitionend"), $477696120c5741dc$var$df = new Map, $477696120c5741dc$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $477696120c5741dc$var$ff(a, b) {
    $477696120c5741dc$var$df.set(a, b);
    $477696120c5741dc$var$fa(b, [
        a
    ]);
}
for(var $477696120c5741dc$var$gf = 0; $477696120c5741dc$var$gf < $477696120c5741dc$var$ef.length; $477696120c5741dc$var$gf++){
    var $477696120c5741dc$var$hf = $477696120c5741dc$var$ef[$477696120c5741dc$var$gf], $477696120c5741dc$var$jf = $477696120c5741dc$var$hf.toLowerCase(), $477696120c5741dc$var$kf = $477696120c5741dc$var$hf[0].toUpperCase() + $477696120c5741dc$var$hf.slice(1);
    $477696120c5741dc$var$ff($477696120c5741dc$var$jf, "on" + $477696120c5741dc$var$kf);
}
$477696120c5741dc$var$ff($477696120c5741dc$var$$e, "onAnimationEnd");
$477696120c5741dc$var$ff($477696120c5741dc$var$af, "onAnimationIteration");
$477696120c5741dc$var$ff($477696120c5741dc$var$bf, "onAnimationStart");
$477696120c5741dc$var$ff("dblclick", "onDoubleClick");
$477696120c5741dc$var$ff("focusin", "onFocus");
$477696120c5741dc$var$ff("focusout", "onBlur");
$477696120c5741dc$var$ff($477696120c5741dc$var$cf, "onTransitionEnd");
$477696120c5741dc$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$477696120c5741dc$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$477696120c5741dc$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$477696120c5741dc$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $477696120c5741dc$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $477696120c5741dc$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($477696120c5741dc$var$lf));
function $477696120c5741dc$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $477696120c5741dc$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $477696120c5741dc$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($477696120c5741dc$var$Qb) throw a = $477696120c5741dc$var$Rb, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, a;
}
function $477696120c5741dc$var$D(a, b) {
    var c = b[$477696120c5741dc$var$of];
    void 0 === c && (c = b[$477696120c5741dc$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($477696120c5741dc$var$pf(b, a, 2, !1), c.add(d));
}
function $477696120c5741dc$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $477696120c5741dc$var$pf(c, a, d, b);
}
var $477696120c5741dc$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $477696120c5741dc$var$sf(a) {
    if (!a[$477696120c5741dc$var$rf]) {
        a[$477696120c5741dc$var$rf] = !0;
        $477696120c5741dc$var$da.forEach(function(b) {
            "selectionchange" !== b && ($477696120c5741dc$var$mf.has(b) || $477696120c5741dc$var$qf(b, !1, a), $477696120c5741dc$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$477696120c5741dc$var$rf] || (b[$477696120c5741dc$var$rf] = !0, $477696120c5741dc$var$qf("selectionchange", !1, b));
    }
}
function $477696120c5741dc$var$pf(a, b, c, d) {
    switch($477696120c5741dc$var$jd(b)){
        case 1:
            var e = $477696120c5741dc$var$ed;
            break;
        case 4:
            e = $477696120c5741dc$var$gd;
            break;
        default:
            e = $477696120c5741dc$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$477696120c5741dc$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $477696120c5741dc$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $477696120c5741dc$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $477696120c5741dc$var$Jb(function() {
        var d = f, e = $477696120c5741dc$var$xb(c), g = [];
        a: {
            var h = $477696120c5741dc$var$df.get(a);
            if (void 0 !== h) {
                var k = $477696120c5741dc$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $477696120c5741dc$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $477696120c5741dc$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $477696120c5741dc$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $477696120c5741dc$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $477696120c5741dc$var$Vd;
                        break;
                    case $477696120c5741dc$var$$e:
                    case $477696120c5741dc$var$af:
                    case $477696120c5741dc$var$bf:
                        k = $477696120c5741dc$var$Hd;
                        break;
                    case $477696120c5741dc$var$cf:
                        k = $477696120c5741dc$var$Xd;
                        break;
                    case "scroll":
                        k = $477696120c5741dc$var$vd;
                        break;
                    case "wheel":
                        k = $477696120c5741dc$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $477696120c5741dc$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $477696120c5741dc$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $477696120c5741dc$var$Kb(w, x), null != F && t.push($477696120c5741dc$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $477696120c5741dc$var$wb && (n = c.relatedTarget || c.fromElement) && ($477696120c5741dc$var$Wc(n) || n[$477696120c5741dc$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $477696120c5741dc$var$Wc(n) : null, null !== n && (J = $477696120c5741dc$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $477696120c5741dc$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $477696120c5741dc$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $477696120c5741dc$var$ue(k);
                        u = null == n ? h : $477696120c5741dc$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $477696120c5741dc$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $477696120c5741dc$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $477696120c5741dc$var$vf(F))u++;
                            for(; 0 < w - u;)t = $477696120c5741dc$var$vf(t), w--;
                            for(; 0 < u - w;)x = $477696120c5741dc$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $477696120c5741dc$var$vf(t);
                                x = $477696120c5741dc$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $477696120c5741dc$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $477696120c5741dc$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $477696120c5741dc$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $477696120c5741dc$var$ve;
                else if ($477696120c5741dc$var$me(h)) {
                    if ($477696120c5741dc$var$we) na = $477696120c5741dc$var$Fe;
                    else {
                        na = $477696120c5741dc$var$De;
                        var xa = $477696120c5741dc$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $477696120c5741dc$var$Ee);
                if (na && (na = na(a, d))) {
                    $477696120c5741dc$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $477696120c5741dc$var$cb(h, "number", h.value);
            }
            xa = d ? $477696120c5741dc$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($477696120c5741dc$var$me(xa) || "true" === xa.contentEditable) $477696120c5741dc$var$Qe = xa, $477696120c5741dc$var$Re = d, $477696120c5741dc$var$Se = null;
                    break;
                case "focusout":
                    $477696120c5741dc$var$Se = $477696120c5741dc$var$Re = $477696120c5741dc$var$Qe = null;
                    break;
                case "mousedown":
                    $477696120c5741dc$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $477696120c5741dc$var$Te = !1;
                    $477696120c5741dc$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($477696120c5741dc$var$Pe) break;
                case "keydown":
                case "keyup":
                    $477696120c5741dc$var$Ue(g, c, e);
            }
            var $a;
            if ($477696120c5741dc$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $477696120c5741dc$var$ie ? $477696120c5741dc$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($477696120c5741dc$var$de && "ko" !== c.locale && ($477696120c5741dc$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $477696120c5741dc$var$ie && ($a = $477696120c5741dc$var$nd()) : ($477696120c5741dc$var$kd = e, $477696120c5741dc$var$ld = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, $477696120c5741dc$var$ie = !0)), xa = $477696120c5741dc$var$oe(d, ba), 0 < xa.length && (ba = new $477696120c5741dc$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $477696120c5741dc$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $477696120c5741dc$var$ce ? $477696120c5741dc$var$je(a, c) : $477696120c5741dc$var$ke(a, c)) d = $477696120c5741dc$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $477696120c5741dc$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $477696120c5741dc$var$se(g, b);
    });
}
function $477696120c5741dc$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $477696120c5741dc$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $477696120c5741dc$var$Kb(a, c), null != f && d.unshift($477696120c5741dc$var$tf(a, f, e)), f = $477696120c5741dc$var$Kb(a, b), null != f && d.push($477696120c5741dc$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $477696120c5741dc$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $477696120c5741dc$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $477696120c5741dc$var$Kb(c, f), null != k && g.unshift($477696120c5741dc$var$tf(c, k, h))) : e || (k = $477696120c5741dc$var$Kb(c, f), null != k && g.push($477696120c5741dc$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $477696120c5741dc$var$xf = /\r\n?/g, $477696120c5741dc$var$yf = /\u0000|\uFFFD/g;
function $477696120c5741dc$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($477696120c5741dc$var$xf, "\n").replace($477696120c5741dc$var$yf, "");
}
function $477696120c5741dc$var$Af(a, b, c) {
    b = $477696120c5741dc$var$zf(b);
    if ($477696120c5741dc$var$zf(a) !== b && c) throw Error($477696120c5741dc$var$p(425));
}
function $477696120c5741dc$var$Bf() {}
var $477696120c5741dc$var$Cf = null, $477696120c5741dc$var$Df = null;
function $477696120c5741dc$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $477696120c5741dc$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $477696120c5741dc$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $477696120c5741dc$var$Hf = "function" === typeof Promise ? Promise : void 0, $477696120c5741dc$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $477696120c5741dc$var$Hf ? function(a) {
    return $477696120c5741dc$var$Hf.resolve(null).then(a).catch($477696120c5741dc$var$If);
} : $477696120c5741dc$var$Ff;
function $477696120c5741dc$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $477696120c5741dc$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $477696120c5741dc$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $477696120c5741dc$var$bd(b);
}
function $477696120c5741dc$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $477696120c5741dc$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $477696120c5741dc$var$Nf = Math.random().toString(36).slice(2), $477696120c5741dc$var$Of = "__reactFiber$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Pf = "__reactProps$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$uf = "__reactContainer$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$of = "__reactEvents$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Qf = "__reactListeners$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Rf = "__reactHandles$" + $477696120c5741dc$var$Nf;
function $477696120c5741dc$var$Wc(a) {
    var b = a[$477696120c5741dc$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$477696120c5741dc$var$uf] || c[$477696120c5741dc$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $477696120c5741dc$var$Mf(a); null !== a;){
                if (c = a[$477696120c5741dc$var$Of]) return c;
                a = $477696120c5741dc$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $477696120c5741dc$var$Cb(a) {
    a = a[$477696120c5741dc$var$Of] || a[$477696120c5741dc$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $477696120c5741dc$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($477696120c5741dc$var$p(33));
}
function $477696120c5741dc$var$Db(a) {
    return a[$477696120c5741dc$var$Pf] || null;
}
var $477696120c5741dc$var$Sf = [], $477696120c5741dc$var$Tf = -1;
function $477696120c5741dc$var$Uf(a) {
    return {
        current: a
    };
}
function $477696120c5741dc$var$E(a) {
    0 > $477696120c5741dc$var$Tf || (a.current = $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf], $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = null, $477696120c5741dc$var$Tf--);
}
function $477696120c5741dc$var$G(a, b) {
    $477696120c5741dc$var$Tf++;
    $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = a.current;
    a.current = b;
}
var $477696120c5741dc$var$Vf = {}, $477696120c5741dc$var$H = $477696120c5741dc$var$Uf($477696120c5741dc$var$Vf), $477696120c5741dc$var$Wf = $477696120c5741dc$var$Uf(!1), $477696120c5741dc$var$Xf = $477696120c5741dc$var$Vf;
function $477696120c5741dc$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $477696120c5741dc$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $477696120c5741dc$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $477696120c5741dc$var$$f() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$E($477696120c5741dc$var$H);
}
function $477696120c5741dc$var$ag(a, b, c) {
    if ($477696120c5741dc$var$H.current !== $477696120c5741dc$var$Vf) throw Error($477696120c5741dc$var$p(168));
    $477696120c5741dc$var$G($477696120c5741dc$var$H, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
function $477696120c5741dc$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($477696120c5741dc$var$p(108, $477696120c5741dc$var$Ra(a) || "Unknown", e));
    return $477696120c5741dc$var$A({}, c, d);
}
function $477696120c5741dc$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $477696120c5741dc$var$Vf;
    $477696120c5741dc$var$Xf = $477696120c5741dc$var$H.current;
    $477696120c5741dc$var$G($477696120c5741dc$var$H, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, $477696120c5741dc$var$Wf.current);
    return !0;
}
function $477696120c5741dc$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($477696120c5741dc$var$p(169));
    c ? (a = $477696120c5741dc$var$bg(a, b, $477696120c5741dc$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$G($477696120c5741dc$var$H, a)) : $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
var $477696120c5741dc$var$eg = null, $477696120c5741dc$var$fg = !1, $477696120c5741dc$var$gg = !1;
function $477696120c5741dc$var$hg(a) {
    null === $477696120c5741dc$var$eg ? $477696120c5741dc$var$eg = [
        a
    ] : $477696120c5741dc$var$eg.push(a);
}
function $477696120c5741dc$var$ig(a) {
    $477696120c5741dc$var$fg = !0;
    $477696120c5741dc$var$hg(a);
}
function $477696120c5741dc$var$jg() {
    if (!$477696120c5741dc$var$gg && null !== $477696120c5741dc$var$eg) {
        $477696120c5741dc$var$gg = !0;
        var a = 0, b = $477696120c5741dc$var$C;
        try {
            var c = $477696120c5741dc$var$eg;
            for($477696120c5741dc$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $477696120c5741dc$var$eg = null;
            $477696120c5741dc$var$fg = !1;
        } catch (e) {
            throw null !== $477696120c5741dc$var$eg && ($477696120c5741dc$var$eg = $477696120c5741dc$var$eg.slice(a + 1)), $477696120c5741dc$var$ac($477696120c5741dc$var$fc, $477696120c5741dc$var$jg), e;
        } finally{
            $477696120c5741dc$var$C = b, $477696120c5741dc$var$gg = !1;
        }
    }
    return null;
}
var $477696120c5741dc$var$kg = [], $477696120c5741dc$var$lg = 0, $477696120c5741dc$var$mg = null, $477696120c5741dc$var$ng = 0, $477696120c5741dc$var$og = [], $477696120c5741dc$var$pg = 0, $477696120c5741dc$var$qg = null, $477696120c5741dc$var$rg = 1, $477696120c5741dc$var$sg = "";
function $477696120c5741dc$var$tg(a, b) {
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$ng;
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$mg;
    $477696120c5741dc$var$mg = a;
    $477696120c5741dc$var$ng = b;
}
function $477696120c5741dc$var$ug(a, b, c) {
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg;
    $477696120c5741dc$var$qg = a;
    var d = $477696120c5741dc$var$rg;
    a = $477696120c5741dc$var$sg;
    var e = 32 - $477696120c5741dc$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $477696120c5741dc$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $477696120c5741dc$var$rg = 1 << 32 - $477696120c5741dc$var$oc(b) + e | c << e | d;
        $477696120c5741dc$var$sg = f + a;
    } else $477696120c5741dc$var$rg = 1 << f | c << e | d, $477696120c5741dc$var$sg = a;
}
function $477696120c5741dc$var$vg(a) {
    null !== a.return && ($477696120c5741dc$var$tg(a, 1), $477696120c5741dc$var$ug(a, 1, 0));
}
function $477696120c5741dc$var$wg(a) {
    for(; a === $477696120c5741dc$var$mg;)$477696120c5741dc$var$mg = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null, $477696120c5741dc$var$ng = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null;
    for(; a === $477696120c5741dc$var$qg;)$477696120c5741dc$var$qg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$sg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$rg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null;
}
var $477696120c5741dc$var$xg = null, $477696120c5741dc$var$yg = null, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$zg = null;
function $477696120c5741dc$var$Ag(a, b) {
    var c = $477696120c5741dc$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $477696120c5741dc$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $477696120c5741dc$var$qg ? {
                id: $477696120c5741dc$var$rg,
                overflow: $477696120c5741dc$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $477696120c5741dc$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $477696120c5741dc$var$Eg(a) {
    if ($477696120c5741dc$var$I) {
        var b = $477696120c5741dc$var$yg;
        if (b) {
            var c = b;
            if (!$477696120c5741dc$var$Cg(a, b)) {
                if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
                b = $477696120c5741dc$var$Lf(c.nextSibling);
                var d = $477696120c5741dc$var$xg;
                b && $477696120c5741dc$var$Cg(a, b) ? $477696120c5741dc$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$xg = a);
            }
        } else {
            if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $477696120c5741dc$var$I = !1;
            $477696120c5741dc$var$xg = a;
        }
    }
}
function $477696120c5741dc$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $477696120c5741dc$var$xg = a;
}
function $477696120c5741dc$var$Gg(a) {
    if (a !== $477696120c5741dc$var$xg) return !1;
    if (!$477696120c5741dc$var$I) return $477696120c5741dc$var$Fg(a), $477696120c5741dc$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$477696120c5741dc$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $477696120c5741dc$var$yg)) {
        if ($477696120c5741dc$var$Dg(a)) throw $477696120c5741dc$var$Hg(), Error($477696120c5741dc$var$p(418));
        for(; b;)$477696120c5741dc$var$Ag(a, b), b = $477696120c5741dc$var$Lf(b.nextSibling);
    }
    $477696120c5741dc$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($477696120c5741dc$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $477696120c5741dc$var$yg = null;
        }
    } else $477696120c5741dc$var$yg = $477696120c5741dc$var$xg ? $477696120c5741dc$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $477696120c5741dc$var$Hg() {
    for(var a = $477696120c5741dc$var$yg; a;)a = $477696120c5741dc$var$Lf(a.nextSibling);
}
function $477696120c5741dc$var$Ig() {
    $477696120c5741dc$var$yg = $477696120c5741dc$var$xg = null;
    $477696120c5741dc$var$I = !1;
}
function $477696120c5741dc$var$Jg(a) {
    null === $477696120c5741dc$var$zg ? $477696120c5741dc$var$zg = [
        a
    ] : $477696120c5741dc$var$zg.push(a);
}
var $477696120c5741dc$var$Kg = $477696120c5741dc$var$ua.ReactCurrentBatchConfig;
function $477696120c5741dc$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $477696120c5741dc$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $477696120c5741dc$var$Mg = $477696120c5741dc$var$Uf(null), $477696120c5741dc$var$Ng = null, $477696120c5741dc$var$Og = null, $477696120c5741dc$var$Pg = null;
function $477696120c5741dc$var$Qg() {
    $477696120c5741dc$var$Pg = $477696120c5741dc$var$Og = $477696120c5741dc$var$Ng = null;
}
function $477696120c5741dc$var$Rg(a) {
    var b = $477696120c5741dc$var$Mg.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$Mg);
    a._currentValue = b;
}
function $477696120c5741dc$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $477696120c5741dc$var$Tg(a, b) {
    $477696120c5741dc$var$Ng = a;
    $477696120c5741dc$var$Pg = $477696120c5741dc$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($477696120c5741dc$var$Ug = !0), a.firstContext = null);
}
function $477696120c5741dc$var$Vg(a) {
    var b = a._currentValue;
    if ($477696120c5741dc$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $477696120c5741dc$var$Og) {
            if (null === $477696120c5741dc$var$Ng) throw Error($477696120c5741dc$var$p(308));
            $477696120c5741dc$var$Og = a;
            $477696120c5741dc$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $477696120c5741dc$var$Og = $477696120c5741dc$var$Og.next = a;
    }
    return b;
}
var $477696120c5741dc$var$Wg = null;
function $477696120c5741dc$var$Xg(a) {
    null === $477696120c5741dc$var$Wg ? $477696120c5741dc$var$Wg = [
        a
    ] : $477696120c5741dc$var$Wg.push(a);
}
function $477696120c5741dc$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $477696120c5741dc$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $477696120c5741dc$var$Zg(a, d);
}
function $477696120c5741dc$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $477696120c5741dc$var$$g = !1;
function $477696120c5741dc$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $477696120c5741dc$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $477696120c5741dc$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $477696120c5741dc$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($477696120c5741dc$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $477696120c5741dc$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $477696120c5741dc$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $477696120c5741dc$var$Zg(a, c);
}
function $477696120c5741dc$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
function $477696120c5741dc$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $477696120c5741dc$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $477696120c5741dc$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $477696120c5741dc$var$A({}, q, r);
                            break a;
                        case 2:
                            $477696120c5741dc$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $477696120c5741dc$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $477696120c5741dc$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($477696120c5741dc$var$p(191, e));
            e.call(d);
        }
    }
}
var $477696120c5741dc$var$jh = (new $4Iuzv.Component).refs;
function $477696120c5741dc$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $477696120c5741dc$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $477696120c5741dc$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $477696120c5741dc$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$L(), e = $477696120c5741dc$var$lh(a), f = $477696120c5741dc$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$dh(a, f, e);
        null !== b && ($477696120c5741dc$var$mh(b, a, e, d), $477696120c5741dc$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$L(), e = $477696120c5741dc$var$lh(a), f = $477696120c5741dc$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$dh(a, f, e);
        null !== b && ($477696120c5741dc$var$mh(b, a, e, d), $477696120c5741dc$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $477696120c5741dc$var$L(), d = $477696120c5741dc$var$lh(a), e = $477696120c5741dc$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $477696120c5741dc$var$dh(a, e, d);
        null !== b && ($477696120c5741dc$var$mh(b, a, d, c), $477696120c5741dc$var$eh(b, a, d));
    }
};
function $477696120c5741dc$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$477696120c5741dc$var$Ie(c, d) || !$477696120c5741dc$var$Ie(e, f) : !0;
}
function $477696120c5741dc$var$ph(a, b, c) {
    var d = !1, e = $477696120c5741dc$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $477696120c5741dc$var$Vg(f) : (e = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $477696120c5741dc$var$Yf(a, e) : $477696120c5741dc$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $477696120c5741dc$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $477696120c5741dc$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $477696120c5741dc$var$nh.enqueueReplaceState(b, b.state, null);
}
function $477696120c5741dc$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $477696120c5741dc$var$jh;
    $477696120c5741dc$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $477696120c5741dc$var$Vg(f) : (f = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, e.context = $477696120c5741dc$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($477696120c5741dc$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $477696120c5741dc$var$nh.enqueueReplaceState(e, e.state, null), $477696120c5741dc$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $477696120c5741dc$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($477696120c5741dc$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($477696120c5741dc$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $477696120c5741dc$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($477696120c5741dc$var$p(284));
        if (!c._owner) throw Error($477696120c5741dc$var$p(290, a));
    }
    return a;
}
function $477696120c5741dc$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($477696120c5741dc$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $477696120c5741dc$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $477696120c5741dc$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $477696120c5741dc$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $477696120c5741dc$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $477696120c5741dc$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $477696120c5741dc$var$sh(a, b, c), d.return = a, d;
        d = $477696120c5741dc$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $477696120c5741dc$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $477696120c5741dc$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $477696120c5741dc$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $477696120c5741dc$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $477696120c5741dc$var$va:
                    return c = $477696120c5741dc$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $477696120c5741dc$var$sh(a, null, b), c.return = a, c;
                case $477696120c5741dc$var$wa:
                    return b = $477696120c5741dc$var$zh(b, a.mode, c), b.return = a, b;
                case $477696120c5741dc$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($477696120c5741dc$var$eb(b) || $477696120c5741dc$var$Ka(b)) return b = $477696120c5741dc$var$Ah(b, a.mode, c, null), b.return = a, b;
            $477696120c5741dc$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $477696120c5741dc$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $477696120c5741dc$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $477696120c5741dc$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($477696120c5741dc$var$eb(c) || $477696120c5741dc$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $477696120c5741dc$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $477696120c5741dc$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $477696120c5741dc$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $477696120c5741dc$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($477696120c5741dc$var$eb(d) || $477696120c5741dc$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $477696120c5741dc$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $477696120c5741dc$var$Ka(h);
        if ("function" !== typeof l) throw Error($477696120c5741dc$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($477696120c5741dc$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $477696120c5741dc$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $477696120c5741dc$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $477696120c5741dc$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $477696120c5741dc$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $477696120c5741dc$var$ya ? (d = $477696120c5741dc$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $477696120c5741dc$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $477696120c5741dc$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $477696120c5741dc$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $477696120c5741dc$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $477696120c5741dc$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($477696120c5741dc$var$eb(f)) return n(a, d, f, h);
            if ($477696120c5741dc$var$Ka(f)) return t(a, d, f, h);
            $477696120c5741dc$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $477696120c5741dc$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $477696120c5741dc$var$Bh = $477696120c5741dc$var$vh(!0), $477696120c5741dc$var$Ch = $477696120c5741dc$var$vh(!1), $477696120c5741dc$var$Dh = {}, $477696120c5741dc$var$Eh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh), $477696120c5741dc$var$Fh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh), $477696120c5741dc$var$Gh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh);
function $477696120c5741dc$var$Hh(a) {
    if (a === $477696120c5741dc$var$Dh) throw Error($477696120c5741dc$var$p(174));
    return a;
}
function $477696120c5741dc$var$Ih(a, b) {
    $477696120c5741dc$var$G($477696120c5741dc$var$Gh, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Fh, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Eh, $477696120c5741dc$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $477696120c5741dc$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $477696120c5741dc$var$lb(b, a);
    }
    $477696120c5741dc$var$E($477696120c5741dc$var$Eh);
    $477696120c5741dc$var$G($477696120c5741dc$var$Eh, b);
}
function $477696120c5741dc$var$Jh() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Eh);
    $477696120c5741dc$var$E($477696120c5741dc$var$Fh);
    $477696120c5741dc$var$E($477696120c5741dc$var$Gh);
}
function $477696120c5741dc$var$Kh(a) {
    $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
    var b = $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
    var c = $477696120c5741dc$var$lb(b, a.type);
    b !== c && ($477696120c5741dc$var$G($477696120c5741dc$var$Fh, a), $477696120c5741dc$var$G($477696120c5741dc$var$Eh, c));
}
function $477696120c5741dc$var$Lh(a) {
    $477696120c5741dc$var$Fh.current === a && ($477696120c5741dc$var$E($477696120c5741dc$var$Eh), $477696120c5741dc$var$E($477696120c5741dc$var$Fh));
}
var $477696120c5741dc$var$M = $477696120c5741dc$var$Uf(0);
function $477696120c5741dc$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $477696120c5741dc$var$Nh = [];
function $477696120c5741dc$var$Oh() {
    for(var a = 0; a < $477696120c5741dc$var$Nh.length; a++)$477696120c5741dc$var$Nh[a]._workInProgressVersionPrimary = null;
    $477696120c5741dc$var$Nh.length = 0;
}
var $477696120c5741dc$var$Ph = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$Qh = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$Rh = 0, $477696120c5741dc$var$N = null, $477696120c5741dc$var$O = null, $477696120c5741dc$var$P = null, $477696120c5741dc$var$Sh = !1, $477696120c5741dc$var$Th = !1, $477696120c5741dc$var$Uh = 0, $477696120c5741dc$var$Vh = 0;
function $477696120c5741dc$var$Q() {
    throw Error($477696120c5741dc$var$p(321));
}
function $477696120c5741dc$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$477696120c5741dc$var$He(a[c], b[c])) return !1;
    return !0;
}
function $477696120c5741dc$var$Xh(a, b, c, d, e, f) {
    $477696120c5741dc$var$Rh = f;
    $477696120c5741dc$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $477696120c5741dc$var$Ph.current = null === a || null === a.memoizedState ? $477696120c5741dc$var$Yh : $477696120c5741dc$var$Zh;
    a = c(d, e);
    if ($477696120c5741dc$var$Th) {
        f = 0;
        do {
            $477696120c5741dc$var$Th = !1;
            $477696120c5741dc$var$Uh = 0;
            if (25 <= f) throw Error($477696120c5741dc$var$p(301));
            f += 1;
            $477696120c5741dc$var$P = $477696120c5741dc$var$O = null;
            b.updateQueue = null;
            $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$$h;
            a = c(d, e);
        }while ($477696120c5741dc$var$Th);
    }
    $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$ai;
    b = null !== $477696120c5741dc$var$O && null !== $477696120c5741dc$var$O.next;
    $477696120c5741dc$var$Rh = 0;
    $477696120c5741dc$var$P = $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
    $477696120c5741dc$var$Sh = !1;
    if (b) throw Error($477696120c5741dc$var$p(300));
    return a;
}
function $477696120c5741dc$var$bi() {
    var a = 0 !== $477696120c5741dc$var$Uh;
    $477696120c5741dc$var$Uh = 0;
    return a;
}
function $477696120c5741dc$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState = $477696120c5741dc$var$P = a : $477696120c5741dc$var$P = $477696120c5741dc$var$P.next = a;
    return $477696120c5741dc$var$P;
}
function $477696120c5741dc$var$di() {
    if (null === $477696120c5741dc$var$O) {
        var a = $477696120c5741dc$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $477696120c5741dc$var$O.next;
    var b = null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState : $477696120c5741dc$var$P.next;
    if (null !== b) $477696120c5741dc$var$P = b, $477696120c5741dc$var$O = a;
    else {
        if (null === a) throw Error($477696120c5741dc$var$p(310));
        $477696120c5741dc$var$O = a;
        a = {
            memoizedState: $477696120c5741dc$var$O.memoizedState,
            baseState: $477696120c5741dc$var$O.baseState,
            baseQueue: $477696120c5741dc$var$O.baseQueue,
            queue: $477696120c5741dc$var$O.queue,
            next: null
        };
        null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState = $477696120c5741dc$var$P = a : $477696120c5741dc$var$P = $477696120c5741dc$var$P.next = a;
    }
    return $477696120c5741dc$var$P;
}
function $477696120c5741dc$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $477696120c5741dc$var$fi(a) {
    var b = $477696120c5741dc$var$di(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = $477696120c5741dc$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($477696120c5741dc$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $477696120c5741dc$var$N.lanes |= m;
                $477696120c5741dc$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $477696120c5741dc$var$He(d, b.memoizedState) || ($477696120c5741dc$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $477696120c5741dc$var$N.lanes |= f, $477696120c5741dc$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $477696120c5741dc$var$gi(a) {
    var b = $477696120c5741dc$var$di(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $477696120c5741dc$var$He(f, b.memoizedState) || ($477696120c5741dc$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $477696120c5741dc$var$hi() {}
function $477696120c5741dc$var$ii(a, b) {
    var c = $477696120c5741dc$var$N, d = $477696120c5741dc$var$di(), e = b(), f = !$477696120c5741dc$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $477696120c5741dc$var$Ug = !0);
    d = d.queue;
    $477696120c5741dc$var$ji($477696120c5741dc$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $477696120c5741dc$var$P && $477696120c5741dc$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $477696120c5741dc$var$li(9, $477696120c5741dc$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $477696120c5741dc$var$R) throw Error($477696120c5741dc$var$p(349));
        0 !== ($477696120c5741dc$var$Rh & 30) || $477696120c5741dc$var$ni(c, b, e);
    }
    return e;
}
function $477696120c5741dc$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $477696120c5741dc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $477696120c5741dc$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $477696120c5741dc$var$oi(b) && $477696120c5741dc$var$pi(a);
}
function $477696120c5741dc$var$ki(a, b, c) {
    return c(function() {
        $477696120c5741dc$var$oi(b) && $477696120c5741dc$var$pi(a);
    });
}
function $477696120c5741dc$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$477696120c5741dc$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $477696120c5741dc$var$pi(a) {
    var b = $477696120c5741dc$var$Zg(a, 1);
    null !== b && $477696120c5741dc$var$mh(b, a, 1, -1);
}
function $477696120c5741dc$var$qi(a) {
    var b = $477696120c5741dc$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $477696120c5741dc$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $477696120c5741dc$var$ri.bind(null, $477696120c5741dc$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $477696120c5741dc$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $477696120c5741dc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $477696120c5741dc$var$si() {
    return $477696120c5741dc$var$di().memoizedState;
}
function $477696120c5741dc$var$ti(a, b, c, d) {
    var e = $477696120c5741dc$var$ci();
    $477696120c5741dc$var$N.flags |= a;
    e.memoizedState = $477696120c5741dc$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $477696120c5741dc$var$ui(a, b, c, d) {
    var e = $477696120c5741dc$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $477696120c5741dc$var$O) {
        var g = $477696120c5741dc$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $477696120c5741dc$var$Wh(d, g.deps)) {
            e.memoizedState = $477696120c5741dc$var$li(b, c, f, d);
            return;
        }
    }
    $477696120c5741dc$var$N.flags |= a;
    e.memoizedState = $477696120c5741dc$var$li(1 | b, c, f, d);
}
function $477696120c5741dc$var$vi(a, b) {
    return $477696120c5741dc$var$ti(8390656, 8, a, b);
}
function $477696120c5741dc$var$ji(a, b) {
    return $477696120c5741dc$var$ui(2048, 8, a, b);
}
function $477696120c5741dc$var$wi(a, b) {
    return $477696120c5741dc$var$ui(4, 2, a, b);
}
function $477696120c5741dc$var$xi(a, b) {
    return $477696120c5741dc$var$ui(4, 4, a, b);
}
function $477696120c5741dc$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $477696120c5741dc$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $477696120c5741dc$var$ui(4, 4, $477696120c5741dc$var$yi.bind(null, b, a), c);
}
function $477696120c5741dc$var$Ai() {}
function $477696120c5741dc$var$Bi(a, b) {
    var c = $477696120c5741dc$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$Ci(a, b) {
    var c = $477696120c5741dc$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$Di(a, b, c) {
    if (0 === ($477696120c5741dc$var$Rh & 21)) return a.baseState && (a.baseState = !1, $477696120c5741dc$var$Ug = !0), a.memoizedState = c;
    $477696120c5741dc$var$He(c, b) || (c = $477696120c5741dc$var$yc(), $477696120c5741dc$var$N.lanes |= c, $477696120c5741dc$var$hh |= c, a.baseState = !0);
    return b;
}
function $477696120c5741dc$var$Ei(a, b) {
    var c = $477696120c5741dc$var$C;
    $477696120c5741dc$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $477696120c5741dc$var$Qh.transition;
    $477696120c5741dc$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $477696120c5741dc$var$C = c, $477696120c5741dc$var$Qh.transition = d;
    }
}
function $477696120c5741dc$var$Fi() {
    return $477696120c5741dc$var$di().memoizedState;
}
function $477696120c5741dc$var$Gi(a, b, c) {
    var d = $477696120c5741dc$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$Hi(a)) $477696120c5741dc$var$Ii(b, c);
    else if (c = $477696120c5741dc$var$Yg(a, b, c, d), null !== c) {
        var e = $477696120c5741dc$var$L();
        $477696120c5741dc$var$mh(c, a, d, e);
        $477696120c5741dc$var$Ji(c, b, d);
    }
}
function $477696120c5741dc$var$ri(a, b, c) {
    var d = $477696120c5741dc$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$Hi(a)) $477696120c5741dc$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($477696120c5741dc$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $477696120c5741dc$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $477696120c5741dc$var$Yg(a, b, e, d);
        null !== c && (e = $477696120c5741dc$var$L(), $477696120c5741dc$var$mh(c, a, d, e), $477696120c5741dc$var$Ji(c, b, d));
    }
}
function $477696120c5741dc$var$Hi(a) {
    var b = a.alternate;
    return a === $477696120c5741dc$var$N || null !== b && b === $477696120c5741dc$var$N;
}
function $477696120c5741dc$var$Ii(a, b) {
    $477696120c5741dc$var$Th = $477696120c5741dc$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $477696120c5741dc$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
var $477696120c5741dc$var$ai = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Q,
    useContext: $477696120c5741dc$var$Q,
    useEffect: $477696120c5741dc$var$Q,
    useImperativeHandle: $477696120c5741dc$var$Q,
    useInsertionEffect: $477696120c5741dc$var$Q,
    useLayoutEffect: $477696120c5741dc$var$Q,
    useMemo: $477696120c5741dc$var$Q,
    useReducer: $477696120c5741dc$var$Q,
    useRef: $477696120c5741dc$var$Q,
    useState: $477696120c5741dc$var$Q,
    useDebugValue: $477696120c5741dc$var$Q,
    useDeferredValue: $477696120c5741dc$var$Q,
    useTransition: $477696120c5741dc$var$Q,
    useMutableSource: $477696120c5741dc$var$Q,
    useSyncExternalStore: $477696120c5741dc$var$Q,
    useId: $477696120c5741dc$var$Q,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Yh = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: function(a, b) {
        $477696120c5741dc$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $477696120c5741dc$var$ti(4194308, 4, $477696120c5741dc$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $477696120c5741dc$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $477696120c5741dc$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $477696120c5741dc$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $477696120c5741dc$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $477696120c5741dc$var$Gi.bind(null, $477696120c5741dc$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $477696120c5741dc$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $477696120c5741dc$var$qi,
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        return $477696120c5741dc$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$qi(!1), b = a[0];
        a = $477696120c5741dc$var$Ei.bind(null, a[1]);
        $477696120c5741dc$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $477696120c5741dc$var$N, e = $477696120c5741dc$var$ci();
        if ($477696120c5741dc$var$I) {
            if (void 0 === c) throw Error($477696120c5741dc$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $477696120c5741dc$var$R) throw Error($477696120c5741dc$var$p(349));
            0 !== ($477696120c5741dc$var$Rh & 30) || $477696120c5741dc$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $477696120c5741dc$var$vi($477696120c5741dc$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $477696120c5741dc$var$li(9, $477696120c5741dc$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $477696120c5741dc$var$ci(), b = $477696120c5741dc$var$R.identifierPrefix;
        if ($477696120c5741dc$var$I) {
            var c = $477696120c5741dc$var$sg;
            var d = $477696120c5741dc$var$rg;
            c = (d & ~(1 << 32 - $477696120c5741dc$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $477696120c5741dc$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $477696120c5741dc$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Zh = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Bi,
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$ji,
    useImperativeHandle: $477696120c5741dc$var$zi,
    useInsertionEffect: $477696120c5741dc$var$wi,
    useLayoutEffect: $477696120c5741dc$var$xi,
    useMemo: $477696120c5741dc$var$Ci,
    useReducer: $477696120c5741dc$var$fi,
    useRef: $477696120c5741dc$var$si,
    useState: function() {
        return $477696120c5741dc$var$fi($477696120c5741dc$var$ei);
    },
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$di();
        return $477696120c5741dc$var$Di(b, $477696120c5741dc$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$fi($477696120c5741dc$var$ei)[0], b = $477696120c5741dc$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$hi,
    useSyncExternalStore: $477696120c5741dc$var$ii,
    useId: $477696120c5741dc$var$Fi,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$$h = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Bi,
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$ji,
    useImperativeHandle: $477696120c5741dc$var$zi,
    useInsertionEffect: $477696120c5741dc$var$wi,
    useLayoutEffect: $477696120c5741dc$var$xi,
    useMemo: $477696120c5741dc$var$Ci,
    useReducer: $477696120c5741dc$var$gi,
    useRef: $477696120c5741dc$var$si,
    useState: function() {
        return $477696120c5741dc$var$gi($477696120c5741dc$var$ei);
    },
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$di();
        return null === $477696120c5741dc$var$O ? b.memoizedState = a : $477696120c5741dc$var$Di(b, $477696120c5741dc$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$gi($477696120c5741dc$var$ei)[0], b = $477696120c5741dc$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$hi,
    useSyncExternalStore: $477696120c5741dc$var$ii,
    useId: $477696120c5741dc$var$Fi,
    unstable_isNewReconciler: !1
};
function $477696120c5741dc$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $477696120c5741dc$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $477696120c5741dc$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $477696120c5741dc$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $477696120c5741dc$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $477696120c5741dc$var$Oi(a, b, c) {
    c = $477696120c5741dc$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $477696120c5741dc$var$Pi || ($477696120c5741dc$var$Pi = !0, $477696120c5741dc$var$Qi = d);
        $477696120c5741dc$var$Mi(a, b);
    };
    return c;
}
function $477696120c5741dc$var$Ri(a, b, c) {
    c = $477696120c5741dc$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $477696120c5741dc$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $477696120c5741dc$var$Mi(a, b);
        "function" !== typeof d && (null === $477696120c5741dc$var$Si ? $477696120c5741dc$var$Si = new Set([
            this
        ]) : $477696120c5741dc$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $477696120c5741dc$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $477696120c5741dc$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $477696120c5741dc$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $477696120c5741dc$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $477696120c5741dc$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $477696120c5741dc$var$ch(-1, 1), b.tag = 2, $477696120c5741dc$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $477696120c5741dc$var$Xi = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$Ug = !1;
function $477696120c5741dc$var$Yi(a, b, c, d) {
    b.child = null === a ? $477696120c5741dc$var$Ch(b, null, c, d) : $477696120c5741dc$var$Bh(b, a.child, c, d);
}
function $477696120c5741dc$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $477696120c5741dc$var$Tg(b, e);
    d = $477696120c5741dc$var$Xh(a, b, c, d, f, e);
    c = $477696120c5741dc$var$bi();
    if (null !== a && !$477696120c5741dc$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$$i(a, b, e);
    $477696120c5741dc$var$I && c && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Yi(a, b, d, e);
    return b.child;
}
function $477696120c5741dc$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$477696120c5741dc$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $477696120c5741dc$var$cj(a, b, f, d, e);
        a = $477696120c5741dc$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $477696120c5741dc$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $477696120c5741dc$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $477696120c5741dc$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $477696120c5741dc$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($477696120c5741dc$var$Ie(f, d) && a.ref === b.ref) {
            if ($477696120c5741dc$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($477696120c5741dc$var$Ug = !0);
            else return b.lanes = a.lanes, $477696120c5741dc$var$$i(a, b, e);
        }
    }
    return $477696120c5741dc$var$dj(a, b, c, d, e);
}
function $477696120c5741dc$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj);
            $477696120c5741dc$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= d;
    $477696120c5741dc$var$Yi(a, b, e, c);
    return b.child;
}
function $477696120c5741dc$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $477696120c5741dc$var$dj(a, b, c, d, e) {
    var f = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current;
    f = $477696120c5741dc$var$Yf(b, f);
    $477696120c5741dc$var$Tg(b, e);
    c = $477696120c5741dc$var$Xh(a, b, c, d, f, e);
    d = $477696120c5741dc$var$bi();
    if (null !== a && !$477696120c5741dc$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$$i(a, b, e);
    $477696120c5741dc$var$I && d && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Yi(a, b, c, e);
    return b.child;
}
function $477696120c5741dc$var$ij(a, b, c, d, e) {
    if ($477696120c5741dc$var$Zf(c)) {
        var f = !0;
        $477696120c5741dc$var$cg(b);
    } else f = !1;
    $477696120c5741dc$var$Tg(b, e);
    if (null === b.stateNode) $477696120c5741dc$var$jj(a, b), $477696120c5741dc$var$ph(b, c, d), $477696120c5741dc$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $477696120c5741dc$var$Vg(l) : (l = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, l = $477696120c5741dc$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $477696120c5741dc$var$qh(b, g, d, l);
        $477696120c5741dc$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$$g ? ("function" === typeof m && ($477696120c5741dc$var$kh(b, c, m, d), k = b.memoizedState), (h = $477696120c5741dc$var$$g || $477696120c5741dc$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $477696120c5741dc$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $477696120c5741dc$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $477696120c5741dc$var$Vg(k) : (k = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, k = $477696120c5741dc$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $477696120c5741dc$var$qh(b, g, d, k);
        $477696120c5741dc$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$$g ? ("function" === typeof y && ($477696120c5741dc$var$kh(b, c, y, d), n = b.memoizedState), (l = $477696120c5741dc$var$$g || $477696120c5741dc$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $477696120c5741dc$var$kj(a, b, c, d, f, e);
}
function $477696120c5741dc$var$kj(a, b, c, d, e, f) {
    $477696120c5741dc$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $477696120c5741dc$var$dg(b, c, !1), $477696120c5741dc$var$$i(a, b, f);
    d = b.stateNode;
    $477696120c5741dc$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $477696120c5741dc$var$Bh(b, a.child, null, f), b.child = $477696120c5741dc$var$Bh(b, null, h, f)) : $477696120c5741dc$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $477696120c5741dc$var$dg(b, c, !0);
    return b.child;
}
function $477696120c5741dc$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $477696120c5741dc$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $477696120c5741dc$var$ag(a, b.context, !1);
    $477696120c5741dc$var$Ih(a, b.containerInfo);
}
function $477696120c5741dc$var$mj(a, b, c, d, e) {
    $477696120c5741dc$var$Ig();
    $477696120c5741dc$var$Jg(e);
    b.flags |= 256;
    $477696120c5741dc$var$Yi(a, b, c, d);
    return b.child;
}
var $477696120c5741dc$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $477696120c5741dc$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $477696120c5741dc$var$pj(a, b, c) {
    var d = b.pendingProps, e = $477696120c5741dc$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $477696120c5741dc$var$G($477696120c5741dc$var$M, e & 1);
    if (null === a) {
        $477696120c5741dc$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $477696120c5741dc$var$qj(g, d, 0, null), a = $477696120c5741dc$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $477696120c5741dc$var$oj(c), b.memoizedState = $477696120c5741dc$var$nj, a) : $477696120c5741dc$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $477696120c5741dc$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $477696120c5741dc$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $477696120c5741dc$var$wh(h, f) : (f = $477696120c5741dc$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $477696120c5741dc$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $477696120c5741dc$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $477696120c5741dc$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $477696120c5741dc$var$rj(a, b) {
    b = $477696120c5741dc$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $477696120c5741dc$var$tj(a, b, c, d) {
    null !== d && $477696120c5741dc$var$Jg(d);
    $477696120c5741dc$var$Bh(b, a.child, null, c);
    a = $477696120c5741dc$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $477696120c5741dc$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $477696120c5741dc$var$Li(Error($477696120c5741dc$var$p(422))), $477696120c5741dc$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $477696120c5741dc$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $477696120c5741dc$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $477696120c5741dc$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $477696120c5741dc$var$oj(g);
        b.memoizedState = $477696120c5741dc$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $477696120c5741dc$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($477696120c5741dc$var$p(419));
        d = $477696120c5741dc$var$Li(f, d, void 0);
        return $477696120c5741dc$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($477696120c5741dc$var$Ug || h) {
        d = $477696120c5741dc$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $477696120c5741dc$var$Zg(a, e), $477696120c5741dc$var$mh(d, a, e, -1));
        }
        $477696120c5741dc$var$uj();
        d = $477696120c5741dc$var$Li(Error($477696120c5741dc$var$p(421)));
        return $477696120c5741dc$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $477696120c5741dc$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(e.nextSibling);
    $477696120c5741dc$var$xg = b;
    $477696120c5741dc$var$I = !0;
    $477696120c5741dc$var$zg = null;
    null !== a && ($477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg, $477696120c5741dc$var$rg = a.id, $477696120c5741dc$var$sg = a.overflow, $477696120c5741dc$var$qg = b);
    b = $477696120c5741dc$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $477696120c5741dc$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $477696120c5741dc$var$Sg(a.return, b, c);
}
function $477696120c5741dc$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $477696120c5741dc$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $477696120c5741dc$var$Yi(a, b, d.children, c);
    d = $477696120c5741dc$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $477696120c5741dc$var$wj(a, c, b);
            else if (19 === a.tag) $477696120c5741dc$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $477696120c5741dc$var$G($477696120c5741dc$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $477696120c5741dc$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $477696120c5741dc$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $477696120c5741dc$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $477696120c5741dc$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $477696120c5741dc$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $477696120c5741dc$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $477696120c5741dc$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $477696120c5741dc$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($477696120c5741dc$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $477696120c5741dc$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $477696120c5741dc$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $477696120c5741dc$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $477696120c5741dc$var$lj(b);
            $477696120c5741dc$var$Ig();
            break;
        case 5:
            $477696120c5741dc$var$Kh(b);
            break;
        case 1:
            $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$cg(b);
            break;
        case 4:
            $477696120c5741dc$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $477696120c5741dc$var$G($477696120c5741dc$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $477696120c5741dc$var$pj(a, b, c);
                $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1);
                a = $477696120c5741dc$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $477696120c5741dc$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $477696120c5741dc$var$ej(a, b, c);
    }
    return $477696120c5741dc$var$$i(a, b, c);
}
var $477696120c5741dc$var$Aj, $477696120c5741dc$var$Bj, $477696120c5741dc$var$Cj, $477696120c5741dc$var$Dj;
$477696120c5741dc$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$477696120c5741dc$var$Bj = function() {};
$477696120c5741dc$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $477696120c5741dc$var$Ya(a, e);
                d = $477696120c5741dc$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $477696120c5741dc$var$A({}, e, {
                    value: void 0
                });
                d = $477696120c5741dc$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $477696120c5741dc$var$gb(a, e);
                d = $477696120c5741dc$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $477696120c5741dc$var$Bf);
        }
        $477696120c5741dc$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $477696120c5741dc$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$477696120c5741dc$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $477696120c5741dc$var$Ej(a, b) {
    if (!$477696120c5741dc$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $477696120c5741dc$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $477696120c5741dc$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $477696120c5741dc$var$S(b), null;
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 3:
            d = b.stateNode;
            $477696120c5741dc$var$Jh();
            $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
            $477696120c5741dc$var$E($477696120c5741dc$var$H);
            $477696120c5741dc$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $477696120c5741dc$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Gj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null));
            $477696120c5741dc$var$Bj(a, b);
            $477696120c5741dc$var$S(b);
            return null;
        case 5:
            $477696120c5741dc$var$Lh(b);
            var e = $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $477696120c5741dc$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                    $477696120c5741dc$var$S(b);
                    return null;
                }
                a = $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    d[$477696120c5741dc$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $477696120c5741dc$var$D("cancel", d);
                            $477696120c5741dc$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], d);
                            break;
                        case "source":
                            $477696120c5741dc$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $477696120c5741dc$var$D("error", d);
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "details":
                            $477696120c5741dc$var$D("toggle", d);
                            break;
                        case "input":
                            $477696120c5741dc$var$Za(d, f);
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$hb(d, f), $477696120c5741dc$var$D("invalid", d);
                    }
                    $477696120c5741dc$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $477696120c5741dc$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $477696120c5741dc$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $477696120c5741dc$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $477696120c5741dc$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$477696120c5741dc$var$Of] = b;
                    a[$477696120c5741dc$var$Pf] = d;
                    $477696120c5741dc$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $477696120c5741dc$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $477696120c5741dc$var$D("cancel", a);
                                $477696120c5741dc$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $477696120c5741dc$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $477696120c5741dc$var$D("error", a);
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $477696120c5741dc$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $477696120c5741dc$var$Za(a, d);
                                e = $477696120c5741dc$var$Ya(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $477696120c5741dc$var$A({}, d, {
                                    value: void 0
                                });
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$hb(a, d);
                                e = $477696120c5741dc$var$gb(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $477696120c5741dc$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $477696120c5741dc$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $477696120c5741dc$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $477696120c5741dc$var$ob(a, k) : "number" === typeof k && $477696120c5741dc$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($477696120c5741dc$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $477696120c5741dc$var$D("scroll", a) : null != k && $477696120c5741dc$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $477696120c5741dc$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $477696120c5741dc$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $477696120c5741dc$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $477696120c5741dc$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $477696120c5741dc$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                c = $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
                $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $477696120c5741dc$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$477696120c5741dc$var$Of] = b, b.stateNode = d;
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($477696120c5741dc$var$I && null !== $477696120c5741dc$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $477696120c5741dc$var$Hg(), $477696120c5741dc$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $477696120c5741dc$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($477696120c5741dc$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($477696120c5741dc$var$p(317));
                        f[$477696120c5741dc$var$Of] = b;
                    } else $477696120c5741dc$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $477696120c5741dc$var$S(b);
                    f = !1;
                } else null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Gj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($477696120c5741dc$var$M.current & 1) ? 0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 3) : $477696120c5741dc$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $477696120c5741dc$var$S(b);
            return null;
        case 4:
            return $477696120c5741dc$var$Jh(), $477696120c5741dc$var$Bj(a, b), null === a && $477696120c5741dc$var$sf(b.stateNode.containerInfo), $477696120c5741dc$var$S(b), null;
        case 10:
            return $477696120c5741dc$var$Rg(b.type._context), $477696120c5741dc$var$S(b), null;
        case 17:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 19:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            f = b.memoizedState;
            if (null === f) return $477696120c5741dc$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $477696120c5741dc$var$Ej(f, !1);
                else {
                    if (0 !== $477696120c5741dc$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $477696120c5741dc$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $477696120c5741dc$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $477696120c5741dc$var$B() > $477696120c5741dc$var$Hj && (b.flags |= 128, d = !0, $477696120c5741dc$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $477696120c5741dc$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $477696120c5741dc$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$477696120c5741dc$var$I) return $477696120c5741dc$var$S(b), null;
                    } else 2 * $477696120c5741dc$var$B() - f.renderingStartTime > $477696120c5741dc$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $477696120c5741dc$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $477696120c5741dc$var$B(), b.sibling = null, c = $477696120c5741dc$var$M.current, $477696120c5741dc$var$G($477696120c5741dc$var$M, d ? c & 1 | 2 : c & 1), b;
            $477696120c5741dc$var$S(b);
            return null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($477696120c5741dc$var$gj & 1073741824) && ($477696120c5741dc$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $477696120c5741dc$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
}
function $477696120c5741dc$var$Jj(a, b) {
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $477696120c5741dc$var$Jh(), $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $477696120c5741dc$var$Lh(b), null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($477696120c5741dc$var$p(340));
                $477696120c5741dc$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $477696120c5741dc$var$E($477696120c5741dc$var$M), null;
        case 4:
            return $477696120c5741dc$var$Jh(), null;
        case 10:
            return $477696120c5741dc$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $477696120c5741dc$var$Kj = !1, $477696120c5741dc$var$U = !1, $477696120c5741dc$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $477696120c5741dc$var$V = null;
function $477696120c5741dc$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $477696120c5741dc$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $477696120c5741dc$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $477696120c5741dc$var$W(a, b, d);
    }
}
var $477696120c5741dc$var$Oj = !1;
function $477696120c5741dc$var$Pj(a, b) {
    $477696120c5741dc$var$Cf = $477696120c5741dc$var$dd;
    a = $477696120c5741dc$var$Me();
    if ($477696120c5741dc$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $477696120c5741dc$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $477696120c5741dc$var$dd = !1;
    for($477696120c5741dc$var$V = b; null !== $477696120c5741dc$var$V;)if (b = $477696120c5741dc$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $477696120c5741dc$var$V = a;
    else for(; null !== $477696120c5741dc$var$V;){
        b = $477696120c5741dc$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $477696120c5741dc$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(163));
            }
        } catch (F) {
            $477696120c5741dc$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $477696120c5741dc$var$V = a;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
    n = $477696120c5741dc$var$Oj;
    $477696120c5741dc$var$Oj = !1;
    return n;
}
function $477696120c5741dc$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $477696120c5741dc$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $477696120c5741dc$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $477696120c5741dc$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $477696120c5741dc$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $477696120c5741dc$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$477696120c5741dc$var$Of], delete b[$477696120c5741dc$var$Pf], delete b[$477696120c5741dc$var$of], delete b[$477696120c5741dc$var$Qf], delete b[$477696120c5741dc$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $477696120c5741dc$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $477696120c5741dc$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $477696120c5741dc$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $477696120c5741dc$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $477696120c5741dc$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Wj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Wj(a, b, c), a = a.sibling;
}
function $477696120c5741dc$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Xj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Xj(a, b, c), a = a.sibling;
}
var $477696120c5741dc$var$X = null, $477696120c5741dc$var$Yj = !1;
function $477696120c5741dc$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$477696120c5741dc$var$ak(a, b, c), c = c.sibling;
}
function $477696120c5741dc$var$ak(a, b, c) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberUnmount) try {
        $477696120c5741dc$var$lc.onCommitFiberUnmount($477696120c5741dc$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $477696120c5741dc$var$U || $477696120c5741dc$var$Mj(c, b);
        case 6:
            var d = $477696120c5741dc$var$X, e = $477696120c5741dc$var$Yj;
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Zj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Yj = e;
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Yj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $477696120c5741dc$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Yj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? $477696120c5741dc$var$Kf(a.parentNode, c) : 1 === a.nodeType && $477696120c5741dc$var$Kf(a, c), $477696120c5741dc$var$bd(a)) : $477696120c5741dc$var$Kf($477696120c5741dc$var$X, c.stateNode));
            break;
        case 4:
            d = $477696120c5741dc$var$X;
            e = $477696120c5741dc$var$Yj;
            $477696120c5741dc$var$X = c.stateNode.containerInfo;
            $477696120c5741dc$var$Yj = !0;
            $477696120c5741dc$var$Zj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$477696120c5741dc$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $477696120c5741dc$var$Nj(c, b, g) : 0 !== (f & 4) && $477696120c5741dc$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 1:
            if (!$477696120c5741dc$var$U && ($477696120c5741dc$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $477696120c5741dc$var$W(c, b, h);
            }
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 21:
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($477696120c5741dc$var$U = (d = $477696120c5741dc$var$U) || null !== c.memoizedState, $477696120c5741dc$var$Zj(a, b, c), $477696120c5741dc$var$U = d) : $477696120c5741dc$var$Zj(a, b, c);
            break;
        default:
            $477696120c5741dc$var$Zj(a, b, c);
    }
}
function $477696120c5741dc$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $477696120c5741dc$var$Lj);
        b.forEach(function(b) {
            var d = $477696120c5741dc$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $477696120c5741dc$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $477696120c5741dc$var$X = h.stateNode;
                        $477696120c5741dc$var$Yj = !1;
                        break a;
                    case 3:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Yj = !0;
                        break a;
                    case 4:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $477696120c5741dc$var$X) throw Error($477696120c5741dc$var$p(160));
            $477696120c5741dc$var$ak(f, g, e);
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $477696120c5741dc$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$477696120c5741dc$var$ek(b, a), b = b.sibling;
}
function $477696120c5741dc$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4) {
                try {
                    $477696120c5741dc$var$Qj(3, a, a.return), $477696120c5741dc$var$Rj(3, a);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
                try {
                    $477696120c5741dc$var$Qj(5, a, a.return);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 512 && null !== c && $477696120c5741dc$var$Mj(c, c.return);
            break;
        case 5:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 512 && null !== c && $477696120c5741dc$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $477696120c5741dc$var$ob(e, "");
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $477696120c5741dc$var$ab(e, f);
                    $477696120c5741dc$var$vb(h, g);
                    var l = $477696120c5741dc$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $477696120c5741dc$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $477696120c5741dc$var$nb(e, q) : "children" === m ? $477696120c5741dc$var$ob(e, q) : $477696120c5741dc$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $477696120c5741dc$var$bb(e, f);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $477696120c5741dc$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $477696120c5741dc$var$fb(e, !!f.multiple, f.defaultValue, !0) : $477696120c5741dc$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$477696120c5741dc$var$Pf] = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($477696120c5741dc$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $477696120c5741dc$var$bd(b.containerInfo);
            } catch (t) {
                $477696120c5741dc$var$W(a, a.return, t);
            }
            break;
        case 4:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            break;
        case 13:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($477696120c5741dc$var$gk = $477696120c5741dc$var$B()));
            d & 4 && $477696120c5741dc$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($477696120c5741dc$var$U = (l = $477696120c5741dc$var$U) || m, $477696120c5741dc$var$dk(b, a), $477696120c5741dc$var$U = l) : $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($477696120c5741dc$var$V = a, m = a.child; null !== m;){
                    for(q = $477696120c5741dc$var$V = m; null !== $477696120c5741dc$var$V;){
                        r = $477696120c5741dc$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $477696120c5741dc$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $477696120c5741dc$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $477696120c5741dc$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $477696120c5741dc$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $477696120c5741dc$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $477696120c5741dc$var$V = y) : $477696120c5741dc$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $477696120c5741dc$var$rb("display", g));
                            } catch (t) {
                                $477696120c5741dc$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $477696120c5741dc$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 4 && $477696120c5741dc$var$bk(a);
            break;
        case 21:
            break;
        default:
            $477696120c5741dc$var$dk(b, a), $477696120c5741dc$var$fk(a);
    }
}
function $477696120c5741dc$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($477696120c5741dc$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($477696120c5741dc$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($477696120c5741dc$var$ob(e, ""), d.flags &= -33);
                    var f = $477696120c5741dc$var$Vj(a);
                    $477696120c5741dc$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $477696120c5741dc$var$Vj(a);
                    $477696120c5741dc$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(161));
            }
        } catch (k) {
            $477696120c5741dc$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $477696120c5741dc$var$ik(a, b, c) {
    $477696120c5741dc$var$V = a;
    $477696120c5741dc$var$jk(a, b, c);
}
function $477696120c5741dc$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $477696120c5741dc$var$V;){
        var e = $477696120c5741dc$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $477696120c5741dc$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $477696120c5741dc$var$U;
                h = $477696120c5741dc$var$Kj;
                var l = $477696120c5741dc$var$U;
                $477696120c5741dc$var$Kj = g;
                if (($477696120c5741dc$var$U = k) && !l) for($477696120c5741dc$var$V = e; null !== $477696120c5741dc$var$V;)g = $477696120c5741dc$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $477696120c5741dc$var$kk(e) : null !== k ? (k.return = g, $477696120c5741dc$var$V = k) : $477696120c5741dc$var$kk(e);
                for(; null !== f;)$477696120c5741dc$var$V = f, $477696120c5741dc$var$jk(f, b, c), f = f.sibling;
                $477696120c5741dc$var$V = e;
                $477696120c5741dc$var$Kj = h;
                $477696120c5741dc$var$U = l;
            }
            $477696120c5741dc$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $477696120c5741dc$var$V = f) : $477696120c5741dc$var$lk(a, b, c);
    }
}
function $477696120c5741dc$var$lk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $477696120c5741dc$var$U || $477696120c5741dc$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$477696120c5741dc$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $477696120c5741dc$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $477696120c5741dc$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $477696120c5741dc$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $477696120c5741dc$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($477696120c5741dc$var$p(163));
                }
                $477696120c5741dc$var$U || b.flags & 512 && $477696120c5741dc$var$Sj(b);
            } catch (r) {
                $477696120c5741dc$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$hk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$kk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $477696120c5741dc$var$Rj(4, b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $477696120c5741dc$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $477696120c5741dc$var$Sj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $477696120c5741dc$var$Sj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $477696120c5741dc$var$W(b, b.return, k);
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $477696120c5741dc$var$V = h;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
var $477696120c5741dc$var$mk = Math.ceil, $477696120c5741dc$var$nk = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$ok = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$pk = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$K = 0, $477696120c5741dc$var$R = null, $477696120c5741dc$var$Y = null, $477696120c5741dc$var$Z = 0, $477696120c5741dc$var$gj = 0, $477696120c5741dc$var$fj = $477696120c5741dc$var$Uf(0), $477696120c5741dc$var$T = 0, $477696120c5741dc$var$qk = null, $477696120c5741dc$var$hh = 0, $477696120c5741dc$var$rk = 0, $477696120c5741dc$var$sk = 0, $477696120c5741dc$var$tk = null, $477696120c5741dc$var$uk = null, $477696120c5741dc$var$gk = 0, $477696120c5741dc$var$Hj = Infinity, $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Pi = !1, $477696120c5741dc$var$Qi = null, $477696120c5741dc$var$Si = null, $477696120c5741dc$var$wk = !1, $477696120c5741dc$var$xk = null, $477696120c5741dc$var$yk = 0, $477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = null, $477696120c5741dc$var$Bk = -1, $477696120c5741dc$var$Ck = 0;
function $477696120c5741dc$var$L() {
    return 0 !== ($477696120c5741dc$var$K & 6) ? $477696120c5741dc$var$B() : -1 !== $477696120c5741dc$var$Bk ? $477696120c5741dc$var$Bk : $477696120c5741dc$var$Bk = $477696120c5741dc$var$B();
}
function $477696120c5741dc$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($477696120c5741dc$var$K & 2) && 0 !== $477696120c5741dc$var$Z) return $477696120c5741dc$var$Z & -$477696120c5741dc$var$Z;
    if (null !== $477696120c5741dc$var$Kg.transition) return 0 === $477696120c5741dc$var$Ck && ($477696120c5741dc$var$Ck = $477696120c5741dc$var$yc()), $477696120c5741dc$var$Ck;
    a = $477696120c5741dc$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $477696120c5741dc$var$jd(a.type);
    return a;
}
function $477696120c5741dc$var$mh(a, b, c, d) {
    if (50 < $477696120c5741dc$var$zk) throw $477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = null, Error($477696120c5741dc$var$p(185));
    $477696120c5741dc$var$Ac(a, c, d);
    if (0 === ($477696120c5741dc$var$K & 2) || a !== $477696120c5741dc$var$R) a === $477696120c5741dc$var$R && (0 === ($477696120c5741dc$var$K & 2) && ($477696120c5741dc$var$rk |= c), 4 === $477696120c5741dc$var$T && $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$Z)), $477696120c5741dc$var$Ek(a, d), 1 === c && 0 === $477696120c5741dc$var$K && 0 === (b.mode & 1) && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
}
function $477696120c5741dc$var$Ek(a, b) {
    var c = a.callbackNode;
    $477696120c5741dc$var$wc(a, b);
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$R ? $477696120c5741dc$var$Z : 0);
    if (0 === d) null !== c && $477696120c5741dc$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $477696120c5741dc$var$bc(c);
        if (1 === b) 0 === a.tag ? $477696120c5741dc$var$ig($477696120c5741dc$var$Fk.bind(null, a)) : $477696120c5741dc$var$hg($477696120c5741dc$var$Fk.bind(null, a)), $477696120c5741dc$var$Jf(function() {
            0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
        }), c = null;
        else {
            switch($477696120c5741dc$var$Dc(d)){
                case 1:
                    c = $477696120c5741dc$var$fc;
                    break;
                case 4:
                    c = $477696120c5741dc$var$gc;
                    break;
                case 16:
                    c = $477696120c5741dc$var$hc;
                    break;
                case 536870912:
                    c = $477696120c5741dc$var$jc;
                    break;
                default:
                    c = $477696120c5741dc$var$hc;
            }
            c = $477696120c5741dc$var$Gk(c, $477696120c5741dc$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $477696120c5741dc$var$Hk(a, b) {
    $477696120c5741dc$var$Bk = -1;
    $477696120c5741dc$var$Ck = 0;
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    var c = a.callbackNode;
    if ($477696120c5741dc$var$Ik() && a.callbackNode !== c) return null;
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$R ? $477696120c5741dc$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $477696120c5741dc$var$Jk(a, d);
    else {
        b = d;
        var e = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 2;
        var f = $477696120c5741dc$var$Kk();
        if ($477696120c5741dc$var$R !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$Lk(a, b);
        for(;;)try {
            $477696120c5741dc$var$Mk();
            break;
        } catch (h) {
            $477696120c5741dc$var$Nk(a, h);
        }
        $477696120c5741dc$var$Qg();
        $477696120c5741dc$var$nk.current = f;
        $477696120c5741dc$var$K = e;
        null !== $477696120c5741dc$var$Y ? b = 0 : ($477696120c5741dc$var$R = null, $477696120c5741dc$var$Z = 0, b = $477696120c5741dc$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $477696120c5741dc$var$xc(a), 0 !== e && (d = e, b = $477696120c5741dc$var$Ok(a, e)));
        if (1 === b) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, d), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
        if (6 === b) $477696120c5741dc$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$477696120c5741dc$var$Pk(e) && (b = $477696120c5741dc$var$Jk(a, d), 2 === b && (f = $477696120c5741dc$var$xc(a), 0 !== f && (d = f, b = $477696120c5741dc$var$Ok(a, f))), 1 === b)) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, d), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($477696120c5741dc$var$p(345));
                case 2:
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 3:
                    $477696120c5741dc$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $477696120c5741dc$var$gk + 500 - $477696120c5741dc$var$B(), 10 < b)) {
                        if (0 !== $477696120c5741dc$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $477696120c5741dc$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Qk.bind(null, a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk), b);
                        break;
                    }
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 4:
                    $477696120c5741dc$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $477696120c5741dc$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $477696120c5741dc$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $477696120c5741dc$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Qk.bind(null, a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk), d);
                        break;
                    }
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 5:
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(329));
            }
        }
    }
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    return a.callbackNode === c ? $477696120c5741dc$var$Hk.bind(null, a) : null;
}
function $477696120c5741dc$var$Ok(a, b) {
    var c = $477696120c5741dc$var$tk;
    a.current.memoizedState.isDehydrated && ($477696120c5741dc$var$Lk(a, b).flags |= 256);
    a = $477696120c5741dc$var$Jk(a, b);
    2 !== a && (b = $477696120c5741dc$var$uk, $477696120c5741dc$var$uk = c, null !== b && $477696120c5741dc$var$Gj(b));
    return a;
}
function $477696120c5741dc$var$Gj(a) {
    null === $477696120c5741dc$var$uk ? $477696120c5741dc$var$uk = a : $477696120c5741dc$var$uk.push.apply($477696120c5741dc$var$uk, a);
}
function $477696120c5741dc$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$477696120c5741dc$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $477696120c5741dc$var$Dk(a, b) {
    b &= ~$477696120c5741dc$var$sk;
    b &= ~$477696120c5741dc$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $477696120c5741dc$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $477696120c5741dc$var$Fk(a) {
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    $477696120c5741dc$var$Ik();
    var b = $477696120c5741dc$var$uc(a, 0);
    if (0 === (b & 1)) return $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), null;
    var c = $477696120c5741dc$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $477696120c5741dc$var$xc(a);
        0 !== d && (b = d, c = $477696120c5741dc$var$Ok(a, d));
    }
    if (1 === c) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, b), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
    if (6 === c) throw Error($477696120c5741dc$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    return null;
}
function $477696120c5741dc$var$Rk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    try {
        return a(b);
    } finally{
        $477696120c5741dc$var$K = c, 0 === $477696120c5741dc$var$K && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
    }
}
function $477696120c5741dc$var$Sk(a) {
    null !== $477696120c5741dc$var$xk && 0 === $477696120c5741dc$var$xk.tag && 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$Ik();
    var b = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    var c = $477696120c5741dc$var$pk.transition, d = $477696120c5741dc$var$C;
    try {
        if ($477696120c5741dc$var$pk.transition = null, $477696120c5741dc$var$C = 1, a) return a();
    } finally{
        $477696120c5741dc$var$C = d, $477696120c5741dc$var$pk.transition = c, $477696120c5741dc$var$K = b, 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
    }
}
function $477696120c5741dc$var$Ij() {
    $477696120c5741dc$var$gj = $477696120c5741dc$var$fj.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$fj);
}
function $477696120c5741dc$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $477696120c5741dc$var$Gf(c));
    if (null !== $477696120c5741dc$var$Y) for(c = $477696120c5741dc$var$Y.return; null !== c;){
        var d = c;
        $477696120c5741dc$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $477696120c5741dc$var$$f();
                break;
            case 3:
                $477696120c5741dc$var$Jh();
                $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
                $477696120c5741dc$var$E($477696120c5741dc$var$H);
                $477696120c5741dc$var$Oh();
                break;
            case 5:
                $477696120c5741dc$var$Lh(d);
                break;
            case 4:
                $477696120c5741dc$var$Jh();
                break;
            case 13:
                $477696120c5741dc$var$E($477696120c5741dc$var$M);
                break;
            case 19:
                $477696120c5741dc$var$E($477696120c5741dc$var$M);
                break;
            case 10:
                $477696120c5741dc$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $477696120c5741dc$var$Ij();
        }
        c = c.return;
    }
    $477696120c5741dc$var$R = a;
    $477696120c5741dc$var$Y = a = $477696120c5741dc$var$wh(a.current, null);
    $477696120c5741dc$var$Z = $477696120c5741dc$var$gj = b;
    $477696120c5741dc$var$T = 0;
    $477696120c5741dc$var$qk = null;
    $477696120c5741dc$var$sk = $477696120c5741dc$var$rk = $477696120c5741dc$var$hh = 0;
    $477696120c5741dc$var$uk = $477696120c5741dc$var$tk = null;
    if (null !== $477696120c5741dc$var$Wg) {
        for(b = 0; b < $477696120c5741dc$var$Wg.length; b++)if (c = $477696120c5741dc$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $477696120c5741dc$var$Wg = null;
    }
    return a;
}
function $477696120c5741dc$var$Nk(a, b) {
    do {
        var c = $477696120c5741dc$var$Y;
        try {
            $477696120c5741dc$var$Qg();
            $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$ai;
            if ($477696120c5741dc$var$Sh) {
                for(var d = $477696120c5741dc$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $477696120c5741dc$var$Sh = !1;
            }
            $477696120c5741dc$var$Rh = 0;
            $477696120c5741dc$var$P = $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
            $477696120c5741dc$var$Th = !1;
            $477696120c5741dc$var$Uh = 0;
            $477696120c5741dc$var$ok.current = null;
            if (null === c || null === c.return) {
                $477696120c5741dc$var$T = 1;
                $477696120c5741dc$var$qk = b;
                $477696120c5741dc$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $477696120c5741dc$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $477696120c5741dc$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $477696120c5741dc$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $477696120c5741dc$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $477696120c5741dc$var$Ti(f, l, b);
                            $477696120c5741dc$var$uj();
                            break a;
                        }
                        k = Error($477696120c5741dc$var$p(426));
                    }
                } else if ($477696120c5741dc$var$I && h.mode & 1) {
                    var J = $477696120c5741dc$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $477696120c5741dc$var$Wi(J, g, h, f, b);
                        $477696120c5741dc$var$Jg($477696120c5741dc$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $477696120c5741dc$var$Ki(k, h);
                4 !== $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 2);
                null === $477696120c5741dc$var$tk ? $477696120c5741dc$var$tk = [
                    f
                ] : $477696120c5741dc$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $477696120c5741dc$var$Oi(f, k, b);
                            $477696120c5741dc$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $477696120c5741dc$var$Si || !$477696120c5741dc$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $477696120c5741dc$var$Ri(f, h, b);
                                $477696120c5741dc$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $477696120c5741dc$var$Tk(c);
        } catch (na) {
            b = na;
            $477696120c5741dc$var$Y === c && null !== c && ($477696120c5741dc$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $477696120c5741dc$var$Kk() {
    var a = $477696120c5741dc$var$nk.current;
    $477696120c5741dc$var$nk.current = $477696120c5741dc$var$ai;
    return null === a ? $477696120c5741dc$var$ai : a;
}
function $477696120c5741dc$var$uj() {
    if (0 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T || 2 === $477696120c5741dc$var$T) $477696120c5741dc$var$T = 4;
    null === $477696120c5741dc$var$R || 0 === ($477696120c5741dc$var$hh & 268435455) && 0 === ($477696120c5741dc$var$rk & 268435455) || $477696120c5741dc$var$Dk($477696120c5741dc$var$R, $477696120c5741dc$var$Z);
}
function $477696120c5741dc$var$Jk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 2;
    var d = $477696120c5741dc$var$Kk();
    if ($477696120c5741dc$var$R !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Lk(a, b);
    for(;;)try {
        $477696120c5741dc$var$Uk();
        break;
    } catch (e) {
        $477696120c5741dc$var$Nk(a, e);
    }
    $477696120c5741dc$var$Qg();
    $477696120c5741dc$var$K = c;
    $477696120c5741dc$var$nk.current = d;
    if (null !== $477696120c5741dc$var$Y) throw Error($477696120c5741dc$var$p(261));
    $477696120c5741dc$var$R = null;
    $477696120c5741dc$var$Z = 0;
    return $477696120c5741dc$var$T;
}
function $477696120c5741dc$var$Uk() {
    for(; null !== $477696120c5741dc$var$Y;)$477696120c5741dc$var$Vk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Mk() {
    for(; null !== $477696120c5741dc$var$Y && !$477696120c5741dc$var$cc();)$477696120c5741dc$var$Vk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Vk(a) {
    var b = $477696120c5741dc$var$Wk(a.alternate, a, $477696120c5741dc$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $477696120c5741dc$var$Tk(a) : $477696120c5741dc$var$Y = b;
    $477696120c5741dc$var$ok.current = null;
}
function $477696120c5741dc$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $477696120c5741dc$var$Fj(c, b, $477696120c5741dc$var$gj), null !== c) {
                $477696120c5741dc$var$Y = c;
                return;
            }
        } else {
            c = $477696120c5741dc$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $477696120c5741dc$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $477696120c5741dc$var$T = 6;
                $477696120c5741dc$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $477696120c5741dc$var$Y = b;
            return;
        }
        $477696120c5741dc$var$Y = b = a;
    }while (null !== b);
    0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 5);
}
function $477696120c5741dc$var$Qk(a, b, c) {
    var d = $477696120c5741dc$var$C, e = $477696120c5741dc$var$pk.transition;
    try {
        $477696120c5741dc$var$pk.transition = null, $477696120c5741dc$var$C = 1, $477696120c5741dc$var$Xk(a, b, c, d);
    } finally{
        $477696120c5741dc$var$pk.transition = e, $477696120c5741dc$var$C = d;
    }
    return null;
}
function $477696120c5741dc$var$Xk(a, b, c, d) {
    do $477696120c5741dc$var$Ik();
    while (null !== $477696120c5741dc$var$xk);
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($477696120c5741dc$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $477696120c5741dc$var$Bc(a, f);
    a === $477696120c5741dc$var$R && ($477696120c5741dc$var$Y = $477696120c5741dc$var$R = null, $477696120c5741dc$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $477696120c5741dc$var$wk || ($477696120c5741dc$var$wk = !0, $477696120c5741dc$var$Gk($477696120c5741dc$var$hc, function() {
        $477696120c5741dc$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $477696120c5741dc$var$pk.transition;
        $477696120c5741dc$var$pk.transition = null;
        var g = $477696120c5741dc$var$C;
        $477696120c5741dc$var$C = 1;
        var h = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 4;
        $477696120c5741dc$var$ok.current = null;
        $477696120c5741dc$var$Pj(a, c);
        $477696120c5741dc$var$ek(c, a);
        $477696120c5741dc$var$Oe($477696120c5741dc$var$Df);
        $477696120c5741dc$var$dd = !!$477696120c5741dc$var$Cf;
        $477696120c5741dc$var$Df = $477696120c5741dc$var$Cf = null;
        a.current = c;
        $477696120c5741dc$var$ik(c, a, e);
        $477696120c5741dc$var$dc();
        $477696120c5741dc$var$K = h;
        $477696120c5741dc$var$C = g;
        $477696120c5741dc$var$pk.transition = f;
    } else a.current = c;
    $477696120c5741dc$var$wk && ($477696120c5741dc$var$wk = !1, $477696120c5741dc$var$xk = a, $477696120c5741dc$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($477696120c5741dc$var$Si = null);
    $477696120c5741dc$var$mc(c.stateNode, d);
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($477696120c5741dc$var$Pi) throw $477696120c5741dc$var$Pi = !1, a = $477696120c5741dc$var$Qi, $477696120c5741dc$var$Qi = null, a;
    0 !== ($477696120c5741dc$var$yk & 1) && 0 !== a.tag && $477696120c5741dc$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $477696120c5741dc$var$Ak ? $477696120c5741dc$var$zk++ : ($477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = a) : $477696120c5741dc$var$zk = 0;
    $477696120c5741dc$var$jg();
    return null;
}
function $477696120c5741dc$var$Ik() {
    if (null !== $477696120c5741dc$var$xk) {
        var a = $477696120c5741dc$var$Dc($477696120c5741dc$var$yk), b = $477696120c5741dc$var$pk.transition, c = $477696120c5741dc$var$C;
        try {
            $477696120c5741dc$var$pk.transition = null;
            $477696120c5741dc$var$C = 16 > a ? 16 : a;
            if (null === $477696120c5741dc$var$xk) var d = !1;
            else {
                a = $477696120c5741dc$var$xk;
                $477696120c5741dc$var$xk = null;
                $477696120c5741dc$var$yk = 0;
                if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(331));
                var e = $477696120c5741dc$var$K;
                $477696120c5741dc$var$K |= 4;
                for($477696120c5741dc$var$V = a.current; null !== $477696120c5741dc$var$V;){
                    var f = $477696120c5741dc$var$V, g = f.child;
                    if (0 !== ($477696120c5741dc$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($477696120c5741dc$var$V = l; null !== $477696120c5741dc$var$V;){
                                    var m = $477696120c5741dc$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $477696120c5741dc$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $477696120c5741dc$var$V = q;
                                    else for(; null !== $477696120c5741dc$var$V;){
                                        m = $477696120c5741dc$var$V;
                                        var r = m.sibling, y = m.return;
                                        $477696120c5741dc$var$Tj(m);
                                        if (m === l) {
                                            $477696120c5741dc$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $477696120c5741dc$var$V = r;
                                            break;
                                        }
                                        $477696120c5741dc$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $477696120c5741dc$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $477696120c5741dc$var$V = g;
                    else b: for(; null !== $477696120c5741dc$var$V;){
                        f = $477696120c5741dc$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $477696120c5741dc$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $477696120c5741dc$var$V = x;
                            break b;
                        }
                        $477696120c5741dc$var$V = f.return;
                    }
                }
                var w = a.current;
                for($477696120c5741dc$var$V = w; null !== $477696120c5741dc$var$V;){
                    g = $477696120c5741dc$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $477696120c5741dc$var$V = u;
                    else b: for(g = w; null !== $477696120c5741dc$var$V;){
                        h = $477696120c5741dc$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $477696120c5741dc$var$Rj(9, h);
                            }
                        } catch (na) {
                            $477696120c5741dc$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $477696120c5741dc$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $477696120c5741dc$var$V = F;
                            break b;
                        }
                        $477696120c5741dc$var$V = h.return;
                    }
                }
                $477696120c5741dc$var$K = e;
                $477696120c5741dc$var$jg();
                if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onPostCommitFiberRoot) try {
                    $477696120c5741dc$var$lc.onPostCommitFiberRoot($477696120c5741dc$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $477696120c5741dc$var$C = c, $477696120c5741dc$var$pk.transition = b;
        }
    }
    return !1;
}
function $477696120c5741dc$var$Yk(a, b, c) {
    b = $477696120c5741dc$var$Ki(c, b);
    b = $477696120c5741dc$var$Oi(a, b, 1);
    a = $477696120c5741dc$var$dh(a, b, 1);
    b = $477696120c5741dc$var$L();
    null !== a && ($477696120c5741dc$var$Ac(a, 1, b), $477696120c5741dc$var$Ek(a, b));
}
function $477696120c5741dc$var$W(a, b, c) {
    if (3 === a.tag) $477696120c5741dc$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $477696120c5741dc$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $477696120c5741dc$var$Si || !$477696120c5741dc$var$Si.has(d))) {
                a = $477696120c5741dc$var$Ki(c, a);
                a = $477696120c5741dc$var$Ri(b, a, 1);
                b = $477696120c5741dc$var$dh(b, a, 1);
                a = $477696120c5741dc$var$L();
                null !== b && ($477696120c5741dc$var$Ac(b, 1, a), $477696120c5741dc$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $477696120c5741dc$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $477696120c5741dc$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $477696120c5741dc$var$R === a && ($477696120c5741dc$var$Z & c) === c && (4 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T && ($477696120c5741dc$var$Z & 130023424) === $477696120c5741dc$var$Z && 500 > $477696120c5741dc$var$B() - $477696120c5741dc$var$gk ? $477696120c5741dc$var$Lk(a, 0) : $477696120c5741dc$var$sk |= c);
    $477696120c5741dc$var$Ek(a, b);
}
function $477696120c5741dc$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $477696120c5741dc$var$sc, $477696120c5741dc$var$sc <<= 1, 0 === ($477696120c5741dc$var$sc & 130023424) && ($477696120c5741dc$var$sc = 4194304)));
    var c = $477696120c5741dc$var$L();
    a = $477696120c5741dc$var$Zg(a, b);
    null !== a && ($477696120c5741dc$var$Ac(a, b, c), $477696120c5741dc$var$Ek(a, c));
}
function $477696120c5741dc$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $477696120c5741dc$var$Zk(a, c);
}
function $477696120c5741dc$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($477696120c5741dc$var$p(314));
    }
    null !== d && d.delete(b);
    $477696120c5741dc$var$Zk(a, c);
}
var $477696120c5741dc$var$Wk;
$477696120c5741dc$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $477696120c5741dc$var$Wf.current) $477696120c5741dc$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $477696120c5741dc$var$Ug = !1, $477696120c5741dc$var$zj(a, b, c);
            $477696120c5741dc$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $477696120c5741dc$var$Ug = !1, $477696120c5741dc$var$I && 0 !== (b.flags & 1048576) && $477696120c5741dc$var$ug(b, $477696120c5741dc$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $477696120c5741dc$var$jj(a, b);
            a = b.pendingProps;
            var e = $477696120c5741dc$var$Yf(b, $477696120c5741dc$var$H.current);
            $477696120c5741dc$var$Tg(b, c);
            e = $477696120c5741dc$var$Xh(null, b, d, a, e, c);
            var f = $477696120c5741dc$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $477696120c5741dc$var$Zf(d) ? (f = !0, $477696120c5741dc$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $477696120c5741dc$var$ah(b), e.updater = $477696120c5741dc$var$nh, b.stateNode = e, e._reactInternals = b, $477696120c5741dc$var$rh(b, d, a, c), b = $477696120c5741dc$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $477696120c5741dc$var$I && f && $477696120c5741dc$var$vg(b), $477696120c5741dc$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $477696120c5741dc$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $477696120c5741dc$var$$k(d);
                a = $477696120c5741dc$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $477696120c5741dc$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $477696120c5741dc$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $477696120c5741dc$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $477696120c5741dc$var$aj(null, b, d, $477696120c5741dc$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($477696120c5741dc$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $477696120c5741dc$var$lj(b);
                if (null === a) throw Error($477696120c5741dc$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $477696120c5741dc$var$bh(a, b);
                $477696120c5741dc$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(423)), b);
                        b = $477696120c5741dc$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(424)), b);
                        b = $477696120c5741dc$var$mj(a, b, d, c, e);
                        break a;
                    } else for($477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.stateNode.containerInfo.firstChild), $477696120c5741dc$var$xg = b, $477696120c5741dc$var$I = !0, $477696120c5741dc$var$zg = null, c = $477696120c5741dc$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $477696120c5741dc$var$Ig();
                    if (d === e) {
                        b = $477696120c5741dc$var$$i(a, b, c);
                        break a;
                    }
                    $477696120c5741dc$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $477696120c5741dc$var$Kh(b), null === a && $477696120c5741dc$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $477696120c5741dc$var$Ef(d, e) ? g = null : null !== f && $477696120c5741dc$var$Ef(d, f) && (b.flags |= 32), $477696120c5741dc$var$hj(a, b), $477696120c5741dc$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $477696120c5741dc$var$Eg(b), null;
        case 13:
            return $477696120c5741dc$var$pj(a, b, c);
        case 4:
            return $477696120c5741dc$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $477696120c5741dc$var$Bh(b, null, d, c) : $477696120c5741dc$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$Zi(a, b, d, e, c);
        case 7:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $477696120c5741dc$var$G($477696120c5741dc$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($477696120c5741dc$var$He(f.value, g)) {
                        if (f.children === e.children && !$477696120c5741dc$var$Wf.current) {
                            b = $477696120c5741dc$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $477696120c5741dc$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $477696120c5741dc$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($477696120c5741dc$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $477696120c5741dc$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $477696120c5741dc$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $477696120c5741dc$var$Tg(b, c), e = $477696120c5741dc$var$Vg(e), d = d(e), b.flags |= 1, $477696120c5741dc$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $477696120c5741dc$var$Lg(d, b.pendingProps), e = $477696120c5741dc$var$Lg(d.type, e), $477696120c5741dc$var$aj(a, b, d, e, c);
        case 15:
            return $477696120c5741dc$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$jj(a, b), b.tag = 1, $477696120c5741dc$var$Zf(d) ? (a = !0, $477696120c5741dc$var$cg(b)) : a = !1, $477696120c5741dc$var$Tg(b, c), $477696120c5741dc$var$ph(b, d, e), $477696120c5741dc$var$rh(b, d, e, c), $477696120c5741dc$var$kj(null, b, d, !0, a, c);
        case 19:
            return $477696120c5741dc$var$yj(a, b, c);
        case 22:
            return $477696120c5741dc$var$ej(a, b, c);
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
};
function $477696120c5741dc$var$Gk(a, b) {
    return $477696120c5741dc$var$ac(a, b);
}
function $477696120c5741dc$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $477696120c5741dc$var$Bg(a, b, c, d) {
    return new $477696120c5741dc$var$al(a, b, c, d);
}
function $477696120c5741dc$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $477696120c5741dc$var$$k(a) {
    if ("function" === typeof a) return $477696120c5741dc$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $477696120c5741dc$var$Da) return 11;
        if (a === $477696120c5741dc$var$Ga) return 14;
    }
    return 2;
}
function $477696120c5741dc$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $477696120c5741dc$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $477696120c5741dc$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $477696120c5741dc$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $477696120c5741dc$var$ya:
            return $477696120c5741dc$var$Ah(c.children, e, f, b);
        case $477696120c5741dc$var$za:
            g = 8;
            e |= 8;
            break;
        case $477696120c5741dc$var$Aa:
            return a = $477696120c5741dc$var$Bg(12, c, b, e | 2), a.elementType = $477696120c5741dc$var$Aa, a.lanes = f, a;
        case $477696120c5741dc$var$Ea:
            return a = $477696120c5741dc$var$Bg(13, c, b, e), a.elementType = $477696120c5741dc$var$Ea, a.lanes = f, a;
        case $477696120c5741dc$var$Fa:
            return a = $477696120c5741dc$var$Bg(19, c, b, e), a.elementType = $477696120c5741dc$var$Fa, a.lanes = f, a;
        case $477696120c5741dc$var$Ia:
            return $477696120c5741dc$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $477696120c5741dc$var$Ba:
                    g = 10;
                    break a;
                case $477696120c5741dc$var$Ca:
                    g = 9;
                    break a;
                case $477696120c5741dc$var$Da:
                    g = 11;
                    break a;
                case $477696120c5741dc$var$Ga:
                    g = 14;
                    break a;
                case $477696120c5741dc$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($477696120c5741dc$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $477696120c5741dc$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $477696120c5741dc$var$Ah(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$qj(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(22, a, d, b);
    a.elementType = $477696120c5741dc$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $477696120c5741dc$var$xh(a, b, c) {
    a = $477696120c5741dc$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$zh(a, b, c) {
    b = $477696120c5741dc$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $477696120c5741dc$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $477696120c5741dc$var$zc(0);
    this.expirationTimes = $477696120c5741dc$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $477696120c5741dc$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $477696120c5741dc$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $477696120c5741dc$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $477696120c5741dc$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $477696120c5741dc$var$ah(f);
    return a;
}
function $477696120c5741dc$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $477696120c5741dc$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $477696120c5741dc$var$el(a) {
    if (!a) return $477696120c5741dc$var$Vf;
    a = a._reactInternals;
    a: {
        if ($477696120c5741dc$var$Vb(a) !== a || 1 !== a.tag) throw Error($477696120c5741dc$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($477696120c5741dc$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($477696120c5741dc$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($477696120c5741dc$var$Zf(c)) return $477696120c5741dc$var$bg(a, c, b);
    }
    return b;
}
function $477696120c5741dc$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $477696120c5741dc$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $477696120c5741dc$var$el(null);
    c = a.current;
    d = $477696120c5741dc$var$L();
    e = $477696120c5741dc$var$lh(c);
    f = $477696120c5741dc$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $477696120c5741dc$var$dh(c, f, e);
    a.current.lanes = e;
    $477696120c5741dc$var$Ac(a, e, d);
    $477696120c5741dc$var$Ek(a, d);
    return a;
}
function $477696120c5741dc$var$gl(a, b, c, d) {
    var e = b.current, f = $477696120c5741dc$var$L(), g = $477696120c5741dc$var$lh(e);
    c = $477696120c5741dc$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $477696120c5741dc$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $477696120c5741dc$var$dh(e, b, g);
    null !== a && ($477696120c5741dc$var$mh(a, e, g, f), $477696120c5741dc$var$eh(a, e, g));
    return g;
}
function $477696120c5741dc$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $477696120c5741dc$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $477696120c5741dc$var$jl(a, b) {
    $477696120c5741dc$var$il(a, b);
    (a = a.alternate) && $477696120c5741dc$var$il(a, b);
}
function $477696120c5741dc$var$kl() {
    return null;
}
var $477696120c5741dc$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $477696120c5741dc$var$ml(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$nl.prototype.render = $477696120c5741dc$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($477696120c5741dc$var$p(409));
    $477696120c5741dc$var$gl(a, b, null, null);
};
$477696120c5741dc$var$nl.prototype.unmount = $477696120c5741dc$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $477696120c5741dc$var$Sk(function() {
            $477696120c5741dc$var$gl(null, a, null, null);
        });
        b[$477696120c5741dc$var$uf] = null;
    }
};
function $477696120c5741dc$var$nl(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $477696120c5741dc$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $477696120c5741dc$var$Qc.length && 0 !== b && b < $477696120c5741dc$var$Qc[c].priority; c++);
        $477696120c5741dc$var$Qc.splice(c, 0, a);
        0 === c && $477696120c5741dc$var$Vc(a);
    }
};
function $477696120c5741dc$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $477696120c5741dc$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $477696120c5741dc$var$ql() {}
function $477696120c5741dc$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $477696120c5741dc$var$hl(g);
                f.call(a);
            };
        }
        var g = $477696120c5741dc$var$fl(b, d, a, 0, null, !1, !1, "", $477696120c5741dc$var$ql);
        a._reactRootContainer = g;
        a[$477696120c5741dc$var$uf] = g.current;
        $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
        $477696120c5741dc$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $477696120c5741dc$var$hl(k);
            h.call(a);
        };
    }
    var k = $477696120c5741dc$var$cl(a, 0, !1, null, null, !1, !1, "", $477696120c5741dc$var$ql);
    a._reactRootContainer = k;
    a[$477696120c5741dc$var$uf] = k.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    $477696120c5741dc$var$Sk(function() {
        $477696120c5741dc$var$gl(b, k, c, d);
    });
    return k;
}
function $477696120c5741dc$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $477696120c5741dc$var$hl(g);
                h.call(a);
            };
        }
        $477696120c5741dc$var$gl(b, g, a, e);
    } else g = $477696120c5741dc$var$rl(c, b, a, e, d);
    return $477696120c5741dc$var$hl(g);
}
$477696120c5741dc$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $477696120c5741dc$var$tc(b.pendingLanes);
                0 !== c && ($477696120c5741dc$var$Cc(b, c | 1), $477696120c5741dc$var$Ek(b, $477696120c5741dc$var$B()), 0 === ($477696120c5741dc$var$K & 6) && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$jg()));
            }
            break;
        case 13:
            $477696120c5741dc$var$Sk(function() {
                var b = $477696120c5741dc$var$Zg(a, 1);
                if (null !== b) {
                    var c = $477696120c5741dc$var$L();
                    $477696120c5741dc$var$mh(b, a, 1, c);
                }
            }), $477696120c5741dc$var$jl(a, 1);
    }
};
$477696120c5741dc$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $477696120c5741dc$var$L();
            $477696120c5741dc$var$mh(b, a, 134217728, c);
        }
        $477696120c5741dc$var$jl(a, 134217728);
    }
};
$477696120c5741dc$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$lh(a), c = $477696120c5741dc$var$Zg(a, b);
        if (null !== c) {
            var d = $477696120c5741dc$var$L();
            $477696120c5741dc$var$mh(c, a, b, d);
        }
        $477696120c5741dc$var$jl(a, b);
    }
};
$477696120c5741dc$var$Hc = function() {
    return $477696120c5741dc$var$C;
};
$477696120c5741dc$var$Ic = function(a, b) {
    var c = $477696120c5741dc$var$C;
    try {
        return $477696120c5741dc$var$C = a, b();
    } finally{
        $477696120c5741dc$var$C = c;
    }
};
$477696120c5741dc$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $477696120c5741dc$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $477696120c5741dc$var$Db(d);
                        if (!e) throw Error($477696120c5741dc$var$p(90));
                        $477696120c5741dc$var$Wa(d);
                        $477696120c5741dc$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $477696120c5741dc$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $477696120c5741dc$var$fb(a, !!c.multiple, b, !1);
    }
};
$477696120c5741dc$var$Gb = $477696120c5741dc$var$Rk;
$477696120c5741dc$var$Hb = $477696120c5741dc$var$Sk;
var $477696120c5741dc$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $477696120c5741dc$var$Cb,
        $477696120c5741dc$var$ue,
        $477696120c5741dc$var$Db,
        $477696120c5741dc$var$Eb,
        $477696120c5741dc$var$Fb,
        $477696120c5741dc$var$Rk
    ]
}, $477696120c5741dc$var$ul = {
    findFiberByHostInstance: $477696120c5741dc$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $477696120c5741dc$var$vl = {
    bundleType: $477696120c5741dc$var$ul.bundleType,
    version: $477696120c5741dc$var$ul.version,
    rendererPackageName: $477696120c5741dc$var$ul.rendererPackageName,
    rendererConfig: $477696120c5741dc$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $477696120c5741dc$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $477696120c5741dc$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $477696120c5741dc$var$ul.findFiberByHostInstance || $477696120c5741dc$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $477696120c5741dc$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$477696120c5741dc$var$wl.isDisabled && $477696120c5741dc$var$wl.supportsFiber) try {
        $477696120c5741dc$var$kc = $477696120c5741dc$var$wl.inject($477696120c5741dc$var$vl), $477696120c5741dc$var$lc = $477696120c5741dc$var$wl;
    } catch (a) {}
}
$477696120c5741dc$export$ae55be85d98224ed = $477696120c5741dc$var$tl;
$477696120c5741dc$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$477696120c5741dc$var$ol(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$dl(a, b, null, c);
};
$477696120c5741dc$export$882461b6382ed46c = function(a, b) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(299));
    var c = !1, d = "", e = $477696120c5741dc$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $477696120c5741dc$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $477696120c5741dc$var$ml(b);
};
$477696120c5741dc$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($477696120c5741dc$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($477696120c5741dc$var$p(268, a));
    }
    a = $477696120c5741dc$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$477696120c5741dc$export$cd75ccfd720a3cd4 = function(a) {
    return $477696120c5741dc$var$Sk(a);
};
$477696120c5741dc$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$477696120c5741dc$var$pl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$sl(null, a, b, !0, c);
};
$477696120c5741dc$export$757ceba2d55c277e = function(a, b, c) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $477696120c5741dc$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $477696120c5741dc$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $477696120c5741dc$var$nl(b);
};
$477696120c5741dc$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$477696120c5741dc$var$pl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$sl(null, a, b, !1, c);
};
$477696120c5741dc$export$502457920280e6be = function(a) {
    if (!$477696120c5741dc$var$pl(a)) throw Error($477696120c5741dc$var$p(40));
    return a._reactRootContainer ? ($477696120c5741dc$var$Sk(function() {
        $477696120c5741dc$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$477696120c5741dc$var$uf] = null;
        });
    }), !0) : !1;
};
$477696120c5741dc$export$c78a37762a8d58e1 = $477696120c5741dc$var$Rk;
$477696120c5741dc$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$477696120c5741dc$var$pl(c)) throw Error($477696120c5741dc$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($477696120c5741dc$var$p(38));
    return $477696120c5741dc$var$sl(a, b, c, !1, d);
};
$477696120c5741dc$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c3ne", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ecVue"));

});
parcelRegister("ecVue", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a57ec74d8a366a12$export$c4744153514ff05d; }, function (v) { return $a57ec74d8a366a12$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7; }, function (v) { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a57ec74d8a366a12$export$e26fe2ed2fa76875; }, function (v) { return $a57ec74d8a366a12$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a57ec74d8a366a12$export$502329bbf4b505b1; }, function (v) { return $a57ec74d8a366a12$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a57ec74d8a366a12$export$6e3807111c4874c4; }, function (v) { return $a57ec74d8a366a12$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a57ec74d8a366a12$export$c27134553091fb3a; }, function (v) { return $a57ec74d8a366a12$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2; }, function (v) { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a57ec74d8a366a12$export$b00a404bbd5edef2; }, function (v) { return $a57ec74d8a366a12$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a57ec74d8a366a12$export$8352ce38b91d0c62; }, function (v) { return $a57ec74d8a366a12$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a57ec74d8a366a12$export$d66a1c1c77bd778b; }, function (v) { return $a57ec74d8a366a12$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a57ec74d8a366a12$export$d3dfb8e4810cb555; }, function (v) { return $a57ec74d8a366a12$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a57ec74d8a366a12$export$839f9183b0465a69; }, function (v) { return $a57ec74d8a366a12$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a57ec74d8a366a12$export$72fdf0e06517287b; }, function (v) { return $a57ec74d8a366a12$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a57ec74d8a366a12$export$4b844e58a3e414b4; }, function (v) { return $a57ec74d8a366a12$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a57ec74d8a366a12$export$816d2913ae6b83b1; }, function (v) { return $a57ec74d8a366a12$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a57ec74d8a366a12$export$61bcfe829111a1d0; }, function (v) { return $a57ec74d8a366a12$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f; }, function (v) { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a57ec74d8a366a12$export$b5836b71941fa3ed; }, function (v) { return $a57ec74d8a366a12$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a57ec74d8a366a12$export$cf845f2c119da08a; }, function (v) { return $a57ec74d8a366a12$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a57ec74d8a366a12$export$c4744153514ff05d;
var $a57ec74d8a366a12$export$3e506c1ccc9cc1a7;
var $a57ec74d8a366a12$export$e26fe2ed2fa76875;
var $a57ec74d8a366a12$export$502329bbf4b505b1;
var $a57ec74d8a366a12$export$6e3807111c4874c4;
var $a57ec74d8a366a12$export$c27134553091fb3a;
var $a57ec74d8a366a12$export$33ee1acdc04fd2a2;
var $a57ec74d8a366a12$export$b00a404bbd5edef2;
var $a57ec74d8a366a12$export$8352ce38b91d0c62;
var $a57ec74d8a366a12$export$d66a1c1c77bd778b;
var $a57ec74d8a366a12$export$d3dfb8e4810cb555;
var $a57ec74d8a366a12$export$839f9183b0465a69;
var $a57ec74d8a366a12$export$72fdf0e06517287b;
var $a57ec74d8a366a12$export$4b844e58a3e414b4;
var $a57ec74d8a366a12$export$816d2913ae6b83b1;
var $a57ec74d8a366a12$export$61bcfe829111a1d0;
var $a57ec74d8a366a12$export$7ee8c9beb337bc3f;
var $a57ec74d8a366a12$export$b5836b71941fa3ed;
var $a57ec74d8a366a12$export$cf845f2c119da08a;
"use strict";
function $a57ec74d8a366a12$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a57ec74d8a366a12$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a57ec74d8a366a12$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a57ec74d8a366a12$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a57ec74d8a366a12$var$g(C, c)) n < e && 0 > $a57ec74d8a366a12$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a57ec74d8a366a12$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a57ec74d8a366a12$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a57ec74d8a366a12$var$l = performance;
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$l.now();
    };
} else {
    var $a57ec74d8a366a12$var$p = Date, $a57ec74d8a366a12$var$q = $a57ec74d8a366a12$var$p.now();
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$p.now() - $a57ec74d8a366a12$var$q;
    };
}
var $a57ec74d8a366a12$var$r = [], $a57ec74d8a366a12$var$t = [], $a57ec74d8a366a12$var$u = 1, $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = 3, $a57ec74d8a366a12$var$z = !1, $a57ec74d8a366a12$var$A = !1, $a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$D = "function" === typeof setTimeout ? setTimeout : null, $a57ec74d8a366a12$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a57ec74d8a366a12$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a57ec74d8a366a12$var$G(a) {
    for(var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t); null !== b;){
        if (null === b.callback) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t);
        else if (b.startTime <= a) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t), b.sortIndex = b.expirationTime, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, b);
        else break;
        b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
    }
}
function $a57ec74d8a366a12$var$H(a) {
    $a57ec74d8a366a12$var$B = !1;
    $a57ec74d8a366a12$var$G(a);
    if (!$a57ec74d8a366a12$var$A) {
        if (null !== $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r)) $a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J);
        else {
            var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== b && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, b.startTime - a);
        }
    }
}
function $a57ec74d8a366a12$var$J(a, b) {
    $a57ec74d8a366a12$var$A = !1;
    $a57ec74d8a366a12$var$B && ($a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1);
    $a57ec74d8a366a12$var$z = !0;
    var c = $a57ec74d8a366a12$var$y;
    try {
        $a57ec74d8a366a12$var$G(b);
        for($a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r); null !== $a57ec74d8a366a12$var$v && (!($a57ec74d8a366a12$var$v.expirationTime > b) || a && !$a57ec74d8a366a12$var$M());){
            var d = $a57ec74d8a366a12$var$v.callback;
            if ("function" === typeof d) {
                $a57ec74d8a366a12$var$v.callback = null;
                $a57ec74d8a366a12$var$y = $a57ec74d8a366a12$var$v.priorityLevel;
                var e = d($a57ec74d8a366a12$var$v.expirationTime <= b);
                b = $a57ec74d8a366a12$export$c4744153514ff05d();
                "function" === typeof e ? $a57ec74d8a366a12$var$v.callback = e : $a57ec74d8a366a12$var$v === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
                $a57ec74d8a366a12$var$G(b);
            } else $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
            $a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
        }
        if (null !== $a57ec74d8a366a12$var$v) var w = !0;
        else {
            var m = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== m && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = c, $a57ec74d8a366a12$var$z = !1;
    }
}
var $a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null, $a57ec74d8a366a12$var$L = -1, $a57ec74d8a366a12$var$P = 5, $a57ec74d8a366a12$var$Q = -1;
function $a57ec74d8a366a12$var$M() {
    return $a57ec74d8a366a12$export$c4744153514ff05d() - $a57ec74d8a366a12$var$Q < $a57ec74d8a366a12$var$P ? !1 : !0;
}
function $a57ec74d8a366a12$var$R() {
    if (null !== $a57ec74d8a366a12$var$O) {
        var a = $a57ec74d8a366a12$export$c4744153514ff05d();
        $a57ec74d8a366a12$var$Q = a;
        var b = !0;
        try {
            b = $a57ec74d8a366a12$var$O(!0, a);
        } finally{
            b ? $a57ec74d8a366a12$var$S() : ($a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null);
        }
    } else $a57ec74d8a366a12$var$N = !1;
}
var $a57ec74d8a366a12$var$S;
if ("function" === typeof $a57ec74d8a366a12$var$F) $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$F($a57ec74d8a366a12$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a57ec74d8a366a12$var$T = new MessageChannel, $a57ec74d8a366a12$var$U = $a57ec74d8a366a12$var$T.port2;
    $a57ec74d8a366a12$var$T.port1.onmessage = $a57ec74d8a366a12$var$R;
    $a57ec74d8a366a12$var$S = function() {
        $a57ec74d8a366a12$var$U.postMessage(null);
    };
} else $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$D($a57ec74d8a366a12$var$R, 0);
};
function $a57ec74d8a366a12$var$I(a) {
    $a57ec74d8a366a12$var$O = a;
    $a57ec74d8a366a12$var$N || ($a57ec74d8a366a12$var$N = !0, $a57ec74d8a366a12$var$S());
}
function $a57ec74d8a366a12$var$K(a, b) {
    $a57ec74d8a366a12$var$L = $a57ec74d8a366a12$var$D(function() {
        a($a57ec74d8a366a12$export$c4744153514ff05d());
    }, b);
}
$a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = 5;
$a57ec74d8a366a12$export$e26fe2ed2fa76875 = 1;
$a57ec74d8a366a12$export$502329bbf4b505b1 = 4;
$a57ec74d8a366a12$export$6e3807111c4874c4 = 3;
$a57ec74d8a366a12$export$c27134553091fb3a = null;
$a57ec74d8a366a12$export$33ee1acdc04fd2a2 = 2;
$a57ec74d8a366a12$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a57ec74d8a366a12$export$8352ce38b91d0c62 = function() {
    $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J));
};
$a57ec74d8a366a12$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a57ec74d8a366a12$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a57ec74d8a366a12$export$d3dfb8e4810cb555 = function() {
    return $a57ec74d8a366a12$var$y;
};
$a57ec74d8a366a12$export$839f9183b0465a69 = function() {
    return $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
};
$a57ec74d8a366a12$export$72fdf0e06517287b = function(a) {
    switch($a57ec74d8a366a12$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a57ec74d8a366a12$var$y;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = b;
    try {
        return a();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$4b844e58a3e414b4 = function() {};
$a57ec74d8a366a12$export$816d2913ae6b83b1 = function() {};
$a57ec74d8a366a12$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = a;
    try {
        return b();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a57ec74d8a366a12$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a57ec74d8a366a12$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$t, a), null === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && a === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t) && ($a57ec74d8a366a12$var$B ? ($a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1) : $a57ec74d8a366a12$var$B = !0, $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, c - d))) : (a.sortIndex = e, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, a), $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J)));
    return a;
};
$a57ec74d8a366a12$export$b5836b71941fa3ed = $a57ec74d8a366a12$var$M;
$a57ec74d8a366a12$export$cf845f2c119da08a = function(a) {
    var b = $a57ec74d8a366a12$var$y;
    return function() {
        var c = $a57ec74d8a366a12$var$y;
        $a57ec74d8a366a12$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a57ec74d8a366a12$var$y = c;
        }
    };
};

});



parcelRegister("bU61Z", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $8aa99a55e89e89bd$export$306c0aa65ff9ec16; }, function (v) { return $8aa99a55e89e89bd$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8aa99a55e89e89bd$export$306c0aa65ff9ec16;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
function $8aa99a55e89e89bd$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8aa99a55e89e89bd$var$k = "function" === typeof Object.is ? Object.is : $8aa99a55e89e89bd$var$h, $8aa99a55e89e89bd$var$l = $4Iuzv.useState, $8aa99a55e89e89bd$var$m = $4Iuzv.useEffect, $8aa99a55e89e89bd$var$n = $4Iuzv.useLayoutEffect, $8aa99a55e89e89bd$var$p = $4Iuzv.useDebugValue;
function $8aa99a55e89e89bd$var$q(a, b) {
    var d = b(), f = $8aa99a55e89e89bd$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $8aa99a55e89e89bd$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $8aa99a55e89e89bd$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $8aa99a55e89e89bd$var$m(function() {
        $8aa99a55e89e89bd$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $8aa99a55e89e89bd$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $8aa99a55e89e89bd$var$p(d);
    return d;
}
function $8aa99a55e89e89bd$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$8aa99a55e89e89bd$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $8aa99a55e89e89bd$var$t(a, b) {
    return b();
}
var $8aa99a55e89e89bd$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8aa99a55e89e89bd$var$t : $8aa99a55e89e89bd$var$q;
$8aa99a55e89e89bd$export$306c0aa65ff9ec16 = void 0 !== $4Iuzv.useSyncExternalStore ? $4Iuzv.useSyncExternalStore : $8aa99a55e89e89bd$var$u;

});

parcelRegister("lCXfb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $fbeb1a2c3ddfe070$export$bf730a2d8bf68b42; }, function (v) { return $fbeb1a2c3ddfe070$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fbeb1a2c3ddfe070$export$bf730a2d8bf68b42;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");

var $lhInO = parcelRequire("lhInO");
function $fbeb1a2c3ddfe070$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fbeb1a2c3ddfe070$var$q = "function" === typeof Object.is ? Object.is : $fbeb1a2c3ddfe070$var$p, $fbeb1a2c3ddfe070$var$r = $lhInO.useSyncExternalStore, $fbeb1a2c3ddfe070$var$t = $4Iuzv.useRef, $fbeb1a2c3ddfe070$var$u = $4Iuzv.useEffect, $fbeb1a2c3ddfe070$var$v = $4Iuzv.useMemo, $fbeb1a2c3ddfe070$var$w = $4Iuzv.useDebugValue;
$fbeb1a2c3ddfe070$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $fbeb1a2c3ddfe070$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $fbeb1a2c3ddfe070$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($fbeb1a2c3ddfe070$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $fbeb1a2c3ddfe070$var$r(a, c[0], c[1]);
    $fbeb1a2c3ddfe070$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $fbeb1a2c3ddfe070$var$w(d);
    return d;
};

});
parcelRegister("lhInO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bU61Z"));

});


parcelRegister("42B1L", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2f14122f1c83ab24$export$2b8d127b894957b9; }, function (v) { return $2f14122f1c83ab24$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2f14122f1c83ab24$export$cea3a54a6425200c; }, function (v) { return $2f14122f1c83ab24$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2f14122f1c83ab24$export$a7c73072b1a182ae; }, function (v) { return $2f14122f1c83ab24$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2f14122f1c83ab24$export$9f27bc3417b4524d; }, function (v) { return $2f14122f1c83ab24$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2f14122f1c83ab24$export$db77ccec0bb4ccac; }, function (v) { return $2f14122f1c83ab24$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2f14122f1c83ab24$export$8392c0c9d3dcbd35; }, function (v) { return $2f14122f1c83ab24$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2f14122f1c83ab24$export$ffb0004e005737fa; }, function (v) { return $2f14122f1c83ab24$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2f14122f1c83ab24$export$b624eff549462981; }, function (v) { return $2f14122f1c83ab24$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2f14122f1c83ab24$export$7897aa7841a5380c; }, function (v) { return $2f14122f1c83ab24$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2f14122f1c83ab24$export$602eac185826482c; }, function (v) { return $2f14122f1c83ab24$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2f14122f1c83ab24$export$e2c29f18771995cb; }, function (v) { return $2f14122f1c83ab24$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2f14122f1c83ab24$export$5f8d39834fd61797; }, function (v) { return $2f14122f1c83ab24$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2f14122f1c83ab24$export$74bf444e3cd11ea5; }, function (v) { return $2f14122f1c83ab24$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2f14122f1c83ab24$export$92387174baf9b227; }, function (v) { return $2f14122f1c83ab24$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2f14122f1c83ab24$export$ec112efeb987d9c6; }, function (v) { return $2f14122f1c83ab24$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2f14122f1c83ab24$export$b706b080d889d2c9; }, function (v) { return $2f14122f1c83ab24$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2f14122f1c83ab24$export$5be5a87408f70ddc; }, function (v) { return $2f14122f1c83ab24$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2f14122f1c83ab24$export$45a5e7f76e0caa8d; }, function (v) { return $2f14122f1c83ab24$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2f14122f1c83ab24$export$455c2e768291efa6; }, function (v) { return $2f14122f1c83ab24$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2f14122f1c83ab24$export$9522e17588c12572; }, function (v) { return $2f14122f1c83ab24$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2f14122f1c83ab24$export$2110ac352bb060b9; }, function (v) { return $2f14122f1c83ab24$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2f14122f1c83ab24$export$56885ab8b9c456ab; }, function (v) { return $2f14122f1c83ab24$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2f14122f1c83ab24$export$d927fcb6adf8f9de; }, function (v) { return $2f14122f1c83ab24$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2f14122f1c83ab24$export$b82d16f27459e05a; }, function (v) { return $2f14122f1c83ab24$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2f14122f1c83ab24$export$522c17b4f5e123e8; }, function (v) { return $2f14122f1c83ab24$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2f14122f1c83ab24$export$1aabd8a0274ecfd6; }, function (v) { return $2f14122f1c83ab24$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2f14122f1c83ab24$export$9b621391a187a31a; }, function (v) { return $2f14122f1c83ab24$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2f14122f1c83ab24$export$f5bbd400c2f4426f; }, function (v) { return $2f14122f1c83ab24$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2f14122f1c83ab24$export$2b8d127b894957b9;
var $2f14122f1c83ab24$export$cea3a54a6425200c;
var $2f14122f1c83ab24$export$a7c73072b1a182ae;
var $2f14122f1c83ab24$export$9f27bc3417b4524d;
var $2f14122f1c83ab24$export$db77ccec0bb4ccac;
var $2f14122f1c83ab24$export$8392c0c9d3dcbd35;
var $2f14122f1c83ab24$export$ffb0004e005737fa;
var $2f14122f1c83ab24$export$b624eff549462981;
var $2f14122f1c83ab24$export$7897aa7841a5380c;
var $2f14122f1c83ab24$export$602eac185826482c;
var $2f14122f1c83ab24$export$e2c29f18771995cb;
var $2f14122f1c83ab24$export$5f8d39834fd61797;
var $2f14122f1c83ab24$export$74bf444e3cd11ea5;
var $2f14122f1c83ab24$export$92387174baf9b227;
var $2f14122f1c83ab24$export$ec112efeb987d9c6;
var $2f14122f1c83ab24$export$b706b080d889d2c9;
var $2f14122f1c83ab24$export$5be5a87408f70ddc;
var $2f14122f1c83ab24$export$45a5e7f76e0caa8d;
var $2f14122f1c83ab24$export$455c2e768291efa6;
var $2f14122f1c83ab24$export$9522e17588c12572;
var $2f14122f1c83ab24$export$2110ac352bb060b9;
var $2f14122f1c83ab24$export$56885ab8b9c456ab;
var $2f14122f1c83ab24$export$d927fcb6adf8f9de;
var $2f14122f1c83ab24$export$b82d16f27459e05a;
var $2f14122f1c83ab24$export$522c17b4f5e123e8;
var $2f14122f1c83ab24$export$1aabd8a0274ecfd6;
var $2f14122f1c83ab24$export$9b621391a187a31a;
var $2f14122f1c83ab24$export$f5bbd400c2f4426f;
"use strict";
var $2f14122f1c83ab24$var$b = "function" === typeof Symbol && Symbol.for, $2f14122f1c83ab24$var$c = $2f14122f1c83ab24$var$b ? Symbol.for("react.element") : 60103, $2f14122f1c83ab24$var$d = $2f14122f1c83ab24$var$b ? Symbol.for("react.portal") : 60106, $2f14122f1c83ab24$var$e = $2f14122f1c83ab24$var$b ? Symbol.for("react.fragment") : 60107, $2f14122f1c83ab24$var$f = $2f14122f1c83ab24$var$b ? Symbol.for("react.strict_mode") : 60108, $2f14122f1c83ab24$var$g = $2f14122f1c83ab24$var$b ? Symbol.for("react.profiler") : 60114, $2f14122f1c83ab24$var$h = $2f14122f1c83ab24$var$b ? Symbol.for("react.provider") : 60109, $2f14122f1c83ab24$var$k = $2f14122f1c83ab24$var$b ? Symbol.for("react.context") : 60110, $2f14122f1c83ab24$var$l = $2f14122f1c83ab24$var$b ? Symbol.for("react.async_mode") : 60111, $2f14122f1c83ab24$var$m = $2f14122f1c83ab24$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2f14122f1c83ab24$var$n = $2f14122f1c83ab24$var$b ? Symbol.for("react.forward_ref") : 60112, $2f14122f1c83ab24$var$p = $2f14122f1c83ab24$var$b ? Symbol.for("react.suspense") : 60113, $2f14122f1c83ab24$var$q = $2f14122f1c83ab24$var$b ? Symbol.for("react.suspense_list") : 60120, $2f14122f1c83ab24$var$r = $2f14122f1c83ab24$var$b ? Symbol.for("react.memo") : 60115, $2f14122f1c83ab24$var$t = $2f14122f1c83ab24$var$b ? Symbol.for("react.lazy") : 60116, $2f14122f1c83ab24$var$v = $2f14122f1c83ab24$var$b ? Symbol.for("react.block") : 60121, $2f14122f1c83ab24$var$w = $2f14122f1c83ab24$var$b ? Symbol.for("react.fundamental") : 60117, $2f14122f1c83ab24$var$x = $2f14122f1c83ab24$var$b ? Symbol.for("react.responder") : 60118, $2f14122f1c83ab24$var$y = $2f14122f1c83ab24$var$b ? Symbol.for("react.scope") : 60119;
function $2f14122f1c83ab24$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2f14122f1c83ab24$var$c:
                switch(a = a.type, a){
                    case $2f14122f1c83ab24$var$l:
                    case $2f14122f1c83ab24$var$m:
                    case $2f14122f1c83ab24$var$e:
                    case $2f14122f1c83ab24$var$g:
                    case $2f14122f1c83ab24$var$f:
                    case $2f14122f1c83ab24$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2f14122f1c83ab24$var$k:
                            case $2f14122f1c83ab24$var$n:
                            case $2f14122f1c83ab24$var$t:
                            case $2f14122f1c83ab24$var$r:
                            case $2f14122f1c83ab24$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2f14122f1c83ab24$var$d:
                return u;
        }
    }
}
function $2f14122f1c83ab24$var$A(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$m;
}
$2f14122f1c83ab24$export$2b8d127b894957b9 = $2f14122f1c83ab24$var$l;
$2f14122f1c83ab24$export$cea3a54a6425200c = $2f14122f1c83ab24$var$m;
$2f14122f1c83ab24$export$a7c73072b1a182ae = $2f14122f1c83ab24$var$k;
$2f14122f1c83ab24$export$9f27bc3417b4524d = $2f14122f1c83ab24$var$h;
$2f14122f1c83ab24$export$db77ccec0bb4ccac = $2f14122f1c83ab24$var$c;
$2f14122f1c83ab24$export$8392c0c9d3dcbd35 = $2f14122f1c83ab24$var$n;
$2f14122f1c83ab24$export$ffb0004e005737fa = $2f14122f1c83ab24$var$e;
$2f14122f1c83ab24$export$b624eff549462981 = $2f14122f1c83ab24$var$t;
$2f14122f1c83ab24$export$7897aa7841a5380c = $2f14122f1c83ab24$var$r;
$2f14122f1c83ab24$export$602eac185826482c = $2f14122f1c83ab24$var$d;
$2f14122f1c83ab24$export$e2c29f18771995cb = $2f14122f1c83ab24$var$g;
$2f14122f1c83ab24$export$5f8d39834fd61797 = $2f14122f1c83ab24$var$f;
$2f14122f1c83ab24$export$74bf444e3cd11ea5 = $2f14122f1c83ab24$var$p;
$2f14122f1c83ab24$export$92387174baf9b227 = function(a) {
    return $2f14122f1c83ab24$var$A(a) || $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$l;
};
$2f14122f1c83ab24$export$ec112efeb987d9c6 = $2f14122f1c83ab24$var$A;
$2f14122f1c83ab24$export$b706b080d889d2c9 = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$k;
};
$2f14122f1c83ab24$export$5be5a87408f70ddc = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$h;
};
$2f14122f1c83ab24$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2f14122f1c83ab24$var$c;
};
$2f14122f1c83ab24$export$455c2e768291efa6 = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$n;
};
$2f14122f1c83ab24$export$9522e17588c12572 = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$e;
};
$2f14122f1c83ab24$export$2110ac352bb060b9 = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$t;
};
$2f14122f1c83ab24$export$56885ab8b9c456ab = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$r;
};
$2f14122f1c83ab24$export$d927fcb6adf8f9de = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$d;
};
$2f14122f1c83ab24$export$b82d16f27459e05a = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$g;
};
$2f14122f1c83ab24$export$522c17b4f5e123e8 = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$f;
};
$2f14122f1c83ab24$export$1aabd8a0274ecfd6 = function(a) {
    return $2f14122f1c83ab24$var$z(a) === $2f14122f1c83ab24$var$p;
};
$2f14122f1c83ab24$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2f14122f1c83ab24$var$e || a === $2f14122f1c83ab24$var$m || a === $2f14122f1c83ab24$var$g || a === $2f14122f1c83ab24$var$f || a === $2f14122f1c83ab24$var$p || a === $2f14122f1c83ab24$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2f14122f1c83ab24$var$t || a.$$typeof === $2f14122f1c83ab24$var$r || a.$$typeof === $2f14122f1c83ab24$var$h || a.$$typeof === $2f14122f1c83ab24$var$k || a.$$typeof === $2f14122f1c83ab24$var$n || a.$$typeof === $2f14122f1c83ab24$var$w || a.$$typeof === $2f14122f1c83ab24$var$x || a.$$typeof === $2f14122f1c83ab24$var$y || a.$$typeof === $2f14122f1c83ab24$var$v);
};
$2f14122f1c83ab24$export$f5bbd400c2f4426f = $2f14122f1c83ab24$var$z;

});

parcelRegister("d21w1", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $97cca3331f49c21d$export$a7c73072b1a182ae; }, function (v) { return $97cca3331f49c21d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $97cca3331f49c21d$export$9f27bc3417b4524d; }, function (v) { return $97cca3331f49c21d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $97cca3331f49c21d$export$db77ccec0bb4ccac; }, function (v) { return $97cca3331f49c21d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $97cca3331f49c21d$export$8392c0c9d3dcbd35; }, function (v) { return $97cca3331f49c21d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $97cca3331f49c21d$export$ffb0004e005737fa; }, function (v) { return $97cca3331f49c21d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $97cca3331f49c21d$export$b624eff549462981; }, function (v) { return $97cca3331f49c21d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $97cca3331f49c21d$export$7897aa7841a5380c; }, function (v) { return $97cca3331f49c21d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $97cca3331f49c21d$export$602eac185826482c; }, function (v) { return $97cca3331f49c21d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $97cca3331f49c21d$export$e2c29f18771995cb; }, function (v) { return $97cca3331f49c21d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $97cca3331f49c21d$export$5f8d39834fd61797; }, function (v) { return $97cca3331f49c21d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $97cca3331f49c21d$export$74bf444e3cd11ea5; }, function (v) { return $97cca3331f49c21d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $97cca3331f49c21d$export$998bcd577473dd93; }, function (v) { return $97cca3331f49c21d$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $97cca3331f49c21d$export$92387174baf9b227; }, function (v) { return $97cca3331f49c21d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $97cca3331f49c21d$export$ec112efeb987d9c6; }, function (v) { return $97cca3331f49c21d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $97cca3331f49c21d$export$b706b080d889d2c9; }, function (v) { return $97cca3331f49c21d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $97cca3331f49c21d$export$5be5a87408f70ddc; }, function (v) { return $97cca3331f49c21d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $97cca3331f49c21d$export$45a5e7f76e0caa8d; }, function (v) { return $97cca3331f49c21d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $97cca3331f49c21d$export$455c2e768291efa6; }, function (v) { return $97cca3331f49c21d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $97cca3331f49c21d$export$9522e17588c12572; }, function (v) { return $97cca3331f49c21d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $97cca3331f49c21d$export$2110ac352bb060b9; }, function (v) { return $97cca3331f49c21d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $97cca3331f49c21d$export$56885ab8b9c456ab; }, function (v) { return $97cca3331f49c21d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $97cca3331f49c21d$export$d927fcb6adf8f9de; }, function (v) { return $97cca3331f49c21d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $97cca3331f49c21d$export$b82d16f27459e05a; }, function (v) { return $97cca3331f49c21d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $97cca3331f49c21d$export$522c17b4f5e123e8; }, function (v) { return $97cca3331f49c21d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $97cca3331f49c21d$export$1aabd8a0274ecfd6; }, function (v) { return $97cca3331f49c21d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $97cca3331f49c21d$export$3d6c20d97e46b957; }, function (v) { return $97cca3331f49c21d$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $97cca3331f49c21d$export$9b621391a187a31a; }, function (v) { return $97cca3331f49c21d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $97cca3331f49c21d$export$f5bbd400c2f4426f; }, function (v) { return $97cca3331f49c21d$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $97cca3331f49c21d$export$a7c73072b1a182ae;
var $97cca3331f49c21d$export$9f27bc3417b4524d;
var $97cca3331f49c21d$export$db77ccec0bb4ccac;
var $97cca3331f49c21d$export$8392c0c9d3dcbd35;
var $97cca3331f49c21d$export$ffb0004e005737fa;
var $97cca3331f49c21d$export$b624eff549462981;
var $97cca3331f49c21d$export$7897aa7841a5380c;
var $97cca3331f49c21d$export$602eac185826482c;
var $97cca3331f49c21d$export$e2c29f18771995cb;
var $97cca3331f49c21d$export$5f8d39834fd61797;
var $97cca3331f49c21d$export$74bf444e3cd11ea5;
var $97cca3331f49c21d$export$998bcd577473dd93;
var $97cca3331f49c21d$export$92387174baf9b227;
var $97cca3331f49c21d$export$ec112efeb987d9c6;
var $97cca3331f49c21d$export$b706b080d889d2c9;
var $97cca3331f49c21d$export$5be5a87408f70ddc;
var $97cca3331f49c21d$export$45a5e7f76e0caa8d;
var $97cca3331f49c21d$export$455c2e768291efa6;
var $97cca3331f49c21d$export$9522e17588c12572;
var $97cca3331f49c21d$export$2110ac352bb060b9;
var $97cca3331f49c21d$export$56885ab8b9c456ab;
var $97cca3331f49c21d$export$d927fcb6adf8f9de;
var $97cca3331f49c21d$export$b82d16f27459e05a;
var $97cca3331f49c21d$export$522c17b4f5e123e8;
var $97cca3331f49c21d$export$1aabd8a0274ecfd6;
var $97cca3331f49c21d$export$3d6c20d97e46b957;
var $97cca3331f49c21d$export$9b621391a187a31a;
var $97cca3331f49c21d$export$f5bbd400c2f4426f;
"use strict";
var $97cca3331f49c21d$var$b = Symbol.for("react.element"), $97cca3331f49c21d$var$c = Symbol.for("react.portal"), $97cca3331f49c21d$var$d = Symbol.for("react.fragment"), $97cca3331f49c21d$var$e = Symbol.for("react.strict_mode"), $97cca3331f49c21d$var$f = Symbol.for("react.profiler"), $97cca3331f49c21d$var$g = Symbol.for("react.provider"), $97cca3331f49c21d$var$h = Symbol.for("react.context"), $97cca3331f49c21d$var$k = Symbol.for("react.server_context"), $97cca3331f49c21d$var$l = Symbol.for("react.forward_ref"), $97cca3331f49c21d$var$m = Symbol.for("react.suspense"), $97cca3331f49c21d$var$n = Symbol.for("react.suspense_list"), $97cca3331f49c21d$var$p = Symbol.for("react.memo"), $97cca3331f49c21d$var$q = Symbol.for("react.lazy"), $97cca3331f49c21d$var$t = Symbol.for("react.offscreen"), $97cca3331f49c21d$var$u;
$97cca3331f49c21d$var$u = Symbol.for("react.module.reference");
function $97cca3331f49c21d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $97cca3331f49c21d$var$b:
                switch(a = a.type, a){
                    case $97cca3331f49c21d$var$d:
                    case $97cca3331f49c21d$var$f:
                    case $97cca3331f49c21d$var$e:
                    case $97cca3331f49c21d$var$m:
                    case $97cca3331f49c21d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $97cca3331f49c21d$var$k:
                            case $97cca3331f49c21d$var$h:
                            case $97cca3331f49c21d$var$l:
                            case $97cca3331f49c21d$var$q:
                            case $97cca3331f49c21d$var$p:
                            case $97cca3331f49c21d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $97cca3331f49c21d$var$c:
                return r;
        }
    }
}
$97cca3331f49c21d$export$a7c73072b1a182ae = $97cca3331f49c21d$var$h;
$97cca3331f49c21d$export$9f27bc3417b4524d = $97cca3331f49c21d$var$g;
$97cca3331f49c21d$export$db77ccec0bb4ccac = $97cca3331f49c21d$var$b;
$97cca3331f49c21d$export$8392c0c9d3dcbd35 = $97cca3331f49c21d$var$l;
$97cca3331f49c21d$export$ffb0004e005737fa = $97cca3331f49c21d$var$d;
$97cca3331f49c21d$export$b624eff549462981 = $97cca3331f49c21d$var$q;
$97cca3331f49c21d$export$7897aa7841a5380c = $97cca3331f49c21d$var$p;
$97cca3331f49c21d$export$602eac185826482c = $97cca3331f49c21d$var$c;
$97cca3331f49c21d$export$e2c29f18771995cb = $97cca3331f49c21d$var$f;
$97cca3331f49c21d$export$5f8d39834fd61797 = $97cca3331f49c21d$var$e;
$97cca3331f49c21d$export$74bf444e3cd11ea5 = $97cca3331f49c21d$var$m;
$97cca3331f49c21d$export$998bcd577473dd93 = $97cca3331f49c21d$var$n;
$97cca3331f49c21d$export$92387174baf9b227 = function() {
    return !1;
};
$97cca3331f49c21d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$97cca3331f49c21d$export$b706b080d889d2c9 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$h;
};
$97cca3331f49c21d$export$5be5a87408f70ddc = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$g;
};
$97cca3331f49c21d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $97cca3331f49c21d$var$b;
};
$97cca3331f49c21d$export$455c2e768291efa6 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$l;
};
$97cca3331f49c21d$export$9522e17588c12572 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$d;
};
$97cca3331f49c21d$export$2110ac352bb060b9 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$q;
};
$97cca3331f49c21d$export$56885ab8b9c456ab = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$p;
};
$97cca3331f49c21d$export$d927fcb6adf8f9de = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$c;
};
$97cca3331f49c21d$export$b82d16f27459e05a = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$f;
};
$97cca3331f49c21d$export$522c17b4f5e123e8 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$e;
};
$97cca3331f49c21d$export$1aabd8a0274ecfd6 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$m;
};
$97cca3331f49c21d$export$3d6c20d97e46b957 = function(a) {
    return $97cca3331f49c21d$var$v(a) === $97cca3331f49c21d$var$n;
};
$97cca3331f49c21d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $97cca3331f49c21d$var$d || a === $97cca3331f49c21d$var$f || a === $97cca3331f49c21d$var$e || a === $97cca3331f49c21d$var$m || a === $97cca3331f49c21d$var$n || a === $97cca3331f49c21d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $97cca3331f49c21d$var$q || a.$$typeof === $97cca3331f49c21d$var$p || a.$$typeof === $97cca3331f49c21d$var$g || a.$$typeof === $97cca3331f49c21d$var$h || a.$$typeof === $97cca3331f49c21d$var$l || a.$$typeof === $97cca3331f49c21d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$97cca3331f49c21d$export$f5bbd400c2f4426f = $97cca3331f49c21d$var$v;

});

parcelRegister("48IOt", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $303aabbbf76adb49$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $303aabbbf76adb49$export$2e2bcd8739ae039 = fn;

});

var $3c47adbabe8a32cb$exports = {};
"use strict";

$3c47adbabe8a32cb$exports = (parcelRequire("hi5z5"));


parcelRequire("4Iuzv");
var $21fa618cfc67d6ae$exports = {};

$parcel$export($21fa618cfc67d6ae$exports, "createRoot", function () { return $21fa618cfc67d6ae$export$882461b6382ed46c; }, function (v) { return $21fa618cfc67d6ae$export$882461b6382ed46c = v; });
$parcel$export($21fa618cfc67d6ae$exports, "hydrateRoot", function () { return $21fa618cfc67d6ae$export$757ceba2d55c277e; }, function (v) { return $21fa618cfc67d6ae$export$757ceba2d55c277e = v; });
var $21fa618cfc67d6ae$export$882461b6382ed46c;
var $21fa618cfc67d6ae$export$757ceba2d55c277e;
"use strict";
var $d0525dc7624af49b$exports = {};
"use strict";
function $d0525dc7624af49b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0525dc7624af49b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0525dc7624af49b$var$checkDCE();

$d0525dc7624af49b$exports = (parcelRequire("68oCn"));


var $21fa618cfc67d6ae$var$i;
$21fa618cfc67d6ae$export$882461b6382ed46c = $d0525dc7624af49b$exports.createRoot;
$21fa618cfc67d6ae$export$757ceba2d55c277e = $d0525dc7624af49b$exports.hydrateRoot;


/**
 * React Router DOM v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @remix-run/router v1.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f29acb16f05b6a44$var$_extends() {
    $f29acb16f05b6a44$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f29acb16f05b6a44$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f29acb16f05b6a44$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f29acb16f05b6a44$export$e19cd5f9376f8cee || ($f29acb16f05b6a44$export$e19cd5f9376f8cee = {}));
const $f29acb16f05b6a44$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f29acb16f05b6a44$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f29acb16f05b6a44$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f29acb16f05b6a44$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f29acb16f05b6a44$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f29acb16f05b6a44$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f29acb16f05b6a44$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f29acb16f05b6a44$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f29acb16f05b6a44$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f29acb16f05b6a44$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f29acb16f05b6a44$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f29acb16f05b6a44$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f29acb16f05b6a44$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f29acb16f05b6a44$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f29acb16f05b6a44$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
        $f29acb16f05b6a44$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $f29acb16f05b6a44$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f29acb16f05b6a44$var$ResultType || ($f29acb16f05b6a44$var$ResultType = {}));
const $f29acb16f05b6a44$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f29acb16f05b6a44$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f29acb16f05b6a44$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f29acb16f05b6a44$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($f29acb16f05b6a44$var$isIndexRoute(route)) {
            let indexRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f29acb16f05b6a44$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $f29acb16f05b6a44$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f29acb16f05b6a44$var$flattenRoutes(routes);
    $f29acb16f05b6a44$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $f29acb16f05b6a44$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $f29acb16f05b6a44$var$safelyDecodeURI(pathname));
    return matches;
}
function $f29acb16f05b6a44$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f29acb16f05b6a44$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $f29acb16f05b6a44$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f29acb16f05b6a44$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f29acb16f05b6a44$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f29acb16f05b6a44$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f29acb16f05b6a44$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f29acb16f05b6a44$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f29acb16f05b6a44$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f29acb16f05b6a44$var$paramRe = /^:\w+$/;
const $f29acb16f05b6a44$var$dynamicSegmentValue = 3;
const $f29acb16f05b6a44$var$indexRouteValue = 2;
const $f29acb16f05b6a44$var$emptySegmentValue = 1;
const $f29acb16f05b6a44$var$staticSegmentValue = 10;
const $f29acb16f05b6a44$var$splatPenalty = -2;
const $f29acb16f05b6a44$var$isSplat = (s)=>s === "*";
function $f29acb16f05b6a44$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f29acb16f05b6a44$var$isSplat)) initialScore += $f29acb16f05b6a44$var$splatPenalty;
    if (index) initialScore += $f29acb16f05b6a44$var$indexRouteValue;
    return segments.filter((s)=>!$f29acb16f05b6a44$var$isSplat(s)).reduce((score, segment)=>score + ($f29acb16f05b6a44$var$paramRe.test(segment) ? $f29acb16f05b6a44$var$dynamicSegmentValue : segment === "" ? $f29acb16f05b6a44$var$emptySegmentValue : $f29acb16f05b6a44$var$staticSegmentValue), initialScore);
}
function $f29acb16f05b6a44$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $f29acb16f05b6a44$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f29acb16f05b6a44$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f29acb16f05b6a44$export$a5c6d149b50c1d86($f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f29acb16f05b6a44$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $f29acb16f05b6a44$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $f29acb16f05b6a44$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $f29acb16f05b6a44$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $f29acb16f05b6a44$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $f29acb16f05b6a44$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f29acb16f05b6a44$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f29acb16f05b6a44$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $f29acb16f05b6a44$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $f29acb16f05b6a44$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f29acb16f05b6a44$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f29acb16f05b6a44$var$normalizeSearch(search),
        hash: $f29acb16f05b6a44$var$normalizeHash(hash)
    };
}
function $f29acb16f05b6a44$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f29acb16f05b6a44$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f29acb16f05b6a44$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f29acb16f05b6a44$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f29acb16f05b6a44$var$_extends({}, toArg);
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f29acb16f05b6a44$var$getInvalidPathError("?", "pathname", "search", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "pathname", "hash", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f29acb16f05b6a44$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $f29acb16f05b6a44$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f29acb16f05b6a44$export$42a99a7a4bc0e76a extends Error {
}
class $f29acb16f05b6a44$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f29acb16f05b6a44$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f29acb16f05b6a44$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f29acb16f05b6a44$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f29acb16f05b6a44$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $f29acb16f05b6a44$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f29acb16f05b6a44$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f29acb16f05b6a44$var$unwrapTrackedPromise(value) {
    if (!$f29acb16f05b6a44$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $f29acb16f05b6a44$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f29acb16f05b6a44$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $f29acb16f05b6a44$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f29acb16f05b6a44$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f29acb16f05b6a44$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f29acb16f05b6a44$var$validMutationMethods = new Set($f29acb16f05b6a44$var$validMutationMethodsArr);
const $f29acb16f05b6a44$var$validRequestMethodsArr = [
    "get",
    ...$f29acb16f05b6a44$var$validMutationMethodsArr
];
const $f29acb16f05b6a44$var$validRequestMethods = new Set($f29acb16f05b6a44$var$validRequestMethodsArr);
const $f29acb16f05b6a44$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f29acb16f05b6a44$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $f29acb16f05b6a44$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $f29acb16f05b6a44$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f29acb16f05b6a44$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $f29acb16f05b6a44$var$isServer = !$f29acb16f05b6a44$var$isBrowser;
const $f29acb16f05b6a44$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    }); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f29acb16f05b6a44$export$baddd0131ee8c05b(init) {
    $f29acb16f05b6a44$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
     // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/"; // Config driven behavior flags
    let future = $f29acb16f05b6a44$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $f29acb16f05b6a44$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $f29acb16f05b6a44$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($f29acb16f05b6a44$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f29acb16f05b6a44$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f29acb16f05b6a44$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, location, basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission.
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if (state.initialized && $f29acb16f05b6a44$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f29acb16f05b6a44$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$f29acb16f05b6a44$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $f29acb16f05b6a44$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f29acb16f05b6a44$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $f29acb16f05b6a44$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $f29acb16f05b6a44$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $f29acb16f05b6a44$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f29acb16f05b6a44$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($f29acb16f05b6a44$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        }); // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f29acb16f05b6a44$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f29acb16f05b6a44$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $f29acb16f05b6a44$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($f29acb16f05b6a44$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $f29acb16f05b6a44$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $f29acb16f05b6a44$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $f29acb16f05b6a44$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $f29acb16f05b6a44$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($f29acb16f05b6a44$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(actionResult)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f29acb16f05b6a44$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f29acb16f05b6a44$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f29acb16f05b6a44$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($f29acb16f05b6a44$var$_extends({
                errors: errors,
                loaderData: $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $f29acb16f05b6a44$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $f29acb16f05b6a44$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) result = await $f29acb16f05b6a44$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $f29acb16f05b6a44$var$createLocation(state.location, redirect.location, $f29acb16f05b6a44$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $f29acb16f05b6a44$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $f29acb16f05b6a44$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace : $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f29acb16f05b6a44$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$f29acb16f05b6a44$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $f29acb16f05b6a44$var$callLoaderOrAction("loader", $f29acb16f05b6a44$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $f29acb16f05b6a44$var$ResultType.error,
                        error: $f29acb16f05b6a44$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $f29acb16f05b6a44$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f29acb16f05b6a44$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f29acb16f05b6a44$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f29acb16f05b6a44$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$f29acb16f05b6a44$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$f29acb16f05b6a44$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f29acb16f05b6a44$export$4d0306f8f6a4585b = Symbol("deferred");
function $f29acb16f05b6a44$export$3336b097a6fbc59a(routes, opts) {
    $f29acb16f05b6a44$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f29acb16f05b6a44$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f29acb16f05b6a44$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f29acb16f05b6a44$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $f29acb16f05b6a44$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f29acb16f05b6a44$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f29acb16f05b6a44$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $f29acb16f05b6a44$var$isResponse(result) ? result : $f29acb16f05b6a44$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($f29acb16f05b6a44$var$isQueryRouteResponse(e)) {
                if (e.type === $f29acb16f05b6a44$var$ResultType.error && !$f29acb16f05b6a44$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f29acb16f05b6a44$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        } else {
            result = await $f29acb16f05b6a44$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f29acb16f05b6a44$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $f29acb16f05b6a44$var$_extends({}, context, {
                statusCode: $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $f29acb16f05b6a44$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $f29acb16f05b6a44$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $f29acb16f05b6a44$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$f29acb16f05b6a44$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f29acb16f05b6a44$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f29acb16f05b6a44$export$fec11da027c70692(routes, context, error) {
    let newContext = $f29acb16f05b6a44$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f29acb16f05b6a44$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $f29acb16f05b6a44$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    } // Resolve the relative path
    let path = $f29acb16f05b6a44$export$cae722b0cc860f13(to ? to : ".", $f29acb16f05b6a44$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path"); // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    } // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$f29acb16f05b6a44$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f29acb16f05b6a44$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f29acb16f05b6a44$export$fe53371bee54353d(path);
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f29acb16f05b6a44$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f29acb16f05b6a44$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f29acb16f05b6a44$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $f29acb16f05b6a44$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f29acb16f05b6a44$export$8ccf933b0513f8d0(path);
    let searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.formData); // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f29acb16f05b6a44$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f29acb16f05b6a44$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $f29acb16f05b6a44$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location); // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($f29acb16f05b6a44$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f29acb16f05b6a44$var$shouldRevalidateLoader(match, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f29acb16f05b6a44$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $f29acb16f05b6a44$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $f29acb16f05b6a44$var$shouldRevalidateLoader(fetcherMatch, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f29acb16f05b6a44$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $f29acb16f05b6a44$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f29acb16f05b6a44$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f29acb16f05b6a44$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f29acb16f05b6a44$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$f29acb16f05b6a44$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f29acb16f05b6a44$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $f29acb16f05b6a44$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f29acb16f05b6a44$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f29acb16f05b6a44$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $f29acb16f05b6a44$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($f29acb16f05b6a44$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($f29acb16f05b6a44$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $f29acb16f05b6a44$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) location = $f29acb16f05b6a44$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $f29acb16f05b6a44$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $f29acb16f05b6a44$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $f29acb16f05b6a44$var$ResultType.error) return {
            type: resultType,
            error: new $f29acb16f05b6a44$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $f29acb16f05b6a44$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($f29acb16f05b6a44$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $f29acb16f05b6a44$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f29acb16f05b6a44$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f29acb16f05b6a44$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $f29acb16f05b6a44$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $f29acb16f05b6a44$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $f29acb16f05b6a44$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f29acb16f05b6a44$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f29acb16f05b6a44$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f29acb16f05b6a44$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f29acb16f05b6a44$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f29acb16f05b6a44$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f29acb16f05b6a44$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f29acb16f05b6a44$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $f29acb16f05b6a44$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $f29acb16f05b6a44$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) return result;
    }
}
function $f29acb16f05b6a44$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) : path;
    return $f29acb16f05b6a44$export$fe53371bee54353d($f29acb16f05b6a44$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f29acb16f05b6a44$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
     // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f29acb16f05b6a44$var$isDeferredResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.deferred;
}
function $f29acb16f05b6a44$var$isErrorResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.error;
}
function $f29acb16f05b6a44$var$isRedirectResult(result) {
    return (result && result.type) === $f29acb16f05b6a44$var$ResultType.redirect;
}
function $f29acb16f05b6a44$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f29acb16f05b6a44$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f29acb16f05b6a44$var$isRedirectResponse(result) {
    if (!$f29acb16f05b6a44$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f29acb16f05b6a44$var$isQueryRouteResponse(obj) {
    return obj && $f29acb16f05b6a44$var$isResponse(obj.response) && (obj.type === $f29acb16f05b6a44$var$ResultType.data || $f29acb16f05b6a44$var$ResultType.error);
}
function $f29acb16f05b6a44$var$isValidMethod(method) {
    return $f29acb16f05b6a44$var$validRequestMethods.has(method.toLowerCase());
}
function $f29acb16f05b6a44$var$isMutationMethod(method) {
    return $f29acb16f05b6a44$var$validMutationMethods.has(method.toLowerCase());
}
async function $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f29acb16f05b6a44$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $f29acb16f05b6a44$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $f29acb16f05b6a44$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $f29acb16f05b6a44$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f29acb16f05b6a44$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $f29acb16f05b6a44$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f29acb16f05b6a44$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f29acb16f05b6a44$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f29acb16f05b6a44$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");

function $175a2504a1bf07a5$var$_extends() {
    $175a2504a1bf07a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $175a2504a1bf07a5$var$_extends.apply(this, arguments);
}
const $175a2504a1bf07a5$export$3add0d5dce533e2e = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$145dfa71566a64dc = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$var$AwaitContext = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$26749e8557646306 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$c7914228fb69b0f5 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$9072aa6dd1f93057 = /*#__PURE__*/ $4Iuzv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $175a2504a1bf07a5$var$RouteErrorContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $175a2504a1bf07a5$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $175a2504a1bf07a5$export$9c954a9d03d32f4a() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $175a2504a1bf07a5$export$45d76561a5302f2b() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $175a2504a1bf07a5$export$1b3f31771c5d07c() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $175a2504a1bf07a5$export$6c330e8992e8a295(pattern) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $175a2504a1bf07a5$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered."; // Mute warnings for calls to useNavigate in SSR environments
function $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4Iuzv.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $175a2504a1bf07a5$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057); // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $175a2504a1bf07a5$var$useNavigateStable() : $175a2504a1bf07a5$var$useNavigateUnstable();
}
function $175a2504a1bf07a5$var$useNavigateUnstable() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$OutletContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $175a2504a1bf07a5$export$4138103a3ae699cc() {
    return $4Iuzv.useContext($175a2504a1bf07a5$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $175a2504a1bf07a5$export$a3be3530d8e40d0b(context) {
    let outlet = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $175a2504a1bf07a5$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $175a2504a1bf07a5$export$5d3fca4a98652595(routes, locationArg) {
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: parentMatches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $f29acb16f05b6a44$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $175a2504a1bf07a5$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $175a2504a1bf07a5$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $175a2504a1bf07a5$var$DefaultErrorComponent() {
    let error = $175a2504a1bf07a5$export$ed527bf60f6e05f2();
    let message = (0, $f29acb16f05b6a44$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4Iuzv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4Iuzv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $175a2504a1bf07a5$var$defaultErrorElement = /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DefaultErrorComponent, null);
class $175a2504a1bf07a5$var$RenderErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $175a2504a1bf07a5$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $175a2504a1bf07a5$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $175a2504a1bf07a5$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4Iuzv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $175a2504a1bf07a5$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($175a2504a1bf07a5$var$DataRouterHook || ($175a2504a1bf07a5$var$DataRouterHook = {}));
var $175a2504a1bf07a5$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($175a2504a1bf07a5$var$DataRouterStateHook || ($175a2504a1bf07a5$var$DataRouterStateHook = {}));
function $175a2504a1bf07a5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $175a2504a1bf07a5$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $175a2504a1bf07a5$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext($175a2504a1bf07a5$export$145dfa71566a64dc);
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
function $175a2504a1bf07a5$var$useRouteContext(hookName) {
    let route = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return route;
} // Internal version with hookName-aware debugging
function $175a2504a1bf07a5$var$useCurrentRouteId(hookName) {
    let route = $175a2504a1bf07a5$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $175a2504a1bf07a5$export$5fc8298006ad9e58() {
    return $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $175a2504a1bf07a5$export$d0fd4b7106de2769() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $175a2504a1bf07a5$export$600dc272ed516c15() {
    let dataRouterContext = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseRevalidator);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $175a2504a1bf07a5$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseMatches);
    return $4Iuzv.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $175a2504a1bf07a5$export$1448a5050d252c4d() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $175a2504a1bf07a5$export$fd5d37484eab868d(routeId) {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $175a2504a1bf07a5$export$fdc00f3f26066d5e() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseActionData);
    let route = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $175a2504a1bf07a5$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4Iuzv.useContext($175a2504a1bf07a5$var$RouteErrorContext);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $175a2504a1bf07a5$export$78a72ddb39bdd145() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $175a2504a1bf07a5$export$17f53340677d5831() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $175a2504a1bf07a5$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $175a2504a1bf07a5$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseBlocker);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $4Iuzv.useState(()=>String(++$175a2504a1bf07a5$var$blockerId));
    let blockerFunction = $4Iuzv.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $4Iuzv.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $175a2504a1bf07a5$var$useNavigateStable() {
    let { router: router } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseNavigateStable);
    let id = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $175a2504a1bf07a5$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$alreadyWarned = {};
function $175a2504a1bf07a5$var$warningOnce(key, cond, message) {
    if (!cond && !$175a2504a1bf07a5$var$alreadyWarned[key]) $175a2504a1bf07a5$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $175a2504a1bf07a5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setState] = $4Iuzv.useState(router.state);
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $175a2504a1bf07a5$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $175a2504a1bf07a5$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref3;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $175a2504a1bf07a5$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let navigate = $175a2504a1bf07a5$export$9770f232ac06a008(); // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, (0, $f29acb16f05b6a44$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4Iuzv.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $175a2504a1bf07a5$export$910ae8079b2c2852(props) {
    return $175a2504a1bf07a5$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $175a2504a1bf07a5$export$e7b0ac011bb776c6(_props) {
    (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $175a2504a1bf07a5$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4Iuzv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4Iuzv.useMemo(()=>{
        let trailingPathname = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $175a2504a1bf07a5$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $175a2504a1bf07a5$export$5d3fca4a98652595($175a2504a1bf07a5$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $175a2504a1bf07a5$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$ResolveAwait, null, children));
}
var $175a2504a1bf07a5$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($175a2504a1bf07a5$var$AwaitRenderStatus || ($175a2504a1bf07a5$var$AwaitRenderStatus = {}));
const $175a2504a1bf07a5$var$neverSettledPromise = new Promise(()=>{});
class $175a2504a1bf07a5$var$AwaitErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $175a2504a1bf07a5$var$AwaitRenderStatus.error : promise._data !== undefined ? $175a2504a1bf07a5$var$AwaitRenderStatus.success : $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && promise._error instanceof (0, $f29acb16f05b6a44$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $175a2504a1bf07a5$var$neverSettledPromise;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $175a2504a1bf07a5$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $175a2504a1bf07a5$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $175a2504a1bf07a5$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4Iuzv.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4Iuzv.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4Iuzv.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $175a2504a1bf07a5$export$e7b0ac011bb776c6) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $175a2504a1bf07a5$export$daf73786167a7f72(matches) {
    return $175a2504a1bf07a5$var$_renderMatches(matches);
}
function $175a2504a1bf07a5$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4Iuzv.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4Iuzv.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $175a2504a1bf07a5$export$f30f7e456d254e83(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $175a2504a1bf07a5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $175a2504a1bf07a5$export$52b333d321859367
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $c34e9f2261c19895$var$_extends() {
    $c34e9f2261c19895$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c34e9f2261c19895$var$_extends.apply(this, arguments);
}
function $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c34e9f2261c19895$var$defaultMethod = "get";
const $c34e9f2261c19895$var$defaultEncType = "application/x-www-form-urlencoded";
function $c34e9f2261c19895$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c34e9f2261c19895$var$isButtonElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c34e9f2261c19895$var$isFormElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c34e9f2261c19895$var$isInputElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c34e9f2261c19895$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c34e9f2261c19895$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c34e9f2261c19895$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c34e9f2261c19895$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $c34e9f2261c19895$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($c34e9f2261c19895$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $c34e9f2261c19895$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($c34e9f2261c19895$var$isButtonElement(target) || $c34e9f2261c19895$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $c34e9f2261c19895$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($c34e9f2261c19895$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $c34e9f2261c19895$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $c34e9f2261c19895$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $c34e9f2261c19895$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $c34e9f2261c19895$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $c34e9f2261c19895$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $c34e9f2261c19895$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367)
    }).initialize();
}
function $c34e9f2261c19895$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367)
    }).initialize();
}
function $c34e9f2261c19895$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c34e9f2261c19895$var$_extends({}, state, {
        errors: $c34e9f2261c19895$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c34e9f2261c19895$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f29acb16f05b6a44$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c34e9f2261c19895$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c34e9f2261c19895$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c34e9f2261c19895$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $c34e9f2261c19895$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $c34e9f2261c19895$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4Iuzv.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref4, $c34e9f2261c19895$var$_excluded);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($c34e9f2261c19895$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    } // Rendered into <a href> for relative URLs
    let href = (0, $175a2504a1bf07a5$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c34e9f2261c19895$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4Iuzv.createElement("a", $c34e9f2261c19895$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $c34e9f2261c19895$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4Iuzv.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref5, $c34e9f2261c19895$var$_excluded2);
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let routerState = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    let { navigator: navigator } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$a6c7ac8248d6e38a, $c34e9f2261c19895$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c34e9f2261c19895$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4Iuzv.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$var$FormImpl, $c34e9f2261c19895$var$_extends({}, props, {
        ref: ref
    }));
});
const $c34e9f2261c19895$var$FormImpl = /*#__PURE__*/ $4Iuzv.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $c34e9f2261c19895$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref6, $c34e9f2261c19895$var$_excluded3);
    let submit = $c34e9f2261c19895$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $c34e9f2261c19895$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $4Iuzv.createElement("form", $c34e9f2261c19895$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c34e9f2261c19895$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $c34e9f2261c19895$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c34e9f2261c19895$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($c34e9f2261c19895$var$DataRouterHook || ($c34e9f2261c19895$var$DataRouterHook = {}));
var $c34e9f2261c19895$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c34e9f2261c19895$var$DataRouterStateHook || ($c34e9f2261c19895$var$DataRouterStateHook = {}));
function $c34e9f2261c19895$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c34e9f2261c19895$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$3add0d5dce533e2e));
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c34e9f2261c19895$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c34e9f2261c19895$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4Iuzv.useCallback((event)=>{
        if ($c34e9f2261c19895$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f29acb16f05b6a44$export$fe53371bee54353d)(location) === (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c34e9f2261c19895$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4Iuzv.useRef($c34e9f2261c19895$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4Iuzv.useRef(false);
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let searchParams = $4Iuzv.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c34e9f2261c19895$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let setSearchParams = $4Iuzv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c34e9f2261c19895$export$47c85c6e3a081d3() {
    return $c34e9f2261c19895$var$useSubmitImpl();
}
function $c34e9f2261c19895$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let currentRouteId = (0, $175a2504a1bf07a5$export$5fc8298006ad9e58)();
    return $4Iuzv.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action, method: method, encType: encType, formData: formData } = $c34e9f2261c19895$var$getFormSubmissionInfo(target, options, basename); // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $c34e9f2261c19895$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
} // v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c34e9f2261c19895$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let routeContext = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    !routeContext && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c34e9f2261c19895$var$_extends({}, (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
}
function $c34e9f2261c19895$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $4Iuzv.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$var$FormImpl, $c34e9f2261c19895$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $c34e9f2261c19895$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c34e9f2261c19895$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseFetcher);
    let route = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $4Iuzv.useState(()=>String(++$c34e9f2261c19895$var$fetcherId));
    let [Form] = $4Iuzv.useState(()=>{
        !routeId && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        return $c34e9f2261c19895$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $4Iuzv.useState(()=>(href)=>{
            !router && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
            !routeId && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $c34e9f2261c19895$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $4Iuzv.useMemo(()=>$c34e9f2261c19895$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $4Iuzv.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c34e9f2261c19895$export$fa996778a3a31087() {
    let state = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c34e9f2261c19895$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c34e9f2261c19895$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let matches = (0, $175a2504a1bf07a5$export$2378eb7f5ff86053)();
    let navigation = (0, $175a2504a1bf07a5$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $4Iuzv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $c34e9f2261c19895$var$usePageHide($4Iuzv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c34e9f2261c19895$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c34e9f2261c19895$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c34e9f2261c19895$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c34e9f2261c19895$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c34e9f2261c19895$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $175a2504a1bf07a5$export$2af03a1de5c0910)(when);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $lhInO = parcelRequire("lhInO");
var $0f7f62120aa48ea1$exports = {};
"use strict";

$0f7f62120aa48ea1$exports = (parcelRequire("lCXfb"));





// Default to a dummy "batch" implementation that just runs the callback
function $621da53f59db0be3$var$defaultNoopBatch(callback) {
    callback();
}
let $621da53f59db0be3$var$batch = $621da53f59db0be3$var$defaultNoopBatch; // Allow injecting another batching function later
const $621da53f59db0be3$export$4b9874722d0da7bc = (newBatch)=>$621da53f59db0be3$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $621da53f59db0be3$export$fc47d4c0ba3bd2c6 = ()=>$621da53f59db0be3$var$batch;



var $4Iuzv = parcelRequire("4Iuzv");

var $4Iuzv = parcelRequire("4Iuzv");

var $4Iuzv = parcelRequire("4Iuzv");
const $04688d22da4f5f87$var$ContextKey = Symbol.for(`react-redux-context-${(0, $4Iuzv.version)}`);
const $04688d22da4f5f87$var$gT = globalThis;
function $04688d22da4f5f87$var$getContext() {
    let realContext = $04688d22da4f5f87$var$gT[$04688d22da4f5f87$var$ContextKey];
    if (!realContext) {
        realContext = (0, $4Iuzv.createContext)(null);
        $04688d22da4f5f87$var$gT[$04688d22da4f5f87$var$ContextKey] = realContext;
    }
    return realContext;
}
const $04688d22da4f5f87$export$cc80c08dc91f1c00 = /*#__PURE__*/ new Proxy({}, /*#__PURE__*/ new Proxy({}, {
    get (_, handler) {
        const target = $04688d22da4f5f87$var$getContext(); // @ts-ignore
        return (_target, ...args)=>Reflect[handler](target, ...args);
    }
}));
var $04688d22da4f5f87$export$2e2bcd8739ae039 = $04688d22da4f5f87$export$cc80c08dc91f1c00;


function $2a86e1d739a547e1$export$d4d6226d5fc61558(context = (0, $04688d22da4f5f87$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $4Iuzv.useContext)(context);
        return contextValue;
    };
}
const $2a86e1d739a547e1$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $2a86e1d739a547e1$export$d4d6226d5fc61558();



const $b7817f958742d384$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $4003a0143258f2e3$var$useSyncExternalStoreWithSelector = (0, $b7817f958742d384$export$20656a4825650bd0);
const $4003a0143258f2e3$export$e2e6e3f3f3b782e3 = (fn)=>{
    $4003a0143258f2e3$var$useSyncExternalStoreWithSelector = fn;
};
const $4003a0143258f2e3$var$refEquality = (a, b)=>a === b;
function $4003a0143258f2e3$export$2b53f90d2bd1cbfb(context = (0, $04688d22da4f5f87$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $04688d22da4f5f87$export$cc80c08dc91f1c00) ? (0, $2a86e1d739a547e1$export$c1275ca9a6fd3ec5) : (0, $2a86e1d739a547e1$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $4003a0143258f2e3$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $4Iuzv.useRef)(true);
        const wrappedSelector = (0, $4Iuzv.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $4003a0143258f2e3$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $4Iuzv.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $4003a0143258f2e3$export$2105062e25df4afe = /*#__PURE__*/ $4003a0143258f2e3$export$2b53f90d2bd1cbfb();


function $78c60c144526c0e4$export$2e2bcd8739ae039() {
    $78c60c144526c0e4$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $78c60c144526c0e4$export$2e2bcd8739ae039.apply(this, arguments);
}


function $c34fbb8b67150408$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $73bbc0bea28e4f9a$exports = {};
"use strict";
var $300d96996704c996$exports = {};
"use strict";

$300d96996704c996$exports = (parcelRequire("42B1L"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $73bbc0bea28e4f9a$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $73bbc0bea28e4f9a$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $73bbc0bea28e4f9a$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $73bbc0bea28e4f9a$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $73bbc0bea28e4f9a$var$TYPE_STATICS = {};
$73bbc0bea28e4f9a$var$TYPE_STATICS[$300d96996704c996$exports.ForwardRef] = $73bbc0bea28e4f9a$var$FORWARD_REF_STATICS;
$73bbc0bea28e4f9a$var$TYPE_STATICS[$300d96996704c996$exports.Memo] = $73bbc0bea28e4f9a$var$MEMO_STATICS;
function $73bbc0bea28e4f9a$var$getStatics(component) {
    // React v16.11 and below
    if ($300d96996704c996$exports.isMemo(component)) return $73bbc0bea28e4f9a$var$MEMO_STATICS;
     // React v16.12 and above
    return $73bbc0bea28e4f9a$var$TYPE_STATICS[component["$$typeof"]] || $73bbc0bea28e4f9a$var$REACT_STATICS;
}
var $73bbc0bea28e4f9a$var$defineProperty = Object.defineProperty;
var $73bbc0bea28e4f9a$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $73bbc0bea28e4f9a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $73bbc0bea28e4f9a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $73bbc0bea28e4f9a$var$getPrototypeOf = Object.getPrototypeOf;
var $73bbc0bea28e4f9a$var$objectPrototype = Object.prototype;
function $73bbc0bea28e4f9a$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($73bbc0bea28e4f9a$var$objectPrototype) {
            var inheritedComponent = $73bbc0bea28e4f9a$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $73bbc0bea28e4f9a$var$objectPrototype) $73bbc0bea28e4f9a$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $73bbc0bea28e4f9a$var$getOwnPropertyNames(sourceComponent);
        if ($73bbc0bea28e4f9a$var$getOwnPropertySymbols) keys = keys.concat($73bbc0bea28e4f9a$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $73bbc0bea28e4f9a$var$getStatics(targetComponent);
        var sourceStatics = $73bbc0bea28e4f9a$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$73bbc0bea28e4f9a$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $73bbc0bea28e4f9a$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $73bbc0bea28e4f9a$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$73bbc0bea28e4f9a$exports = $73bbc0bea28e4f9a$var$hoistNonReactStatics;



var $4Iuzv = parcelRequire("4Iuzv");
var $c009d25364177c1b$exports = {};
"use strict";

$c009d25364177c1b$exports = (parcelRequire("d21w1"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $6c8dddb278a38025$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $4309dbc903824fcd$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $6c8dddb278a38025$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $4309dbc903824fcd$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $4309dbc903824fcd$var$verify(mapStateToProps, "mapStateToProps");
    $4309dbc903824fcd$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $4309dbc903824fcd$var$verify(mergeProps, "mergeProps");
}


const $4d7f9da0245cfe46$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $4d7f9da0245cfe46$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $4d7f9da0245cfe46$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $c34fbb8b67150408$export$2e2bcd8739ae039)(_ref, $4d7f9da0245cfe46$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $4d7f9da0245cfe46$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $23b80c596d5a9732$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $a4990b2dc89e591e$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $eaa80da0fe66a1dc$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $a4990b2dc89e591e$export$2e2bcd8739ae039)(value)) (0, $6c8dddb278a38025$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $f378cf351d1e7ed2$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $f378cf351d1e7ed2$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $f378cf351d1e7ed2$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f378cf351d1e7ed2$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f378cf351d1e7ed2$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $fbe0a67cd2eb393b$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $02085d0b5f1914ca$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $f378cf351d1e7ed2$export$710f7c60f68acd3e)((dispatch)=>(0, $23b80c596d5a9732$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $f378cf351d1e7ed2$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $f378cf351d1e7ed2$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $fbe0a67cd2eb393b$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $d2c59625335724d0$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $f378cf351d1e7ed2$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $f378cf351d1e7ed2$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $fbe0a67cd2eb393b$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $5c665bf4cce3f79b$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $78c60c144526c0e4$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $5c665bf4cce3f79b$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $5c665bf4cce3f79b$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$5c665bf4cce3f79b$export$691c327fc30bc857 : typeof mergeProps === "function" ? $5c665bf4cce3f79b$export$5b105939c84b5234(mergeProps) : (0, $fbe0a67cd2eb393b$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $a2d0f091b3109cf6$var$createListenerCollection() {
    const batch = (0, $621da53f59db0be3$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $a2d0f091b3109cf6$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $a2d0f091b3109cf6$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $a2d0f091b3109cf6$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $a2d0f091b3109cf6$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $a2d0f091b3109cf6$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $4Iuzv = parcelRequire("4Iuzv");
const $322bb7f9a12f50c7$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $322bb7f9a12f50c7$export$700979bc83e7db82 = $322bb7f9a12f50c7$export$71594e8a50f746f4 ? (0, $4Iuzv.useLayoutEffect) : (0, $4Iuzv.useEffect);


function $a2ba95ff049a4fd8$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $a2ba95ff049a4fd8$export$2e2bcd8739ae039(objA, objB) {
    if ($a2ba95ff049a4fd8$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$a2ba95ff049a4fd8$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $58760a5be0977b6b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $58760a5be0977b6b$var$useSyncExternalStore = (0, $b7817f958742d384$export$20656a4825650bd0);
const $58760a5be0977b6b$export$36d45daa6a4925b8 = (fn)=>{
    $58760a5be0977b6b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $58760a5be0977b6b$var$EMPTY_ARRAY = [
    null,
    0
];
const $58760a5be0977b6b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $58760a5be0977b6b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $58760a5be0977b6b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $322bb7f9a12f50c7$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $58760a5be0977b6b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $58760a5be0977b6b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $58760a5be0977b6b$var$initStateUpdates = ()=>$58760a5be0977b6b$var$EMPTY_ARRAY;
function $58760a5be0977b6b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $58760a5be0977b6b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $58760a5be0977b6b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $58760a5be0977b6b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $a2ba95ff049a4fd8$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $a2ba95ff049a4fd8$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $a2ba95ff049a4fd8$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $04688d22da4f5f87$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $d2c59625335724d0$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $02085d0b5f1914ca$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $5c665bf4cce3f79b$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, $4Iuzv.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $c34fbb8b67150408$export$2e2bcd8739ae039)(props, $58760a5be0977b6b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, $4Iuzv.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $c009d25364177c1b$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, $4Iuzv.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, $4Iuzv.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $4d7f9da0245cfe46$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, $4Iuzv.useMemo)(()=>{
                if (!shouldHandleStateChanges) return $58760a5be0977b6b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $a2d0f091b3109cf6$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, $4Iuzv.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $78c60c144526c0e4$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, $4Iuzv.useRef)();
            const lastWrapperProps = (0, $4Iuzv.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, $4Iuzv.useRef)();
            const renderIsScheduled = (0, $4Iuzv.useRef)(false);
            const isProcessingDispatch = (0, $4Iuzv.useRef)(false);
            const isMounted = (0, $4Iuzv.useRef)(false);
            const latestSubscriptionCallbackError = (0, $4Iuzv.useRef)();
            (0, $322bb7f9a12f50c7$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, $4Iuzv.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, $4Iuzv.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $58760a5be0977b6b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $58760a5be0977b6b$var$useIsomorphicLayoutEffectWithArgs($58760a5be0977b6b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $58760a5be0977b6b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $322bb7f9a12f50c7$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, $4Iuzv.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(WrappedComponent, (0, $78c60c144526c0e4$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, $4Iuzv.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(Connect, (0, $78c60c144526c0e4$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($73bbc0bea28e4f9a$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($73bbc0bea28e4f9a$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $58760a5be0977b6b$export$2e2bcd8739ae039 = $58760a5be0977b6b$var$connect;



var $4Iuzv = parcelRequire("4Iuzv");



function $0e894410288988cc$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = (0, $4Iuzv.useMemo)(()=>{
        const subscription = (0, $a2d0f091b3109cf6$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = (0, $4Iuzv.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, $322bb7f9a12f50c7$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $04688d22da4f5f87$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $0e894410288988cc$export$2e2bcd8739ae039 = $0e894410288988cc$var$Provider;







function $6bf15db07a0e99a6$export$671dba69185d0304(context = (0, $04688d22da4f5f87$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $04688d22da4f5f87$export$cc80c08dc91f1c00) ? (0, $2a86e1d739a547e1$export$c1275ca9a6fd3ec5) : (0, $2a86e1d739a547e1$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $6bf15db07a0e99a6$export$6ccbb43953eebf8 = /*#__PURE__*/ $6bf15db07a0e99a6$export$671dba69185d0304();


function $060db65b89081276$export$bc9b55530897c558(context = (0, $04688d22da4f5f87$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $04688d22da4f5f87$export$cc80c08dc91f1c00) ? (0, $6bf15db07a0e99a6$export$6ccbb43953eebf8) : (0, $6bf15db07a0e99a6$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $060db65b89081276$export$8ad76b76a4c905f8 = /*#__PURE__*/ $060db65b89081276$export$bc9b55530897c558();









(0, $4003a0143258f2e3$export$e2e6e3f3f3b782e3)((0, $0f7f62120aa48ea1$exports.useSyncExternalStoreWithSelector));
(0, $58760a5be0977b6b$export$36d45daa6a4925b8)((0, $lhInO.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $621da53f59db0be3$export$4b9874722d0da7bc)((0, $d0525dc7624af49b$exports.unstable_batchedUpdates));



var $48IOt = parcelRequire("48IOt");
function $57d334e8ab97a36f$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $57d334e8ab97a36f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $57d334e8ab97a36f$export$2e2bcd8739ae039(obj);
}



function $599b618f03d7b341$export$2e2bcd8739ae039(input, hint) {
    if ((0, $57d334e8ab97a36f$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $57d334e8ab97a36f$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $a951d020c99c109a$export$2e2bcd8739ae039(arg) {
    var key = (0, $599b618f03d7b341$export$2e2bcd8739ae039)(arg, "string");
    return (0, $57d334e8ab97a36f$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $6a3df7ec5ef507cc$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $a951d020c99c109a$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $11e59f8e6d2d151a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $11e59f8e6d2d151a$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $11e59f8e6d2d151a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $6a3df7ec5ef507cc$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $11e59f8e6d2d151a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $97eb05a0271afdd7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $97eb05a0271afdd7$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $97eb05a0271afdd7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $97eb05a0271afdd7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $97eb05a0271afdd7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $97eb05a0271afdd7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $97eb05a0271afdd7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $97eb05a0271afdd7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $97eb05a0271afdd7$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($97eb05a0271afdd7$var$isDate(val)) return "date";
    if ($97eb05a0271afdd7$var$isError(val)) return "error";
    var constructorName = $97eb05a0271afdd7$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $97eb05a0271afdd7$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $97eb05a0271afdd7$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $97eb05a0271afdd7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $97eb05a0271afdd7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $97eb05a0271afdd7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(1));
        return enhancer($97eb05a0271afdd7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$97eb05a0271afdd7$var$isPlainObject(action)) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $97eb05a0271afdd7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$97eb05a0271afdd7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $97eb05a0271afdd7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$97eb05a0271afdd7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $97eb05a0271afdd7$export$8928921ea2d3b126 = $97eb05a0271afdd7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $97eb05a0271afdd7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $97eb05a0271afdd7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $97eb05a0271afdd7$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$97eb05a0271afdd7$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $97eb05a0271afdd7$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $97eb05a0271afdd7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $97eb05a0271afdd7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $97eb05a0271afdd7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $97eb05a0271afdd7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $97eb05a0271afdd7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $97eb05a0271afdd7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $97eb05a0271afdd7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $97eb05a0271afdd7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $97eb05a0271afdd7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $97eb05a0271afdd7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $97eb05a0271afdd7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $97eb05a0271afdd7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($97eb05a0271afdd7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $97eb05a0271afdd7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $11e59f8e6d2d151a$export$2e2bcd8739ae039)((0, $11e59f8e6d2d151a$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $320ed371264a508c$var$NOT_FOUND = "NOT_FOUND";
function $320ed371264a508c$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $320ed371264a508c$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $320ed371264a508c$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $320ed371264a508c$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $320ed371264a508c$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $320ed371264a508c$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $320ed371264a508c$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $320ed371264a508c$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $320ed371264a508c$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $320ed371264a508c$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $320ed371264a508c$var$createSingletonCache(comparator) : $320ed371264a508c$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $320ed371264a508c$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $b2bf54b0d112358c$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $b2bf54b0d112358c$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $b2bf54b0d112358c$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $b2bf54b0d112358c$export$595d22ed68ca2841 = /* #__PURE__ */ $b2bf54b0d112358c$export$5943f4447f6ef248((0, $320ed371264a508c$export$281bff7f05488aa2));
var $b2bf54b0d112358c$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $b2bf54b0d112358c$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $05baea71612da282$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $05baea71612da282$var$thunk = $05baea71612da282$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$05baea71612da282$var$thunk.withExtraArgument = $05baea71612da282$var$createThunkMiddleware;
var $05baea71612da282$export$2e2bcd8739ae039 = $05baea71612da282$var$thunk;


var $5671edd534fa79c4$exports = {};
// shim for using process in browser
var $5671edd534fa79c4$var$process = $5671edd534fa79c4$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5671edd534fa79c4$var$cachedSetTimeout;
var $5671edd534fa79c4$var$cachedClearTimeout;
function $5671edd534fa79c4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $5671edd534fa79c4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        else $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        else $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    }
})();
function $5671edd534fa79c4$var$runTimeout(fun) {
    if ($5671edd534fa79c4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedSetTimeout === $5671edd534fa79c4$var$defaultSetTimout || !$5671edd534fa79c4$var$cachedSetTimeout) && setTimeout) {
        $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5671edd534fa79c4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5671edd534fa79c4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5671edd534fa79c4$var$runClearTimeout(marker) {
    if ($5671edd534fa79c4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedClearTimeout === $5671edd534fa79c4$var$defaultClearTimeout || !$5671edd534fa79c4$var$cachedClearTimeout) && clearTimeout) {
        $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5671edd534fa79c4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5671edd534fa79c4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5671edd534fa79c4$var$queue = [];
var $5671edd534fa79c4$var$draining = false;
var $5671edd534fa79c4$var$currentQueue;
var $5671edd534fa79c4$var$queueIndex = -1;
function $5671edd534fa79c4$var$cleanUpNextTick() {
    if (!$5671edd534fa79c4$var$draining || !$5671edd534fa79c4$var$currentQueue) return;
    $5671edd534fa79c4$var$draining = false;
    if ($5671edd534fa79c4$var$currentQueue.length) $5671edd534fa79c4$var$queue = $5671edd534fa79c4$var$currentQueue.concat($5671edd534fa79c4$var$queue);
    else $5671edd534fa79c4$var$queueIndex = -1;
    if ($5671edd534fa79c4$var$queue.length) $5671edd534fa79c4$var$drainQueue();
}
function $5671edd534fa79c4$var$drainQueue() {
    if ($5671edd534fa79c4$var$draining) return;
    var timeout = $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$cleanUpNextTick);
    $5671edd534fa79c4$var$draining = true;
    var len = $5671edd534fa79c4$var$queue.length;
    while(len){
        $5671edd534fa79c4$var$currentQueue = $5671edd534fa79c4$var$queue;
        $5671edd534fa79c4$var$queue = [];
        while(++$5671edd534fa79c4$var$queueIndex < len)if ($5671edd534fa79c4$var$currentQueue) $5671edd534fa79c4$var$currentQueue[$5671edd534fa79c4$var$queueIndex].run();
        $5671edd534fa79c4$var$queueIndex = -1;
        len = $5671edd534fa79c4$var$queue.length;
    }
    $5671edd534fa79c4$var$currentQueue = null;
    $5671edd534fa79c4$var$draining = false;
    $5671edd534fa79c4$var$runClearTimeout(timeout);
}
$5671edd534fa79c4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5671edd534fa79c4$var$queue.push(new $5671edd534fa79c4$var$Item(fun, args));
    if ($5671edd534fa79c4$var$queue.length === 1 && !$5671edd534fa79c4$var$draining) $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$drainQueue);
};
// v8 likes predictible objects
function $5671edd534fa79c4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5671edd534fa79c4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5671edd534fa79c4$var$process.title = "browser";
$5671edd534fa79c4$var$process.browser = true;
$5671edd534fa79c4$var$process.env = {};
$5671edd534fa79c4$var$process.argv = [];
$5671edd534fa79c4$var$process.version = ""; // empty string to avoid regexp issues
$5671edd534fa79c4$var$process.versions = {};
function $5671edd534fa79c4$var$noop() {}
$5671edd534fa79c4$var$process.on = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.addListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.once = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.off = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeAllListeners = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.emit = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependOnceListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.listeners = function(name) {
    return [];
};
$5671edd534fa79c4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$5671edd534fa79c4$var$process.cwd = function() {
    return "/";
};
$5671edd534fa79c4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$5671edd534fa79c4$var$process.umask = function() {
    return 0;
};


var $cb2071a08f9755a6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cb2071a08f9755a6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cb2071a08f9755a6$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $cb2071a08f9755a6$var$__defProp = Object.defineProperty;
var $cb2071a08f9755a6$var$__defProps = Object.defineProperties;
var $cb2071a08f9755a6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cb2071a08f9755a6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cb2071a08f9755a6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cb2071a08f9755a6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cb2071a08f9755a6$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $cb2071a08f9755a6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $cb2071a08f9755a6$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($cb2071a08f9755a6$var$__hasOwnProp.call(b, prop)) $cb2071a08f9755a6$var$__defNormalProp(a, prop, b[prop]);
    if ($cb2071a08f9755a6$var$__getOwnPropSymbols) for(var _i = 0, _c = $cb2071a08f9755a6$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($cb2071a08f9755a6$var$__propIsEnum.call(b, prop)) $cb2071a08f9755a6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cb2071a08f9755a6$var$__spreadProps = function(a, b) {
    return $cb2071a08f9755a6$var$__defProps(a, $cb2071a08f9755a6$var$__getOwnPropDescs(b));
};
var $cb2071a08f9755a6$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $cb2071a08f9755a6$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $b2bf54b0d112358c$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $cb2071a08f9755a6$var$__spreadArray([
            (0, $48IOt.isDraft)(value) ? (0, $48IOt.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $cb2071a08f9755a6$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $97eb05a0271afdd7$export$f672e0b6f7222cd7;
    return (0, $97eb05a0271afdd7$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $cb2071a08f9755a6$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $cb2071a08f9755a6$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $cb2071a08f9755a6$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $cb2071a08f9755a6$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $cb2071a08f9755a6$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $cb2071a08f9755a6$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $cb2071a08f9755a6$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $cb2071a08f9755a6$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $cb2071a08f9755a6$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $cb2071a08f9755a6$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $cb2071a08f9755a6$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $cb2071a08f9755a6$var$freezeDraftable(val) {
    return (0, $48IOt.isDraftable)(val) ? (0, $48IOt.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $cb2071a08f9755a6$var$isProduction = true;
var $cb2071a08f9755a6$var$prefix = "Invariant failed";
function $cb2071a08f9755a6$var$invariant(condition, message) {
    if (condition) return;
    if ($cb2071a08f9755a6$var$isProduction) throw new Error($cb2071a08f9755a6$var$prefix);
    throw new Error($cb2071a08f9755a6$var$prefix + ": " + (message || ""));
}
function $cb2071a08f9755a6$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $cb2071a08f9755a6$var$getSerialize(serializer, decycler), indent);
}
function $cb2071a08f9755a6$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $cb2071a08f9755a6$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $cb2071a08f9755a6$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $cb2071a08f9755a6$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $cb2071a08f9755a6$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $cb2071a08f9755a6$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $cb2071a08f9755a6$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $cb2071a08f9755a6$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $cb2071a08f9755a6$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $cb2071a08f9755a6$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $cb2071a08f9755a6$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $cb2071a08f9755a6$export$53b83ca8eaab0383(val);
}
function $cb2071a08f9755a6$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $cb2071a08f9755a6$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $cb2071a08f9755a6$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $cb2071a08f9755a6$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $cb2071a08f9755a6$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$cb2071a08f9755a6$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $cb2071a08f9755a6$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $cb2071a08f9755a6$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $cb2071a08f9755a6$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $cb2071a08f9755a6$export$36c1185aeee5b0a6(options);
    };
}
function $cb2071a08f9755a6$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $cb2071a08f9755a6$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($cb2071a08f9755a6$var$isBoolean(thunk)) middlewareArray.push((0, $05baea71612da282$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $05baea71612da282$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $cb2071a08f9755a6$var$IS_PRODUCTION = true;
function $cb2071a08f9755a6$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $cb2071a08f9755a6$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($cb2071a08f9755a6$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $97eb05a0271afdd7$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$cb2071a08f9755a6$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$cb2071a08f9755a6$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $97eb05a0271afdd7$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $97eb05a0271afdd7$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $cb2071a08f9755a6$var$composeWithDevTools($cb2071a08f9755a6$var$__spreadValues({
        trace: !$cb2071a08f9755a6$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $cb2071a08f9755a6$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $cb2071a08f9755a6$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $97eb05a0271afdd7$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $cb2071a08f9755a6$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $cb2071a08f9755a6$var$__spreadValues($cb2071a08f9755a6$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $cb2071a08f9755a6$export$b956e38827fca970(action) {
    return $cb2071a08f9755a6$export$53b83ca8eaab0383(action) && "type" in action;
}
function $cb2071a08f9755a6$export$ebd532f9034651f3(action) {
    return $cb2071a08f9755a6$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($cb2071a08f9755a6$var$isValidKey);
}
function $cb2071a08f9755a6$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $cb2071a08f9755a6$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $cb2071a08f9755a6$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $cb2071a08f9755a6$var$isStateFunction(x) {
    return typeof x === "function";
}
var $cb2071a08f9755a6$var$hasWarnedAboutObjectNotation = false;
function $cb2071a08f9755a6$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $cb2071a08f9755a6$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($cb2071a08f9755a6$var$isStateFunction(initialState)) getInitialState = function() {
        return $cb2071a08f9755a6$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $cb2071a08f9755a6$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $cb2071a08f9755a6$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $48IOt.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $48IOt.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $48IOt.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $cb2071a08f9755a6$var$hasWarnedAboutObjectNotation2 = false;
function $cb2071a08f9755a6$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $cb2071a08f9755a6$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $5671edd534fa79c4$exports;
    var initialState = typeof options.initialState == "function" ? options.initialState : $cb2071a08f9755a6$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $cb2071a08f9755a6$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $cb2071a08f9755a6$export$309c7a02b0b0bc62(type, prepareCallback) : $cb2071a08f9755a6$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $cb2071a08f9755a6$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $cb2071a08f9755a6$var$__spreadValues($cb2071a08f9755a6$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $cb2071a08f9755a6$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $cb2071a08f9755a6$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $cb2071a08f9755a6$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($cb2071a08f9755a6$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $cb2071a08f9755a6$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $cb2071a08f9755a6$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $cb2071a08f9755a6$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $cb2071a08f9755a6$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $cb2071a08f9755a6$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $cb2071a08f9755a6$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $cb2071a08f9755a6$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $cb2071a08f9755a6$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $cb2071a08f9755a6$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $cb2071a08f9755a6$var$createSingleArgumentStateOperator(mutator) {
    var operator = $cb2071a08f9755a6$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $cb2071a08f9755a6$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $cb2071a08f9755a6$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $48IOt.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $48IOt.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $cb2071a08f9755a6$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $cb2071a08f9755a6$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $cb2071a08f9755a6$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $cb2071a08f9755a6$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $cb2071a08f9755a6$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $cb2071a08f9755a6$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $cb2071a08f9755a6$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $cb2071a08f9755a6$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $cb2071a08f9755a6$var$__spreadValues($cb2071a08f9755a6$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $cb2071a08f9755a6$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $cb2071a08f9755a6$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $cb2071a08f9755a6$var$createStateOperator(addOneMutably),
        addMany: $cb2071a08f9755a6$var$createStateOperator(addManyMutably),
        setOne: $cb2071a08f9755a6$var$createStateOperator(setOneMutably),
        setMany: $cb2071a08f9755a6$var$createStateOperator(setManyMutably),
        setAll: $cb2071a08f9755a6$var$createStateOperator(setAllMutably),
        updateOne: $cb2071a08f9755a6$var$createStateOperator(updateOneMutably),
        updateMany: $cb2071a08f9755a6$var$createStateOperator(updateManyMutably),
        upsertOne: $cb2071a08f9755a6$var$createStateOperator(upsertOneMutably),
        upsertMany: $cb2071a08f9755a6$var$createStateOperator(upsertManyMutably),
        removeOne: $cb2071a08f9755a6$var$createStateOperator(removeOneMutably),
        removeMany: $cb2071a08f9755a6$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $cb2071a08f9755a6$var$createSortedStateAdapter(selectId, sort) {
    var _c = $cb2071a08f9755a6$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($cb2071a08f9755a6$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $cb2071a08f9755a6$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $cb2071a08f9755a6$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $cb2071a08f9755a6$var$createStateOperator(addOneMutably),
        updateOne: $cb2071a08f9755a6$var$createStateOperator(updateOneMutably),
        upsertOne: $cb2071a08f9755a6$var$createStateOperator(upsertOneMutably),
        setOne: $cb2071a08f9755a6$var$createStateOperator(setOneMutably),
        setMany: $cb2071a08f9755a6$var$createStateOperator(setManyMutably),
        setAll: $cb2071a08f9755a6$var$createStateOperator(setAllMutably),
        addMany: $cb2071a08f9755a6$var$createStateOperator(addManyMutably),
        updateMany: $cb2071a08f9755a6$var$createStateOperator(updateManyMutably),
        upsertMany: $cb2071a08f9755a6$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $cb2071a08f9755a6$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $cb2071a08f9755a6$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $cb2071a08f9755a6$var$createInitialStateFactory();
    var selectorsFactory = $cb2071a08f9755a6$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $cb2071a08f9755a6$var$createSortedStateAdapter(selectId, sortComparer) : $cb2071a08f9755a6$var$createUnsortedStateAdapter(selectId);
    return $cb2071a08f9755a6$var$__spreadValues($cb2071a08f9755a6$var$__spreadValues($cb2071a08f9755a6$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $cb2071a08f9755a6$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $cb2071a08f9755a6$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $cb2071a08f9755a6$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $cb2071a08f9755a6$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $cb2071a08f9755a6$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $cb2071a08f9755a6$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $cb2071a08f9755a6$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $cb2071a08f9755a6$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $cb2071a08f9755a6$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $cb2071a08f9755a6$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $cb2071a08f9755a6$var$__spreadProps($cb2071a08f9755a6$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $cb2071a08f9755a6$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $cb2071a08f9755a6$var$__spreadProps($cb2071a08f9755a6$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $cb2071a08f9755a6$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $cb2071a08f9755a6$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $cb2071a08f9755a6$var$__spreadProps($cb2071a08f9755a6$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $cb2071a08f9755a6$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $cb2071a08f9755a6$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $cb2071a08f9755a6$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$cb2071a08f9755a6$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $cb2071a08f9755a6$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $cb2071a08f9755a6$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $cb2071a08f9755a6$var$RejectWithValue) throw result;
                                                if (result instanceof $cb2071a08f9755a6$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $cb2071a08f9755a6$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($cb2071a08f9755a6$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $cb2071a08f9755a6$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $cb2071a08f9755a6$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $cb2071a08f9755a6$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $cb2071a08f9755a6$var$matches = function(matcher, action) {
    if ($cb2071a08f9755a6$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $cb2071a08f9755a6$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $cb2071a08f9755a6$var$matches(matcher, action);
        });
    };
}
function $cb2071a08f9755a6$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $cb2071a08f9755a6$var$matches(matcher, action);
        });
    };
}
function $cb2071a08f9755a6$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $cb2071a08f9755a6$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $cb2071a08f9755a6$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $cb2071a08f9755a6$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$cb2071a08f9755a6$var$isAsyncThunkArray(asyncThunks)) return $cb2071a08f9755a6$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $cb2071a08f9755a6$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $cb2071a08f9755a6$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $cb2071a08f9755a6$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$cb2071a08f9755a6$var$isAsyncThunkArray(asyncThunks)) return $cb2071a08f9755a6$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $cb2071a08f9755a6$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $cb2071a08f9755a6$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $cb2071a08f9755a6$export$9dd1fb32974da385($cb2071a08f9755a6$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$cb2071a08f9755a6$var$isAsyncThunkArray(asyncThunks)) return $cb2071a08f9755a6$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $cb2071a08f9755a6$export$9dd1fb32974da385($cb2071a08f9755a6$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $cb2071a08f9755a6$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $cb2071a08f9755a6$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$cb2071a08f9755a6$var$isAsyncThunkArray(asyncThunks)) return $cb2071a08f9755a6$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $cb2071a08f9755a6$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $cb2071a08f9755a6$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $cb2071a08f9755a6$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$cb2071a08f9755a6$var$isAsyncThunkArray(asyncThunks)) return $cb2071a08f9755a6$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $cb2071a08f9755a6$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $cb2071a08f9755a6$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $cb2071a08f9755a6$var$noop = function() {};
var $cb2071a08f9755a6$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $cb2071a08f9755a6$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $cb2071a08f9755a6$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $cb2071a08f9755a6$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $cb2071a08f9755a6$var$task = "task";
var $cb2071a08f9755a6$var$listener = "listener";
var $cb2071a08f9755a6$var$completed = "completed";
var $cb2071a08f9755a6$var$cancelled = "cancelled";
var $cb2071a08f9755a6$var$taskCancelled = "task-" + $cb2071a08f9755a6$var$cancelled;
var $cb2071a08f9755a6$var$taskCompleted = "task-" + $cb2071a08f9755a6$var$completed;
var $cb2071a08f9755a6$var$listenerCancelled = $cb2071a08f9755a6$var$listener + "-" + $cb2071a08f9755a6$var$cancelled;
var $cb2071a08f9755a6$var$listenerCompleted = $cb2071a08f9755a6$var$listener + "-" + $cb2071a08f9755a6$var$completed;
var $cb2071a08f9755a6$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $cb2071a08f9755a6$var$task + " " + $cb2071a08f9755a6$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $cb2071a08f9755a6$var$validateActive = function(signal) {
    if (signal.aborted) throw new $cb2071a08f9755a6$export$cb1bdac908fed7f(signal.reason);
};
function $cb2071a08f9755a6$var$raceWithSignal(signal, promise2) {
    var cleanup = $cb2071a08f9755a6$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $cb2071a08f9755a6$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $cb2071a08f9755a6$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $cb2071a08f9755a6$var$noop;
    });
}
var $cb2071a08f9755a6$var$runTask = function(task2, cleanUp) {
    return $cb2071a08f9755a6$var$__async(void 0, null, function() {
        var value, error_1;
        return $cb2071a08f9755a6$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $cb2071a08f9755a6$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $cb2071a08f9755a6$var$createPause = function(signal) {
    return function(promise2) {
        return $cb2071a08f9755a6$var$catchRejection($cb2071a08f9755a6$var$raceWithSignal(signal, promise2).then(function(output) {
            $cb2071a08f9755a6$var$validateActive(signal);
            return output;
        }));
    };
};
var $cb2071a08f9755a6$var$createDelay = function(signal) {
    var pause = $cb2071a08f9755a6$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $cb2071a08f9755a6$var$assign = Object.assign;
var $cb2071a08f9755a6$var$INTERNAL_NIL_TOKEN = {};
var $cb2071a08f9755a6$var$alm = "listenerMiddleware";
var $cb2071a08f9755a6$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $cb2071a08f9755a6$var$addAbortSignalListener(parentAbortSignal, function() {
            return $cb2071a08f9755a6$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $cb2071a08f9755a6$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $cb2071a08f9755a6$var$runTask(function() {
            return $cb2071a08f9755a6$var$__async(void 0, null, function() {
                var result2;
                return $cb2071a08f9755a6$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $cb2071a08f9755a6$var$validateActive(parentAbortSignal);
                            $cb2071a08f9755a6$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $cb2071a08f9755a6$var$createPause(childAbortController.signal),
                                    delay: $cb2071a08f9755a6$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $cb2071a08f9755a6$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $cb2071a08f9755a6$var$abortControllerWithReason(childAbortController, $cb2071a08f9755a6$var$taskCompleted);
        });
        return {
            result: $cb2071a08f9755a6$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $cb2071a08f9755a6$var$abortControllerWithReason(childAbortController, $cb2071a08f9755a6$var$taskCancelled);
            }
        };
    };
};
var $cb2071a08f9755a6$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $cb2071a08f9755a6$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $cb2071a08f9755a6$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $cb2071a08f9755a6$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $cb2071a08f9755a6$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $cb2071a08f9755a6$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $cb2071a08f9755a6$var$catchRejection(take(predicate, timeout));
    };
};
var $cb2071a08f9755a6$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $cb2071a08f9755a6$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $cb2071a08f9755a6$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $cb2071a08f9755a6$var$createListenerEntry = function(options) {
    var _c = $cb2071a08f9755a6$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $cb2071a08f9755a6$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $cb2071a08f9755a6$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $cb2071a08f9755a6$var$abortControllerWithReason(controller, $cb2071a08f9755a6$var$listenerCancelled);
    });
};
var $cb2071a08f9755a6$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($cb2071a08f9755a6$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $cb2071a08f9755a6$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $cb2071a08f9755a6$export$f03a6b845d3fb58b = $cb2071a08f9755a6$export$309c7a02b0b0bc62($cb2071a08f9755a6$var$alm + "/add");
var $cb2071a08f9755a6$export$b1b8022855fb2b71 = $cb2071a08f9755a6$export$309c7a02b0b0bc62($cb2071a08f9755a6$var$alm + "/removeAll");
var $cb2071a08f9755a6$export$b03e9483f936dccb = $cb2071a08f9755a6$export$309c7a02b0b0bc62($cb2071a08f9755a6$var$alm + "/remove");
var $cb2071a08f9755a6$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $cb2071a08f9755a6$var$__spreadArray([
        $cb2071a08f9755a6$var$alm + "/error"
    ], args));
};
function $cb2071a08f9755a6$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $cb2071a08f9755a6$var$defaultErrorHandler : _c;
    $cb2071a08f9755a6$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $cb2071a08f9755a6$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $cb2071a08f9755a6$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $cb2071a08f9755a6$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $cb2071a08f9755a6$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $cb2071a08f9755a6$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $cb2071a08f9755a6$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $cb2071a08f9755a6$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $cb2071a08f9755a6$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $cb2071a08f9755a6$var$createDelay(internalTaskController.signal),
                                pause: $cb2071a08f9755a6$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $cb2071a08f9755a6$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $cb2071a08f9755a6$var$abortControllerWithReason(controller, $cb2071a08f9755a6$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $cb2071a08f9755a6$export$cb1bdac908fed7f)) $cb2071a08f9755a6$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $cb2071a08f9755a6$var$abortControllerWithReason(internalTaskController, $cb2071a08f9755a6$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $cb2071a08f9755a6$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$cb2071a08f9755a6$export$b956e38827fca970(action)) return next(action);
                if ($cb2071a08f9755a6$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($cb2071a08f9755a6$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($cb2071a08f9755a6$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $cb2071a08f9755a6$var$INTERNAL_NIL_TOKEN) throw new Error($cb2071a08f9755a6$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $cb2071a08f9755a6$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $cb2071a08f9755a6$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $cb2071a08f9755a6$export$8fb31c0f05df007b = "RTK_autoBatch";
var $cb2071a08f9755a6$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$cb2071a08f9755a6$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $cb2071a08f9755a6$var$promise;
var $cb2071a08f9755a6$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($cb2071a08f9755a6$var$promise || ($cb2071a08f9755a6$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $cb2071a08f9755a6$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $cb2071a08f9755a6$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $cb2071a08f9755a6$var$createQueueWithTimer(10);
var $cb2071a08f9755a6$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $cb2071a08f9755a6$var$queueMicrotaskShim : options.type === "raf" ? $cb2071a08f9755a6$var$rAF : options.type === "callback" ? options.queueNotification : $cb2071a08f9755a6$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$cb2071a08f9755a6$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $48IOt.enableES5)();



const $e80f118453286f03$var$initialState = {
    items: []
};
const $e80f118453286f03$var$cartSlice = (0, $cb2071a08f9755a6$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: $e80f118453286f03$var$initialState,
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            const itemIndex = state.items.findIndex((item)=>item.id === action.payload.id);
            if (itemIndex !== -1) state.items.splice(itemIndex, 1);
        },
        clearItems: (state)=>{
            state.items = [];
        }
    }
});
const { addItem: $e80f118453286f03$export$fb9705de59d96855, clearItems: $e80f118453286f03$export$adee95e2d3d98b76, removeItem: $e80f118453286f03$export$fe2d9b4e03920b4c } = $e80f118453286f03$var$cartSlice.actions;
var $e80f118453286f03$export$2e2bcd8739ae039 = $e80f118453286f03$var$cartSlice.reducer;


const $be0d9339cbb41c1b$var$appStore = (0, $cb2071a08f9755a6$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $e80f118453286f03$export$2e2bcd8739ae039)
    }
});
var $be0d9339cbb41c1b$export$2e2bcd8739ae039 = $be0d9339cbb41c1b$var$appStore;




var $4Iuzv = parcelRequire("4Iuzv");
const $a2c194671e8c1390$var$ThemeContext = /*#__PURE__*/ (0, $4Iuzv.createContext)(undefined);
const $a2c194671e8c1390$export$d8964aec282183a3 = ({ children: children })=>{
    const [theme, setTheme] = (0, $4Iuzv.useState)(()=>{
        // Check local storage or system preference
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) return savedTheme;
        if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
        return "light";
    });
    (0, $4Iuzv.useEffect)(()=>{
        const root = window.document.documentElement;
        root.classList.remove("light", "dark");
        root.classList.add(theme);
        localStorage.setItem("theme", theme);
    }, [
        theme
    ]);
    const toggleTheme = ()=>{
        setTheme((prev)=>prev === "light" ? "dark" : "light");
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($a2c194671e8c1390$var$ThemeContext.Provider, {
        value: {
            theme: theme,
            toggleTheme: toggleTheme
        },
        children: children
    });
};
const $a2c194671e8c1390$export$93d4e7f90805808f = ()=>{
    const context = (0, $4Iuzv.useContext)($a2c194671e8c1390$var$ThemeContext);
    if (!context) throw new Error("useTheme must be used within a ThemeProvider");
    return context;
};



parcelRequire("4Iuzv");



const $2e19991f285c915e$var$Header = ()=>{
    const cartItems = (0, $4003a0143258f2e3$export$2105062e25df4afe)((state)=>state.cart.items);
    const { theme: theme, toggleTheme: toggleTheme } = (0, $a2c194671e8c1390$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
        className: "fixed top-0 left-0 right-0 h-16 bg-white dark:bg-gray-900 shadow-sm z-50 flex items-center justify-between px-4 md:px-12 transition-colors duration-200 border-b border-gray-100 dark:border-gray-800",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "text-2xl",
                        children: "\uD83C\uDF7D\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                        className: "text-xl font-bold text-gray-900 dark:text-white",
                        children: [
                            "Easy",
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "text-orange-500",
                                children: "Eats"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                className: "flex items-center gap-1 md:gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                        onClick: toggleTheme,
                        className: "p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors mr-2",
                        "aria-label": "Toggle theme",
                        children: theme === "light" ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                            className: "fa-solid fa-moon"
                        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                            className: "fa-solid fa-sun"
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "hidden md:flex items-center gap-2 px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg font-medium text-sm transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                className: "fa-solid fa-house text-xs"
                            }),
                            "Home"
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                        to: "/cart",
                        className: "flex items-center gap-2 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-full font-medium text-sm transition-colors relative",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                className: "fa-solid fa-bag-shopping text-sm"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "hidden sm:inline",
                                children: "Cart"
                            }),
                            cartItems.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "absolute -top-1 -right-1 bg-gray-900 dark:bg-white text-white dark:text-gray-900 text-xs font-bold min-w-[20px] h-5 rounded-full flex items-center justify-center",
                                children: cartItems.length
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2e19991f285c915e$export$2e2bcd8739ae039 = $2e19991f285c915e$var$Header;



parcelRequire("4Iuzv");

const $18897fd3e64934ab$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("footer", {
        className: "bg-white text-gray-900 dark:bg-gray-900 dark:text-white mt-auto border-t border-gray-200 dark:border-gray-800 transition-colors",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "max-w-[1400px] mx-auto px-6 py-16",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-3xl",
                                            children: "\uD83C\uDF7D\uFE0F"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                            className: "text-2xl font-bold tracking-tight",
                                            children: [
                                                "Easy",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-orange-500",
                                                    children: "Eats"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-gray-500 dark:text-gray-400 text-sm leading-relaxed max-w-xs",
                                    children: "Discover the best food & drinks in your city. Delivered with love and care, straight to your doorstep."
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "flex gap-4 pt-2",
                                    children: [
                                        "facebook",
                                        "twitter",
                                        "instagram",
                                        "linkedin"
                                    ].map((social)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                            href: "#",
                                            className: "w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-orange-500 group flex items-center justify-center transition-all duration-300 hover:-translate-y-1",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                className: `fa-brands fa-${social === "facebook" ? "facebook-f" : social} text-gray-600 dark:text-gray-300 group-hover:text-white transition-colors`
                                            })
                                        }, social))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                    className: "text-lg font-semibold mb-6 text-gray-900 dark:text-white border-b-2 border-orange-500 inline-block pb-1",
                                    children: "Quick Links"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ul", {
                                    className: "space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                                to: "/",
                                                className: "text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-2 group",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                        className: "fa-solid fa-chevron-right text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                                                    }),
                                                    "Home"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                                to: "/cart",
                                                className: "text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-2 group",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                        className: "fa-solid fa-chevron-right text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                                                    }),
                                                    "Cart"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                    className: "text-lg font-semibold mb-6 text-gray-900 dark:text-white border-b-2 border-orange-500 inline-block pb-1",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ul", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                            className: "flex items-start gap-3 text-gray-600 dark:text-gray-400 group cursor-pointer hover:text-orange-500 dark:hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "mt-1 w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                        className: "fa-solid fa-location-dot text-sm group-hover:text-white transition-colors"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                    className: "text-sm leading-relaxed",
                                                    children: [
                                                        "123 Food Street, Tasty Town,",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                        "Flavor District, India 456789"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                            className: "flex items-center gap-3 text-gray-600 dark:text-gray-400 group cursor-pointer hover:text-orange-500 dark:hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                        className: "fa-solid fa-envelope text-sm group-hover:text-white transition-colors"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: "support@easyeats.com"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                            className: "flex items-center gap-3 text-gray-600 dark:text-gray-400 group cursor-pointer hover:text-orange-500 dark:hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                        className: "fa-solid fa-phone text-sm group-hover:text-white transition-colors"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: "+91 1800-123-4567"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                    className: "text-lg font-semibold mb-6 text-gray-900 dark:text-white border-b-2 border-orange-500 inline-block pb-1",
                                    children: "Newsletter"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-gray-500 dark:text-gray-400 text-sm mb-4",
                                    children: "Subscribe for offers and updates."
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("form", {
                                    className: "space-y-2",
                                    onSubmit: (e)=>e.preventDefault(),
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                                            type: "email",
                                            placeholder: "Email Address",
                                            className: "w-full px-4 py-3 bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-900 dark:text-white text-sm focus:outline-none focus:border-orange-500 transition-colors"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg text-sm transition-colors shadow-lg hover:shadow-orange-500/20",
                                            children: "Subscribe"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "border-t border-gray-200 dark:border-gray-800 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 transition-colors",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                            className: "text-gray-500 text-sm text-center md:text-left",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " EasyEats. Designed with ",
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                    className: "fa-solid fa-heart text-red-500 mx-1 animate-pulse"
                                }),
                                " by Shivam."
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex gap-6 text-sm text-gray-500",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                    href: "#",
                                    className: "hover:text-orange-500 transition-colors",
                                    children: "Privacy"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                    href: "#",
                                    className: "hover:text-orange-500 transition-colors",
                                    children: "Terms"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                    href: "#",
                                    className: "hover:text-orange-500 transition-colors",
                                    children: "Sitemap"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $18897fd3e64934ab$export$2e2bcd8739ae039 = $18897fd3e64934ab$var$Footer;




var $4Iuzv = parcelRequire("4Iuzv");


var $4Iuzv = parcelRequire("4Iuzv");
const $6b2db4c295d3ce5e$var$useRestaurantData = ()=>{
    const [allRestaurants, setAllRestaurants] = (0, $4Iuzv.useState)(null);
    const [filteredRestaurants, setFilteredRestaurants] = (0, $4Iuzv.useState)(null);
    const [topBrands, setTopBrands] = (0, $4Iuzv.useState)(null);
    const [foodCategories, setFoodCategories] = (0, $4Iuzv.useState)(null);
    const [loading, setLoading] = (0, $4Iuzv.useState)(true);
    const [cityName, setCityName] = (0, $4Iuzv.useState)("Surat");
    const [lat, setLat] = (0, $4Iuzv.useState)(21.1702401);
    const [lng, setLng] = (0, $4Iuzv.useState)(72.83106070000001);
    const setLocation = (0, $4Iuzv.useCallback)((newLat, newLng, name)=>{
        setCityName(name);
        setLat(newLat);
        setLng(newLng);
    }, []);
    // Fetch restaurants when lat/lng changes
    (0, $4Iuzv.useEffect)(()=>{
        const fetchRestaurants = async ()=>{
            setLoading(true);
            try {
                const apiUrl = `https://foodfire.onrender.com/api/restaurants?lat=${lat}&lng=${lng}&page_type=DESKTOP_WEB_LISTING`;
                console.log("Fetching restaurants for:", cityName, "at", lat, lng);
                const response = await fetch(apiUrl);
                const json = await response.json();
                const cards = json?.data?.cards || [];
                // Extract food categories (What's on your mind)
                const categoryCard = cards.find((card)=>card?.card?.card?.id === "whats_on_your_mind");
                const categories = categoryCard?.card?.card?.imageGridCards?.info || categoryCard?.card?.card?.gridElements?.infoWithStyle?.info || [];
                setFoodCategories(categories);
                // Extract top brands
                const topBrandsCard = cards.find((card)=>card?.card?.card?.id === "top_brands_for_you");
                const topBrandsData = topBrandsCard?.card?.card?.gridElements?.infoWithStyle?.restaurants || [];
                setTopBrands(topBrandsData);
                // Extract main restaurant list
                const restaurantListCard = cards.find((card)=>card?.card?.card?.id === "restaurant_grid_listing");
                let restaurantList = restaurantListCard?.card?.card?.gridElements?.infoWithStyle?.restaurants || [];
                // If no restaurant_grid_listing, find restaurants from other sources
                if (restaurantList.length === 0) for(let i = 0; i < cards.length; i++){
                    const checkData = cards[i]?.card?.card?.gridElements?.infoWithStyle?.restaurants;
                    if (checkData && checkData.length > 0) {
                        restaurantList = checkData;
                        break;
                    }
                }
                setAllRestaurants(restaurantList);
                setFilteredRestaurants(restaurantList);
            } catch (error) {
                console.error("Error fetching restaurants:", error);
                setAllRestaurants([]);
                setFilteredRestaurants([]);
            } finally{
                setLoading(false);
            }
        };
        fetchRestaurants();
    }, [
        lat,
        lng,
        cityName
    ]);
    return {
        allRestaurants: allRestaurants,
        filteredRestaurants: filteredRestaurants,
        topBrands: topBrands,
        foodCategories: foodCategories,
        loading: loading,
        cityName: cityName,
        setLocation: setLocation
    };
};
var $6b2db4c295d3ce5e$export$2e2bcd8739ae039 = $6b2db4c295d3ce5e$var$useRestaurantData;



var $4Iuzv = parcelRequire("4Iuzv");
const $82d0314b2a90bff4$var$useOnline = ()=>{
    const [isOnline, setIsOnline] = (0, $4Iuzv.useState)(true);
    (0, $4Iuzv.useEffect)(()=>{
        const handleOnline = ()=>setIsOnline(true);
        const handleOffline = ()=>setIsOnline(false);
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return ()=>{
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);
    return isOnline;
};
var $82d0314b2a90bff4$export$2e2bcd8739ae039 = $82d0314b2a90bff4$var$useOnline;



parcelRequire("4Iuzv");
const $03968f016876be30$export$3c67ec6258c4a827 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
const $03968f016876be30$export$3c5a5d8e1e203ce0 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_160,c_fill/";
const $03968f016876be30$export$79ba8f6ee526656e = 12;
const $03968f016876be30$export$138fdc351675302c = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
const $03968f016876be30$export$4a3a00b9ff5cf3da = "type.googleapis.com/swiggy.presentation.food.v2.Restaurant";


const $88c15ae016bd3d07$var$RestaurantCard = ({ restaurant: restaurant })=>{
    const { cloudinaryImageId: cloudinaryImageId, name: name, cuisines: cuisines, areaName: areaName, locality: locality, avgRating: avgRating, avgRatingString: avgRatingString, totalRatingsString: totalRatingsString, sla: sla, costForTwo: costForTwo, isOpen: isOpen, aggregatedDiscountInfoV3: aggregatedDiscountInfoV3, veg: veg, badges: badges, availability: availability } = restaurant;
    const getRatingColor = (rating)=>{
        if (rating >= 4) return "bg-green-600"; // Cleaner green
        if (rating >= 3) return "bg-orange-500";
        return "bg-red-500";
    };
    // Handle cuisines as array or string and sort for better display
    const cuisineText = Array.isArray(cuisines) ? cuisines.slice(0, 3).join(", ") + (cuisines.length > 3 ? "..." : "") : cuisines;
    // Get discount text
    const discountText = aggregatedDiscountInfoV3?.header ? `${aggregatedDiscountInfoV3.header}${aggregatedDiscountInfoV3.subHeader ? " " + aggregatedDiscountInfoV3.subHeader : ""}` : null;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
        className: "rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer group relative bg-white dark:bg-gray-800/80 dark:backdrop-blur-sm shadow-sm hover:shadow-xl hover:-translate-y-1 border border-gray-100 dark:border-white/5 h-full flex flex-col",
        children: [
            isOpen === false && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute inset-0 bg-gray-900/60 z-20 flex items-center justify-center backdrop-blur-[1px]",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "bg-white/95 dark:bg-black/90 px-4 py-2 rounded-lg shadow-xl text-center",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                            className: "text-gray-800 dark:text-gray-200 font-bold text-sm block",
                            children: "Opens at"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                            className: "text-orange-500 font-bold",
                            children: availability?.nextCloseTime ? new Date(availability.nextCloseTime).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit"
                            }) : "Soon"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "relative aspect-[4/3] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                        src: (0, $03968f016876be30$export$3c67ec6258c4a827) + cloudinaryImageId,
                        alt: name,
                        className: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-in-out",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 to-transparent pointer-events-none"
                    }),
                    discountText && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute bottom-3 left-3 right-3 z-10",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "font-extrabold text-xl text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] leading-none tracking-tight",
                            children: [
                                aggregatedDiscountInfoV3?.header,
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                    className: "text-base font-bold ml-1 opacity-95 block sm:inline sm:mt-0 mt-0.5",
                                    children: aggregatedDiscountInfoV3?.subHeader
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "p-4 flex-1 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex justify-between items-start mb-1 gap-2",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                className: "font-bold text-lg text-gray-800 dark:text-gray-100 line-clamp-1 flex-1 group-hover:text-orange-500 transition-colors",
                                children: name
                            }),
                            avgRating && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: `flex items-center gap-1 px-1.5 py-0.5 rounded-md ${getRatingColor(avgRating)} text-white shadow-sm flex-shrink-0`,
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-xs font-bold leading-none",
                                        children: avgRatingString || avgRating
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-star text-[8px] leading-none"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center gap-2 mb-2.5",
                        children: [
                            veg ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-4 h-4 border border-green-600 p-0.5 rounded-sm flex items-center justify-center flex-shrink-0",
                                title: "Vegetarian",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "w-full h-full bg-green-600 rounded-full"
                                })
                            }) : // Optional: Add Non-Veg indicator if you want, usually Swiggy just shows Veg
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-4 h-4 border border-red-600 p-0.5 rounded-sm flex items-center justify-center flex-shrink-0",
                                title: "Non-Vegetarian",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                    className: "fa-solid fa-play text-[8px] text-red-600 rotate-[30deg] ml-[1px]"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-sm text-gray-500 dark:text-gray-400 font-medium line-clamp-1 flex-1",
                                children: cuisineText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400 mb-3.5",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-location-dot text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "truncate",
                                        children: areaName || locality
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-1 h-1 rounded-full bg-gray-300 dark:bg-gray-600 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "font-semibold text-gray-700 dark:text-gray-300 flex-shrink-0",
                                children: sla?.slaString || `${sla?.deliveryTime} mins`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "w-full h-[1px] bg-gray-100 dark:bg-white/5 mb-3"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-auto flex items-center justify-between text-xs font-medium text-gray-500 dark:text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                children: costForTwo ?? "\u20B9200 for two"
                            }),
                            sla?.lastMileTravelString && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                className: "flex items-center gap-1 bg-gray-50 dark:bg-white/5 px-2 py-1 rounded-full text-gray-600 dark:text-gray-300",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-person-biking text-orange-500"
                                    }),
                                    sla.lastMileTravelString
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $88c15ae016bd3d07$export$2e2bcd8739ae039 = $88c15ae016bd3d07$var$RestaurantCard;



parcelRequire("4Iuzv");

const $ac8e759342c9dcad$var$CardShimmer = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-sm transition-colors",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "h-44 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 animate-pulse"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "p-4 space-y-3",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "h-5 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 rounded animate-pulse w-3/4"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 rounded animate-pulse w-full"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex gap-4",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 rounded animate-pulse w-1/3"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "h-4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 rounded animate-pulse w-1/4"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $ac8e759342c9dcad$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "max-w-7xl mx-auto px-6 py-12",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6",
            children: Array((0, $03968f016876be30$export$79ba8f6ee526656e)).fill(0).map((_, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($ac8e759342c9dcad$var$CardShimmer, {}, index))
        })
    });
};
var $ac8e759342c9dcad$export$2e2bcd8739ae039 = $ac8e759342c9dcad$var$Shimmer;



parcelRequire("4Iuzv");
const $2310929c0636e95d$var$UserOffline = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex flex-col items-center justify-center min-h-[60vh] text-center px-6 pt-16 transition-colors",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "text-6xl mb-4",
                children: "\uD83D\uDCE1"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                className: "text-2xl font-bold text-gray-900 dark:text-white mb-2",
                children: "You're Offline"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                className: "text-gray-500 dark:text-gray-400 max-w-md",
                children: "It looks like you've lost your internet connection. Please check your network and try again."
            })
        ]
    });
};
var $2310929c0636e95d$export$2e2bcd8739ae039 = $2310929c0636e95d$var$UserOffline;



const $dbff80deb87e1ce5$var$ITEMS_PER_PAGE = 8;
const $dbff80deb87e1ce5$var$Body = ()=>{
    const [searchText, setSearchText] = (0, $4Iuzv.useState)("");
    const [searchResults, setSearchResults] = (0, $4Iuzv.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $4Iuzv.useState)("");
    const [currentPage, setCurrentPage] = (0, $4Iuzv.useState)(1);
    const [selectedCategory, setSelectedCategory] = (0, $4Iuzv.useState)(null);
    const { allRestaurants: allRestaurants, filteredRestaurants: filteredRestaurants, topBrands: topBrands, foodCategories: foodCategories, loading: loading, cityName: cityName } = (0, $6b2db4c295d3ce5e$export$2e2bcd8739ae039)();
    const isOnline = (0, $82d0314b2a90bff4$export$2e2bcd8739ae039)();
    if (!isOnline) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2310929c0636e95d$export$2e2bcd8739ae039), {});
    const filterRestaurants = (text, restaurants)=>{
        if (!restaurants) return;
        if (text !== "") {
            const filtered = restaurants.filter((restaurant)=>restaurant?.info?.name.toLowerCase().includes(text.toLowerCase()) || typeof restaurant?.info?.cuisines === "string" && restaurant.info.cuisines.toLowerCase().includes(text.toLowerCase()) || Array.isArray(restaurant?.info?.cuisines) && restaurant.info.cuisines.some((c)=>c.toLowerCase().includes(text.toLowerCase())));
            setSearchResults(filtered);
            setErrorMessage(filtered.length === 0 ? "No restaurants found" : "");
            setCurrentPage(1);
        } else {
            setSearchResults(null);
            setErrorMessage("");
            setCurrentPage(1);
        }
    };
    // Filter by food category
    const handleCategoryClick = (categoryText)=>{
        if (!allRestaurants) return;
        if (selectedCategory === categoryText) {
            // Deselect category
            setSelectedCategory(null);
            setSearchResults(null);
            setErrorMessage("");
            setCurrentPage(1);
        } else {
            // Filter by category
            setSelectedCategory(categoryText);
            const filtered = allRestaurants.filter((restaurant)=>{
                const cuisines = restaurant?.info?.cuisines;
                if (typeof cuisines === "string") return cuisines.toLowerCase().includes(categoryText.toLowerCase());
                if (Array.isArray(cuisines)) return cuisines.some((c)=>c.toLowerCase().includes(categoryText.toLowerCase()));
                return false;
            });
            setSearchResults(filtered);
            setErrorMessage(filtered.length === 0 ? `No restaurants found for ${categoryText}` : "");
            setCurrentPage(1);
        }
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter") filterRestaurants(searchText, allRestaurants);
    };
    if (loading) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
        className: "pt-16 min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                className: "relative py-20 px-6 max-w-[1400px] mx-auto flex flex-col items-center justify-center min-h-[40vh] text-center",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center gap-6 mb-8 text-orange-500/80 dark:text-orange-400/80",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                className: "fa-solid fa-burger text-4xl animate-bounce",
                                style: {
                                    animationDelay: "0s"
                                }
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                className: "fa-solid fa-pizza-slice text-4xl animate-bounce",
                                style: {
                                    animationDelay: "0.2s"
                                }
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                className: "fa-solid fa-utensils text-4xl animate-bounce",
                                style: {
                                    animationDelay: "0.4s"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                        className: "text-3xl md:text-5xl font-extrabold text-gray-800 dark:text-gray-100 mb-4 animate-pulse",
                        children: "Looking for great food..."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                        className: "text-gray-500 dark:text-gray-400 text-lg max-w-lg",
                        children: "We are curating the best restaurants around you. Hang tight!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ac8e759342c9dcad$export$2e2bcd8739ae039), {})
        ]
    });
    const displayRestaurants = searchResults ?? filteredRestaurants;
    // Pagination logic
    const totalItems = displayRestaurants?.length || 0;
    const totalPages = Math.ceil(totalItems / $dbff80deb87e1ce5$var$ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * $dbff80deb87e1ce5$var$ITEMS_PER_PAGE;
    const endIndex = startIndex + $dbff80deb87e1ce5$var$ITEMS_PER_PAGE;
    const currentRestaurants = displayRestaurants?.slice(startIndex, endIndex) || [];
    const goToPage = (page)=>{
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            window.scrollTo({
                top: 500,
                behavior: "smooth"
            });
        }
    };
    const getPageNumbers = ()=>{
        const pages = [];
        if (totalPages <= 7) for(let i = 1; i <= totalPages; i++)pages.push(i);
        else {
            if (currentPage <= 4) pages.push(1, 2, 3, 4, 5, "...", totalPages);
            else if (currentPage >= totalPages - 3) pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            else pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
        }
        return pages;
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
        className: "pt-16 min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                className: "relative py-24 px-6 md:px-12 bg-orange-50/50 dark:bg-gray-900 transition-colors duration-200 overflow-hidden min-h-[600px] flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute -top-[30%] -left-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-r from-orange-200/40 to-amber-200/40 dark:from-orange-900/20 dark:to-amber-900/20 blur-[100px]"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute top-[20%] -right-[10%] w-[60%] h-[60%] rounded-full bg-gradient-to-l from-orange-300/30 to-red-300/30 dark:from-orange-800/20 dark:to-red-900/20 blur-[100px]"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute inset-0 opacity-[0.03] dark:opacity-[0.05]",
                                style: {
                                    backgroundImage: "radial-gradient(#fb923c 1px, transparent 1px)",
                                    backgroundSize: "32px 32px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "absolute inset-0 z-0 pointer-events-none hidden md:block select-none overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute top-[15%] left-[10%] animate-float opacity-20 dark:opacity-10 text-orange-600 dark:text-orange-400 rotate-[-15deg]",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                    className: "fa-solid fa-pizza-slice text-8xl filter drop-shadow-lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute top-[20%] right-[12%] animate-float-delayed opacity-20 dark:opacity-10 text-amber-600 dark:text-amber-400 rotate-[15deg]",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                    className: "fa-solid fa-burger text-9xl filter drop-shadow-lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute bottom-[20%] left-[15%] animate-spin-slow opacity-15 dark:opacity-5 text-pink-500 dark:text-pink-400",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                    className: "fa-solid fa-ice-cream text-7xl filter drop-shadow-md"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute bottom-[25%] right-[20%] animate-float opacity-15 dark:opacity-5 text-gray-600 dark:text-gray-400 rotate-[10deg]",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                    className: "fa-solid fa-utensils text-6xl filter drop-shadow-md"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "relative z-10 max-w-4xl mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "inline-flex items-center gap-2 bg-white/50 dark:bg-gray-800/50 backdrop-blur-md border border-gray-200 dark:border-gray-700 rounded-full px-5 py-2 mb-8 shadow-sm",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-location-dot text-orange-500"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-gray-700 dark:text-gray-200 font-medium tracking-wide text-sm",
                                        children: cityName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                className: "text-4xl md:text-6xl font-extrabold text-gray-900 dark:text-white mb-6 leading-tight tracking-tight",
                                children: [
                                    "Order food from ",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                        className: "hidden md:block"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500",
                                        children: "favourite restaurants"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                className: "text-gray-600 dark:text-gray-400 text-lg md:text-xl mb-10 max-w-2xl mx-auto",
                                children: [
                                    "Discover the best food & drinks in ",
                                    cityName,
                                    ". Fast delivery to your doorstep."
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center w-full max-w-2xl mx-auto bg-white dark:bg-gray-800 rounded-full shadow-xl shadow-orange-500/10 dark:shadow-none border border-gray-200 dark:border-gray-700 p-2 transition-all focus-within:ring-2 focus-within:ring-orange-500/50 focus-within:border-orange-500",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "pl-4 pr-3 text-gray-400 dark:text-gray-500",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                            className: "fa-solid fa-magnifying-glass text-lg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search for restaurants or cuisines...",
                                        value: searchText,
                                        onChange: (e)=>setSearchText(e.target.value),
                                        onKeyPress: handleKeyPress,
                                        className: "flex-1 bg-transparent text-gray-700 dark:text-gray-200 placeholder-gray-400 focus:placeholder-gray-300 outline-none text-base md:text-lg w-full"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: ()=>filterRestaurants(searchText, allRestaurants),
                                        className: "bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-full px-8 py-3 md:py-4 transition-all transform active:scale-95 shadow-lg shadow-orange-500/25 flex-shrink-0 whitespace-nowrap ml-2",
                                        children: "Search"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            foodCategories && foodCategories.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                className: "max-w-[1400px] mx-auto px-6 py-8",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center justify-between mb-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                className: "text-xl font-bold text-gray-900 dark:text-white",
                                children: "What's on your mind?"
                            }),
                            selectedCategory && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: ()=>{
                                    setSelectedCategory(null);
                                    setSearchResults(null);
                                    setErrorMessage("");
                                },
                                className: "flex items-center gap-2 text-sm text-orange-500 hover:text-orange-600 font-medium",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-xmark"
                                    }),
                                    "Clear filter"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "flex gap-4 overflow-x-auto pb-4 scrollbar-hide",
                        children: foodCategories.slice(0, 12).map((category)=>{
                            const isSelected = selectedCategory === category.action?.text;
                            return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                onClick: ()=>handleCategoryClick(category.action?.text),
                                className: "flex-shrink-0 text-center cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: `w-20 h-20 rounded-full overflow-hidden mb-2 ring-2 transition-all transform group-hover:scale-105 ${isSelected ? "ring-orange-500 ring-offset-2 scale-105" : "ring-transparent group-hover:ring-orange-400"}`,
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: (0, $03968f016876be30$export$3c67ec6258c4a827) + category.imageId,
                                            alt: category.action?.text,
                                            className: "w-full h-full object-cover"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: `text-xs font-medium transition-colors ${isSelected ? "text-orange-500" : "text-gray-700 dark:text-gray-300 group-hover:text-orange-500"}`,
                                        children: category.action?.text
                                    })
                                ]
                            }, category.id);
                        })
                    })
                ]
            }),
            topBrands && topBrands.length > 0 && !searchResults && !selectedCategory && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("section", {
                className: "w-full bg-white dark:bg-gray-900 py-10 border-y border-gray-100 dark:border-gray-800 transition-colors",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "max-w-[1400px] mx-auto px-6",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex items-center justify-between mb-6",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                            className: "text-2xl font-bold text-gray-900 dark:text-white mb-1",
                                            children: [
                                                "Top restaurant chains in ",
                                                cityName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-gray-500 dark:text-gray-400 text-sm",
                                            children: "Handpicked favorites just for you"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center justify-center text-gray-700 dark:text-gray-300 transition-colors border border-gray-200 dark:border-gray-700",
                                            onClick: ()=>{
                                                const container = document.getElementById("top-brands-scroll");
                                                if (container) container.scrollBy({
                                                    left: -320,
                                                    behavior: "smooth"
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                className: "fa-solid fa-chevron-left text-sm"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center justify-center text-gray-700 dark:text-gray-300 transition-colors border border-gray-200 dark:border-gray-700",
                                            onClick: ()=>{
                                                const container = document.getElementById("top-brands-scroll");
                                                if (container) container.scrollBy({
                                                    left: 320,
                                                    behavior: "smooth"
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                className: "fa-solid fa-chevron-right text-sm"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            id: "top-brands-scroll",
                            className: "flex gap-4 overflow-x-auto pb-2 scrollbar-hide scroll-smooth",
                            children: topBrands.map((restaurant, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                    to: `/restaurant/${restaurant?.info?.id}`,
                                    className: "flex-shrink-0 w-[calc(25%-12px)] min-w-[280px]",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $88c15ae016bd3d07$export$2e2bcd8739ae039), {
                                        restaurant: restaurant.info
                                    })
                                }, restaurant?.info?.id))
                        })
                    ]
                })
            }),
            errorMessage && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "text-center py-8 text-red-500 font-medium",
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                className: "max-w-[1400px] mx-auto px-6 py-12",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center justify-between mb-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                className: "text-2xl md:text-3xl font-bold text-gray-900 dark:text-white",
                                children: searchResults ? "Search Results" : `Restaurants with online food delivery in ${cityName}`
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                className: "text-gray-500 dark:text-gray-400",
                                children: [
                                    totalItems,
                                    " places"
                                ]
                            })
                        ]
                    }),
                    totalItems === 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "text-center py-16",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "text-6xl mb-4",
                                children: "\uD83C\uDF7D\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                className: "text-xl font-semibold text-gray-900 dark:text-white mb-2",
                                children: "No restaurants found"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-gray-500 dark:text-gray-400",
                                children: "Try a different search term"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6",
                                children: currentRestaurants.map((restaurant)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        to: `/restaurant/${restaurant?.info?.id}`,
                                        className: "block",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $88c15ae016bd3d07$export$2e2bcd8739ae039), {
                                            restaurant: restaurant.info
                                        })
                                    }, restaurant?.info?.id))
                            }),
                            totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center justify-center gap-2 mt-12",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                        onClick: ()=>goToPage(currentPage - 1),
                                        disabled: currentPage === 1,
                                        className: `flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${currentPage === 1 ? "text-gray-400 cursor-not-allowed dark:text-gray-600" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                className: "fa-solid fa-chevron-left text-sm"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "hidden sm:inline",
                                                children: "Previous"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "flex items-center gap-1",
                                        children: getPageNumbers().map((page, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                onClick: ()=>typeof page === "number" && goToPage(page),
                                                disabled: page === "...",
                                                className: `w-10 h-10 rounded-lg font-medium transition-colors ${page === currentPage ? "bg-orange-500 text-white" : page === "..." ? "text-gray-400 cursor-default" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                                children: page
                                            }, index))
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                        onClick: ()=>goToPage(currentPage + 1),
                                        disabled: currentPage === totalPages,
                                        className: `flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed dark:text-gray-600" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "hidden sm:inline",
                                                children: "Next"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                className: "fa-solid fa-chevron-right text-sm"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                className: "text-center text-gray-500 dark:text-gray-400 text-sm mt-4",
                                children: [
                                    "Showing ",
                                    startIndex + 1,
                                    "-",
                                    Math.min(endIndex, totalItems),
                                    " of ",
                                    totalItems,
                                    " restaurants"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $dbff80deb87e1ce5$export$2e2bcd8739ae039 = $dbff80deb87e1ce5$var$Body;




var $4Iuzv = parcelRequire("4Iuzv");




const $bb219b6b5d0eb685$var$ITEMS_PER_PAGE = 6;
const $bb219b6b5d0eb685$var$RestaurantMenu = ()=>{
    const { resId: resId } = (0, $175a2504a1bf07a5$export$99eaa27ddbbb95ef)();
    const navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    const [restaurant, setRestaurant] = (0, $4Iuzv.useState)(null);
    const [menuItems, setMenuItems] = (0, $4Iuzv.useState)([]);
    const [currentPage, setCurrentPage] = (0, $4Iuzv.useState)(1);
    const [addedItems, setAddedItems] = (0, $4Iuzv.useState)(new Set());
    const [loading, setLoading] = (0, $4Iuzv.useState)(true);
    const dispatch = (0, $060db65b89081276$export$8ad76b76a4c905f8)();
    (0, $4Iuzv.useEffect)(()=>{
        fetchRestaurantInfo();
    }, [
        resId
    ]);
    const addToCart = (item)=>{
        dispatch((0, $e80f118453286f03$export$fb9705de59d96855)(item));
        setAddedItems((prev)=>new Set(prev).add(item.id));
        setTimeout(()=>{
            setAddedItems((prev)=>{
                const newSet = new Set(prev);
                newSet.delete(item.id);
                return newSet;
            });
        }, 2000);
    };
    const fetchRestaurantInfo = async ()=>{
        if (!resId) return;
        setLoading(true);
        try {
            // Using CORS Proxy to bypass CORS issues with Swiggy API
            const swiggyMenuUrl = `https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&restaurantId=${resId}&submitAction=ENTER`;
            const proxyUrl = `https://corsproxy.io/?${encodeURIComponent(swiggyMenuUrl)}`;
            const response = await fetch(proxyUrl);
            const json = await response.json();
            const restaurantData = json?.data?.cards?.map((x)=>x.card)?.find((x)=>x && x.card["@type"] === (0, $03968f016876be30$export$4a3a00b9ff5cf3da))?.card?.info || null;
            setRestaurant(restaurantData);
            const menuItemsData = json?.data?.cards.find((x)=>x.groupedCard)?.groupedCard?.cardGroupMap?.REGULAR?.cards?.map((x)=>x.card?.card)?.filter((x)=>x["@type"] === (0, $03968f016876be30$export$138fdc351675302c))?.map((x)=>x.itemCards).flat().map((x)=>x.card?.info) || [];
            const uniqueMenuItems = [];
            menuItemsData.forEach((item)=>{
                if (item && !uniqueMenuItems.find((x)=>x.id === item.id)) uniqueMenuItems.push(item);
            });
            setMenuItems(uniqueMenuItems);
        } catch (error) {
            setMenuItems([]);
            setRestaurant(null);
            console.error(error);
        } finally{
            setLoading(false);
        }
    };
    const formatPrice = (price, defaultPrice)=>{
        const finalPrice = price || defaultPrice || 0;
        if (finalPrice > 0) return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR"
        }).format(finalPrice / 100);
        return "";
    };
    const getRatingColor = (rating)=>{
        if (!rating || rating === 0) return "bg-gray-400";
        if (rating >= 4) return "bg-green-500";
        if (rating >= 3) return "bg-yellow-500";
        return "bg-red-500";
    };
    // Pagination logic
    const totalItems = menuItems.length;
    const totalPages = Math.ceil(totalItems / $bb219b6b5d0eb685$var$ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * $bb219b6b5d0eb685$var$ITEMS_PER_PAGE;
    const endIndex = startIndex + $bb219b6b5d0eb685$var$ITEMS_PER_PAGE;
    const currentMenuItems = menuItems.slice(startIndex, endIndex);
    const goToPage = (page)=>{
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            const menuSection = document.getElementById("menu-section");
            if (menuSection) menuSection.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };
    const getPageNumbers = ()=>{
        const pages = [];
        if (totalPages <= 7) for(let i = 1; i <= totalPages; i++)pages.push(i);
        else {
            if (currentPage <= 4) pages.push(1, 2, 3, 4, 5, "...", totalPages);
            else if (currentPage >= totalPages - 3) pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            else pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
        }
        return pages;
    };
    if (loading) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "pt-16 min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center transition-colors duration-200",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500 mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                    className: "text-gray-500 dark:text-gray-400",
                    children: "Loading restaurant..."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "pt-16 min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "bg-white dark:bg-gray-900 border-b dark:border-gray-800 sticky top-16 z-40 transition-colors",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "max-w-4xl mx-auto px-6 py-3",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                        onClick: ()=>navigate("/"),
                        className: "flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                className: "fa-solid fa-arrow-left"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                children: "Back to restaurants"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "bg-white dark:bg-gradient-to-r dark:from-gray-900 dark:to-gray-800 text-gray-900 dark:text-white py-12 px-6 transition-colors shadow-sm dark:shadow-none",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                            src: (0, $03968f016876be30$export$3c67ec6258c4a827) + restaurant?.cloudinaryImageId,
                            alt: restaurant?.name,
                            className: "w-64 h-48 object-cover rounded-2xl shadow-2xl"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "text-center md:text-left flex-1",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                                    className: "text-3xl md:text-4xl font-bold mb-2",
                                    children: restaurant?.name
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-gray-500 dark:text-gray-300 mb-2",
                                    children: Array.isArray(restaurant?.cuisines) ? restaurant?.cuisines?.join(", ") : restaurant?.cuisines
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-gray-500 dark:text-gray-400 text-sm mb-4",
                                    children: restaurant?.areaName || restaurant?.locality
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                            className: `${getRatingColor(restaurant?.avgRating)} px-3 py-1 rounded-md font-semibold flex items-center gap-1`,
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                    className: "fa-solid fa-star text-xs"
                                                }),
                                                restaurant?.avgRating,
                                                restaurant?.totalRatingsString && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                    className: "text-white/90 ml-1",
                                                    children: [
                                                        "(",
                                                        restaurant.totalRatingsString,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                            className: "flex items-center gap-1 font-medium text-gray-700 dark:text-white",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                    className: "fa-solid fa-clock text-orange-500 dark:text-orange-400"
                                                }),
                                                restaurant?.sla?.slaString
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                            className: "flex items-center gap-1 font-medium text-gray-700 dark:text-white",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                    className: "fa-solid fa-indian-rupee-sign text-orange-500 dark:text-orange-400"
                                                }),
                                                restaurant?.costForTwoMessage || restaurant?.costForTwo
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                id: "menu-section",
                className: "max-w-4xl mx-auto px-6 py-12",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center justify-between mb-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900 dark:text-white",
                                        children: "Recommended"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                        className: "text-gray-500 dark:text-gray-400",
                                        children: [
                                            totalItems,
                                            " items"
                                        ]
                                    })
                                ]
                            }),
                            totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                className: "text-gray-500 dark:text-gray-400 text-sm",
                                children: [
                                    "Page ",
                                    currentPage,
                                    " of ",
                                    totalPages
                                ]
                            })
                        ]
                    }),
                    menuItems.length === 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "text-center py-16",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "text-6xl mb-4",
                                children: "\uD83C\uDF7D\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                className: "text-xl font-semibold text-gray-900 dark:text-white mb-2",
                                children: "No menu items available"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-gray-500 dark:text-gray-400",
                                children: "This restaurant's menu is currently unavailable"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "space-y-4",
                        children: currentMenuItems.map((item)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col md:flex-row justify-between gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-2 mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: `w-4 h-4 border-2 rounded-sm flex items-center justify-center ${item.isVeg === 1 ? "border-green-500" : "border-red-500"}`,
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: `w-2 h-2 rounded-full ${item.isVeg === 1 ? "bg-green-500" : "bg-red-500"}`
                                                        })
                                                    }),
                                                    item.ratings?.aggregatedRating?.rating && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                        className: "text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                                className: "fa-solid fa-star text-orange-400"
                                                            }),
                                                            item.ratings.aggregatedRating.rating,
                                                            item.ratings.aggregatedRating.ratingCount && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                                children: [
                                                                    "(",
                                                                    item.ratings.aggregatedRating.ratingCount,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                className: "text-lg font-semibold text-gray-900 dark:text-white mb-1",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "font-semibold text-orange-500 mb-2",
                                                children: formatPrice(item.price, item.defaultPrice)
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-gray-500 dark:text-gray-400 text-sm line-clamp-2",
                                                children: item.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex flex-col items-center gap-3",
                                        children: [
                                            item.imageId && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: (0, $03968f016876be30$export$3c5a5d8e1e203ce0) + item.imageId,
                                                alt: item.name,
                                                className: "w-28 h-24 object-cover rounded-xl"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                onClick: ()=>addToCart(item),
                                                className: `font-semibold px-8 py-2 rounded-lg transition-all duration-300 ${addedItems.has(item.id) ? "bg-green-500 text-white" : "bg-orange-500 hover:bg-orange-600 text-white"}`,
                                                children: addedItems.has(item.id) ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                                            className: "fa-solid fa-check mr-2"
                                                        }),
                                                        "Added"
                                                    ]
                                                }) : "ADD +"
                                            })
                                        ]
                                    })
                                ]
                            }, item.id))
                    }),
                    totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center justify-center gap-2 mt-12",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: ()=>goToPage(currentPage - 1),
                                disabled: currentPage === 1,
                                className: `flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${currentPage === 1 ? "text-gray-400 cursor-not-allowed dark:text-gray-600" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-chevron-left text-sm"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "hidden sm:inline",
                                        children: "Previous"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex items-center gap-1",
                                children: getPageNumbers().map((page, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: ()=>typeof page === "number" && goToPage(page),
                                        disabled: page === "...",
                                        className: `w-10 h-10 rounded-lg font-medium transition-colors ${page === currentPage ? "bg-orange-500 text-white" : page === "..." ? "text-gray-400 cursor-default" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                        children: page
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: ()=>goToPage(currentPage + 1),
                                disabled: currentPage === totalPages,
                                className: `flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed dark:text-gray-600" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "hidden sm:inline",
                                        children: "Next"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                                        className: "fa-solid fa-chevron-right text-sm"
                                    })
                                ]
                            })
                        ]
                    }),
                    totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                        className: "text-center text-gray-500 dark:text-gray-400 text-sm mt-4",
                        children: [
                            "Showing ",
                            startIndex + 1,
                            "-",
                            Math.min(endIndex, totalItems),
                            " of ",
                            totalItems,
                            " items"
                        ]
                    })
                ]
            })
        ]
    });
};
var $bb219b6b5d0eb685$export$2e2bcd8739ae039 = $bb219b6b5d0eb685$var$RestaurantMenu;



parcelRequire("4Iuzv");




const $ed8414b5ce1f1672$var$CartPage = ()=>{
    const cartItems = (0, $4003a0143258f2e3$export$2105062e25df4afe)((state)=>state.cart.items);
    const dispatch = (0, $060db65b89081276$export$8ad76b76a4c905f8)();
    const navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    const handleRemoveItem = (item)=>{
        dispatch((0, $e80f118453286f03$export$fe2d9b4e03920b4c)(item));
    };
    const handleClearCart = ()=>{
        dispatch((0, $e80f118453286f03$export$adee95e2d3d98b76)());
    };
    const handleGoBack = ()=>{
        navigate(-1);
    };
    const totalPrice = cartItems.reduce((sum, item)=>sum + (item.price || 0), 0);
    const formatPrice = (price)=>{
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR"
        }).format(price / 100);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "pt-16 min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "max-w-4xl mx-auto px-6 py-12",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                    onClick: handleGoBack,
                    className: "flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium mb-6 transition-colors",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("i", {
                            className: "fa-solid fa-arrow-left"
                        }),
                        "Back"
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex items-center justify-between mb-8",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                                    className: "text-3xl font-bold text-gray-900 dark:text-white",
                                    children: "Shopping Cart"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                    className: "text-gray-500 dark:text-gray-400",
                                    children: [
                                        cartItems.length,
                                        " items"
                                    ]
                                })
                            ]
                        }),
                        cartItems.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                            onClick: handleClearCart,
                            className: "text-red-500 hover:text-red-600 font-medium transition-colors",
                            children: "Clear Cart"
                        })
                    ]
                }),
                cartItems.length === 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "text-center py-16",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "text-6xl mb-4",
                            children: "\uD83D\uDED2"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                            className: "text-xl font-semibold text-gray-900 dark:text-white mb-2",
                            children: "Your cart is empty"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                            className: "text-gray-500 dark:text-gray-400",
                            children: "Add some delicious items from our restaurants!"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "bg-white dark:bg-gray-800 rounded-2xl shadow-sm overflow-hidden transition-colors",
                    children: [
                        cartItems.map((item, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center justify-between p-6 border-b border-gray-100 dark:border-gray-700 last:border-0",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            item.imageId && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: (0, $03968f016876be30$export$3c5a5d8e1e203ce0) + item.imageId,
                                                alt: item.name,
                                                className: "w-20 h-16 object-cover rounded-lg"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                        className: "font-semibold text-gray-900 dark:text-white",
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                        className: "text-orange-500 font-medium",
                                                        children: formatPrice(item.price)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: ()=>handleRemoveItem(item),
                                        className: "text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 px-4 py-2 rounded-lg font-medium transition-colors",
                                        children: "Remove"
                                    })
                                ]
                            }, `${item.id}-${index}`)),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "p-6 bg-gray-50 dark:bg-gray-900/50 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                    className: "text-lg font-semibold text-gray-900 dark:text-white",
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                    className: "text-2xl font-bold text-orange-500",
                                    children: formatPrice(totalPrice)
                                })
                            ]
                        })
                    ]
                }),
                cartItems.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                    className: "w-full mt-6 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-4 rounded-xl transition-colors",
                    children: "Proceed to Checkout"
                })
            ]
        })
    });
};
var $ed8414b5ce1f1672$export$2e2bcd8739ae039 = $ed8414b5ce1f1672$var$CartPage;



parcelRequire("4Iuzv");

const $dcfd14e51183d73c$var$Error = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-6 text-center transition-colors",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "text-8xl mb-6",
                children: "\uD83D\uDE35"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                className: "text-4xl font-bold text-gray-900 dark:text-white mb-4",
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                className: "text-xl text-gray-500 dark:text-gray-400 mb-8",
                children: "Something went wrong. The page you're looking for doesn't exist."
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-8 rounded-full transition-colors",
                children: "Go Back Home"
            })
        ]
    });
};
var $dcfd14e51183d73c$export$2e2bcd8739ae039 = $dcfd14e51183d73c$var$Error;


const $de193658e9587177$var$AppLayout = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0e894410288988cc$export$2e2bcd8739ae039), {
        store: (0, $be0d9339cbb41c1b$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a2c194671e8c1390$export$d8964aec282183a3), {
            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-200",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2e19991f285c915e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $175a2504a1bf07a5$export$910ae8079b2c2852), {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $18897fd3e64934ab$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
const $de193658e9587177$var$appRouter = (0, $c34e9f2261c19895$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($de193658e9587177$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $dcfd14e51183d73c$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $dbff80deb87e1ce5$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurant/:resId",
                element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $bb219b6b5d0eb685$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ed8414b5ce1f1672$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
const $de193658e9587177$var$rootElement = document.getElementById("root");
if ($de193658e9587177$var$rootElement) {
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($21fa618cfc67d6ae$exports))).createRoot($de193658e9587177$var$rootElement);
    root.render(/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $175a2504a1bf07a5$export$323e4fc2fa4753fb), {
        router: $de193658e9587177$var$appRouter
    }));
}


//# sourceMappingURL=index.c9e187d5.js.map
